import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  ISO8601DateTime: string;
  JSON: any;
};

export enum AdminReservationOrderField {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  PeopleCount = 'PEOPLE_COUNT'
}

export type AdminReservationsOrderBy = {
  direction: OrderDirection;
  field: AdminReservationOrderField;
};

export enum AdminVoucherSalesOrder {
  Recent = 'RECENT'
}

export type Agreement = {
  __typename?: 'Agreement';
  currentTenant: Scalars['String'];
  festivalEditionRestaurant: FestivalEditionRestaurant;
  id: Scalars['ID'];
  metadatas: Array<Metadata>;
  restaurant: Reservable;
  title: Scalars['String'];
  type: DocumentTypeEnum;
};

/** Autogenerated return type of AppleSignIn */
export type AppleSignInPayload = {
  __typename?: 'AppleSignInPayload';
  authToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type Area = {
  point: Point;
  /** area radius in kilometers */
  radius: Scalars['Float'];
};

/** The connection type for ImageFile. */
export type Attachments = {
  __typename?: 'Attachments';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AttachmentsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ImageFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AttachmentsEdge = {
  __typename?: 'AttachmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ImageFile>;
};

export type Banner = {
  __typename?: 'Banner';
  alt: Scalars['String'];
  category: Scalars['ISO8601DateTime'];
  country: Country;
  countryCode: Scalars['String'];
  countryId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  files: Scalars['JSON'];
  href?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  pageDetail?: Maybe<PageDetail>;
  pageDetailId?: Maybe<Scalars['ID']>;
  position: Scalars['Int'];
  region?: Maybe<Region>;
  regionId?: Maybe<Scalars['ID']>;
  section?: Maybe<Section>;
  sectionId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['ISO8601DateTime'];
  validFrom: Scalars['ISO8601DateTime'];
  validTo?: Maybe<Scalars['ISO8601DateTime']>;
  visible: Scalars['Boolean'];
};

/** An edge in a connection. */
export type BannerEdge = {
  __typename?: 'BannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Banner>;
};

/** The connection type for Banner. */
export type Banners = {
  __typename?: 'Banners';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BannerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Banner>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BillingDataChanges = {
  __typename?: 'BillingDataChanges';
  bankAccountNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyType?: Maybe<CompanyTypeEnum>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  currentTenant: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  representName?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
};

/** Reservations which can be returned for book */
export type BookReservation = ManualReservation | Reservation;

export type CalendarRevision = {
  __typename?: 'CalendarRevision';
  createdAt: Scalars['Date'];
  currentTenant: Scalars['String'];
  endsOn: Scalars['Date'];
  id: Scalars['ID'];
  restaurant: Restaurant;
  startsOn: Scalars['Date'];
  updatedAt: Scalars['Date'];
  user?: Maybe<User>;
};

export type Card = {
  __typename?: 'Card';
  brand: Scalars['String'];
  canBeDestroyed: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  default: Scalars['Boolean'];
  expiryDate: Scalars['Date'];
  id: Scalars['ID'];
  last4Digits: Scalars['String'];
  name: Scalars['String'];
  requestId: Scalars['String'];
  user: User;
};

export enum CardTransactionTypeEnum {
  Multi = 'MULTI',
  Oneclick = 'ONECLICK',
  Oneshot = 'ONESHOT',
  Single = 'SINGLE',
  SingleLongterm = 'SINGLE_LONGTERM'
}

export type ClientConfig = {
  __typename?: 'ClientConfig';
  currentTenant: Scalars['String'];
  d2dDefaultReservableFrom: Scalars['ISO8601DateTime'];
  d2dReservableFrom: Scalars['ISO8601DateTime'];
  mgmEnabled: Scalars['Boolean'];
  reservableExtraDefaultReservableFrom: Scalars['ISO8601DateTime'];
  reservableExtraReservableFrom: Scalars['ISO8601DateTime'];
};

export type Collection = {
  __typename?: 'Collection';
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  restaurants: Array<Restaurant>;
};


export type CollectionImageUrlArgs = {
  version?: InputMaybe<ImageVersionEnum>;
};

export enum CollectionCategoryEnum {
  Festivaleditionrestaurant = 'FESTIVALEDITIONRESTAURANT',
  Reservableextra = 'RESERVABLEEXTRA',
  Restaurant = 'RESTAURANT'
}

/** An edge in a connection. */
export type CollectionEdge = {
  __typename?: 'CollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PolymorphicCollection>;
};

export type CollectionElement = {
  __typename?: 'CollectionElement';
  currentTenant: Scalars['String'];
  elementId: Scalars['ID'];
  elementType: Scalars['String'];
  imageFiles: Array<ImageFile>;
};

/** The connection type for PolymorphicCollection. */
export type Collections = {
  __typename?: 'Collections';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CollectionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PolymorphicCollection>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Company = {
  __typename?: 'Company';
  currentTenant: Scalars['String'];
  description: Scalars['String'];
  slug: Scalars['String'];
  value: Scalars['String'];
};

export enum CompanyTypeEnum {
  /** Spółdzielnia */
  Cooperative = 'COOPERATIVE',
  /** Spółka akcyjna */
  JointStockCompany = 'JOINT_STOCK_COMPANY',
  /** Spółka komandytowo-akcyjna */
  LimitedJointStockPartnership = 'LIMITED_JOINT_STOCK_PARTNERSHIP',
  /** Spółka z o.o-komandytowa */
  LimitedLiabilityPartnership = 'LIMITED_LIABILITY_PARTNERSHIP',
  /** Spółka komandytowa */
  LimitedPartnership = 'LIMITED_PARTNERSHIP',
  /** Spółka cywilna */
  Partnership = 'PARTNERSHIP',
  /** Osoba fizyczna prowadząca działalność gosp. */
  Person = 'PERSON',
  /** Spółka z o.o. */
  PrivateLimitedCompany = 'PRIVATE_LIMITED_COMPANY',
  /** Spółka jawna */
  PublicCompany = 'PUBLIC_COMPANY'
}

/** Autogenerated return type of ConfirmUser */
export type ConfirmUserPayload = {
  __typename?: 'ConfirmUserPayload';
  authToken: Scalars['String'];
  user: User;
};

export type CookieRegion = {
  __typename?: 'CookieRegion';
  id: Scalars['String'];
  isProposed: Scalars['Boolean'];
  name: Scalars['String'];
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String'];
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
  nativeName: Scalars['String'];
};

/** Autogenerated return type of CreateGuest */
export type CreateGuestPayload = {
  __typename?: 'CreateGuestPayload';
  authToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type CreateOrderResponse = {
  __typename?: 'CreateOrderResponse';
  currentTenant: Scalars['String'];
  orderId: Scalars['String'];
  redirectUri: Scalars['String'];
  status: Scalars['String'];
};

/** Autogenerated return type of CreateUser */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  authToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type CropData = {
  __typename?: 'CropData';
  baseHeight?: Maybe<Scalars['Float']>;
  baseWidth?: Maybe<Scalars['Float']>;
  currentTenant: Scalars['String'];
  height: Scalars['Float'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type CrossSell = {
  __typename?: 'CrossSell';
  adult: Scalars['Boolean'];
  categorySlug?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  dailies: Array<Daily>;
  description: Scalars['String'];
  extraDescription?: Maybe<Scalars['String']>;
  festivalDrink: Scalars['Boolean'];
  festivalEditionRestaurants: Array<FestivalEditionRestaurant>;
  fill: Scalars['Boolean'];
  forced: Scalars['Boolean'];
  id: Scalars['ID'];
  image?: Maybe<ImageFile>;
  internal: Scalars['Boolean'];
  name: Scalars['String'];
  /** Limited to people count on reservation */
  peopleCountLimited: Scalars['Boolean'];
  position: Scalars['Int'];
  price: Scalars['Float'];
  quantityLimitedToOne: Scalars['Boolean'];
};

export type CrossSellData = {
  __typename?: 'CrossSellData';
  crossSell: CrossSell;
  currentTenant: Scalars['String'];
  soldCount: Scalars['Int'];
};

export enum CrossSellOrderField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

/** The connection type for CrossSell. */
export type CrossSells = {
  __typename?: 'CrossSells';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CrossSellsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CrossSell>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CrossSellsEdge = {
  __typename?: 'CrossSellsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CrossSell>;
};

export type CrossSellsList = {
  crossSellId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type CrossSellsOrderBy = {
  direction: OrderDirection;
  field: CrossSellOrderField;
};

export type Daily = {
  __typename?: 'Daily';
  allCrossSells: Array<CrossSell>;
  availableReservationTypes: Array<ReservationTypeEnum>;
  breakAfterReservation: Scalars['Int'];
  code: Scalars['String'];
  crossSells: Array<CrossSell>;
  currentTenant: Scalars['String'];
  dailyCrossSells: Array<DailyCrossSell>;
  defaultReservableFrom: Scalars['ISO8601DateTime'];
  defaultReservationType: ReservationTypeEnum;
  enabled: Scalars['Boolean'];
  endsAt: Scalars['Date'];
  id: Scalars['ID'];
  maxPeopleCount: Scalars['Int'];
  menus: Array<Menu>;
  menusPerPerson: Scalars['Int'];
  metadatas: Array<Metadata>;
  minPeopleCount: Scalars['Int'];
  name: Scalars['String'];
  possibleSlots?: Maybe<Array<Scalars['Int']>>;
  price: Scalars['Float'];
  resExtraSlotAvailabilityTimeLimitInMinutes: Scalars['Int'];
  reservableFrom: Scalars['ISO8601DateTime'];
  restaurant: Restaurant;
  rulesEditable: Scalars['Boolean'];
  slotAvailabilityTimeLimitInMinutes: Scalars['Int'];
  slotDefinitions?: Maybe<Array<SlotDefinition>>;
  slotDuration: Scalars['Int'];
  startsAt: Scalars['Date'];
};

export type DailyCrossSell = {
  __typename?: 'DailyCrossSell';
  crossSell: CrossSell;
  currentTenant: Scalars['String'];
  daily: Daily;
  enabled: Scalars['Boolean'];
};

export type DateRange = {
  endsOn: Scalars['Date'];
  startsOn: Scalars['Date'];
};

export type DecodedRestaurant = {
  __typename?: 'DecodedRestaurant';
  currentTenant: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  sourceId?: Maybe<Scalars['Int']>;
};

export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  city?: Maybe<Scalars['String']>;
  currentTenant: Scalars['String'];
  distance?: Maybe<Scalars['Int']>;
  flatNo?: Maybe<Scalars['String']>;
  houseNo?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type DeliveryAddressInput = {
  city: Scalars['String'];
  flatNo?: InputMaybe<Scalars['String']>;
  houseNo: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  street: Scalars['String'];
  zipCode: Scalars['String'];
};

export type DiscountAssignment = {
  __typename?: 'DiscountAssignment';
  currentTenant: Scalars['String'];
  discountable?: Maybe<Discountable>;
  discountableId?: Maybe<Scalars['ID']>;
  discountableType: DiscountableTypeEnum;
};

export enum DiscountBillingMethodEnum {
  Barter = 'BARTER',
  Free = 'FREE',
  NoInfo = 'NO_INFO',
  Paid = 'PAID'
}

export enum DiscountCategoryEnum {
  CentralCampaign = 'CENTRAL_CAMPAIGN',
  ContractPartners = 'CONTRACT_PARTNERS',
  CrmInternal = 'CRM_INTERNAL',
  CrmInternalBase = 'CRM_INTERNAL_BASE',
  Cross = 'CROSS',
  Employee = 'EMPLOYEE',
  Influ = 'INFLU',
  MarketingPartners = 'MARKETING_PARTNERS',
  NewBiz = 'NEW_BIZ',
  NoInfo = 'NO_INFO',
  PurchasedPartners = 'PURCHASED_PARTNERS',
  RcApp = 'RC_APP',
  RegionalCampaign = 'REGIONAL_CAMPAIGN',
  RelationalPartners = 'RELATIONAL_PARTNERS',
  Restaurant = 'RESTAURANT',
  RestaurantProfiles = 'RESTAURANT_PROFILES',
  StComplaints = 'ST_COMPLAINTS',
  StTechnical = 'ST_TECHNICAL',
  WrPurchase = 'WR_PURCHASE'
}

export enum DiscountOrder {
  Recent = 'RECENT'
}

export enum DiscountTypes {
  All = 'ALL',
  PeopleCount = 'PEOPLE_COUNT',
  Percent = 'PERCENT',
  Total = 'TOTAL'
}

export type Discountable = Event | FestivalEdition;

export enum DiscountableTypeEnum {
  Event = 'EVENT',
  FestivalEdition = 'FESTIVAL_EDITION',
  ReservableExtra = 'RESERVABLE_EXTRA'
}

/** The connection type for Redeemable. */
export type Discounts = {
  __typename?: 'Discounts';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DiscountsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Redeemable>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DiscountsEdge = {
  __typename?: 'DiscountsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Redeemable>;
};

export type Document = {
  __typename?: 'Document';
  currentTenant: Scalars['String'];
  festivalEdition?: Maybe<FestivalEdition>;
  id: Scalars['ID'];
  richText: Scalars['String'];
  title: Scalars['String'];
  type: DocumentTypeEnum;
};

export enum DocumentTypeEnum {
  AgreementTemplate = 'AGREEMENT_TEMPLATE',
  ClubAgreementTemplate = 'CLUB_AGREEMENT_TEMPLATE',
  MainRegulation = 'MAIN_REGULATION',
  OtherRegulation = 'OTHER_REGULATION',
  PrivacyPolicy = 'PRIVACY_POLICY',
  Regulation = 'REGULATION'
}

/** The connection type for Document. */
export type Documents = {
  __typename?: 'Documents';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DocumentsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Document>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DocumentsEdge = {
  __typename?: 'DocumentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Document>;
};

export type Event = {
  __typename?: 'Event';
  address: Scalars['String'];
  availableReservationTypes: Array<ReservationTypeEnum>;
  code: Scalars['String'];
  currentTenant: Scalars['String'];
  defaultReservableFrom: Scalars['ISO8601DateTime'];
  defaultReservationType: ReservationTypeEnum;
  description: Scalars['String'];
  endsAt: Scalars['ISO8601DateTime'];
  external: Scalars['Boolean'];
  externalUrl?: Maybe<Scalars['String']>;
  global?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  imageFiles: Array<ImageFile>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  maxMenusAmount: Scalars['Int'];
  maxPeopleCount: Scalars['Int'];
  menus?: Maybe<Array<Menu>>;
  menusPerPerson: Scalars['Int'];
  metadatas: Array<Metadata>;
  minMenusAmount: Scalars['Int'];
  minPeopleCount: Scalars['Int'];
  position: Scalars['Int'];
  price: Scalars['Float'];
  region?: Maybe<Region>;
  reservableFrom: Scalars['ISO8601DateTime'];
  reservationFeeUnitPrice: Scalars['Float'];
  restaurant?: Maybe<Restaurant>;
  rulesEditable: Scalars['Boolean'];
  slotless: Scalars['Boolean'];
  slots?: Maybe<Array<SlotDefinition>>;
  startsAt: Scalars['ISO8601DateTime'];
  title: Scalars['String'];
};

export enum EventOrder {
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  Recent = 'RECENT',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC'
}

/** The connection type for Event. */
export type Events = {
  __typename?: 'Events';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Event>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EventsEdge = {
  __typename?: 'EventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Event>;
};

/** Autogenerated return type of FacebookSignIn */
export type FacebookSignInPayload = {
  __typename?: 'FacebookSignInPayload';
  authToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type Favorite = {
  __typename?: 'Favorite';
  currentTenant: Scalars['String'];
  restaurant: Restaurant;
  user: User;
};

export type Festival = {
  __typename?: 'Festival';
  about: Scalars['String'];
  attendeesCount: Scalars['Int'];
  code: Scalars['String'];
  currentTenant: Scalars['String'];
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  image?: Maybe<ImageFile>;
  logo?: Maybe<ImageFile>;
  metadatas: Array<Metadata>;
  name: Scalars['String'];
  reservationClosingRule: ReservationClosingRule;
  shortDescription: Scalars['String'];
  slogan: Scalars['String'];
  slug: Scalars['String'];
  url: Scalars['String'];
};

export enum FestivalCodesEnum {
  Bfw = 'bfw',
  Bw = 'bw',
  Cc = 'cc',
  Cf = 'cf',
  Chm = 'chm',
  Dw = 'dw',
  Fdw = 'fdw',
  Gw = 'gw',
  Korw = 'korw',
  Neon = 'neon',
  Pw = 'pw',
  Rctjz = 'rctjz',
  Rw = 'rw',
  Rwx = 'rwx'
}

export type FestivalEdition = {
  __typename?: 'FestivalEdition';
  agreementTemplate?: Maybe<Document>;
  allDaySlots: Scalars['Boolean'];
  availableReservationTypes: Array<ReservationTypeEnum>;
  code: Scalars['String'];
  crossSellAssignments: Array<FestivalEditionCrossSell>;
  crossSells: Array<CrossSell>;
  currentTenant: Scalars['String'];
  defaultReservableFrom: Scalars['ISO8601DateTime'];
  defaultReservationType: ReservationTypeEnum;
  enabled: Scalars['Boolean'];
  endsAt: Scalars['ISO8601DateTime'];
  externalSale: Scalars['Boolean'];
  features: Array<FestivalEditionFeaturesTypeEnum>;
  festival: Festival;
  festivalDrinkSaleForced: FestivalEditionDrinkSaleEnum;
  /** List of festival edition restaurants */
  festivalEditionRestaurants: FestivalEditionRestaurants;
  forceLabels: Scalars['Boolean'];
  hidden?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use slots attribute to get hours */
  hours: Array<Scalars['String']>;
  id: Scalars['ID'];
  inventoryItemAssignments: Array<FestivalEditionInventoryItem>;
  inventoryItems: Array<InventoryItem>;
  maxMenusAmount: Scalars['Int'];
  maxPeopleCount: Scalars['Int'];
  menuPositions: Array<FestivalEditionMenuPosition>;
  menusPerPerson: Scalars['Int'];
  metadatas: Array<Metadata>;
  minMenusAmount: Scalars['Int'];
  minPeopleCount: Scalars['Int'];
  overridableTagTypes: Array<OverridableTagTypeEnum>;
  presaleStartsAt: Scalars['ISO8601DateTime'];
  price: Scalars['Float'];
  regulation?: Maybe<Document>;
  /** @deprecated Only one regulation per festival - use regualation attribute */
  regulations: Array<Document>;
  reservableFrom: Scalars['ISO8601DateTime'];
  reservationFeeUnitPrice: Scalars['Float'];
  reservationStartsAt: Scalars['ISO8601DateTime'];
  reservationsCancellable: Scalars['Boolean'];
  reservationsEditable: Scalars['Boolean'];
  slotDuration: Scalars['Int'];
  slots?: Maybe<Array<SlotDefinition>>;
  sponsors: Array<Sponsor>;
  startsAt: Scalars['ISO8601DateTime'];
  state: FestivalStateEnum;
  submission?: Maybe<Submission>;
  voucher: Scalars['Boolean'];
  voucherTemplateFile?: Maybe<ImageFile>;
};


export type FestivalEditionFestivalEditionRestaurantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  festival_edition_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  price_from?: InputMaybe<Scalars['Int']>;
  price_to?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  reservation_filters?: InputMaybe<ReservationFilter>;
  restaurant_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sort?: InputMaybe<FestivalEditionRestaurantSort>;
  tag_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags?: InputMaybe<Array<InputMaybe<TagFilter>>>;
  zone_id?: InputMaybe<Scalars['ID']>;
};

export type FestivalEditionCrossSell = {
  __typename?: 'FestivalEditionCrossSell';
  crossSell: CrossSell;
  currentTenant: Scalars['String'];
  enabledRegions: Array<Region>;
  ferAutoFilled: Scalars['Boolean'];
};

export type FestivalEditionData = {
  __typename?: 'FestivalEditionData';
  crossSellData: Array<CrossSellData>;
  currentTenant: Scalars['String'];
  festivalEdition: FestivalEdition;
  incomeData: IncomeData;
  peopleData: Array<PeopleData>;
  reservationsData: Array<ReservationsData>;
  restaurant?: Maybe<Restaurant>;
  seatsData: SeatsData;
  slotsData: Array<SlotsData>;
  usersData: UsersData;
};

export enum FestivalEditionDrinkSaleEnum {
  GuestCount = 'GUEST_COUNT',
  None = 'NONE',
  One = 'ONE'
}

/** An edge in a connection. */
export type FestivalEditionEdge = {
  __typename?: 'FestivalEditionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<FestivalEdition>;
};

export enum FestivalEditionFeaturesTypeEnum {
  FollowUpSurvey = 'FOLLOW_UP_SURVEY',
  LastGuestFree = 'LAST_GUEST_FREE'
}

export type FestivalEditionInventoryItem = {
  __typename?: 'FestivalEditionInventoryItem';
  currentTenant: Scalars['String'];
  festivalEdition: FestivalEdition;
  id: Scalars['ID'];
  inventoryItem: InventoryItem;
  priceRequired: Scalars['Boolean'];
  quantityRequired: Scalars['Boolean'];
};

export type FestivalEditionMenuPosition = {
  __typename?: 'FestivalEditionMenuPosition';
  currentTenant: Scalars['String'];
  label: Scalars['String'];
  required: Scalars['Boolean'];
};

export enum FestivalEditionOrderField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

export type FestivalEditionRestaurant = {
  __typename?: 'FestivalEditionRestaurant';
  agreement?: Maybe<Agreement>;
  allDaySlots: Scalars['Boolean'];
  availableCrossSells: Array<CrossSell>;
  availableReservationTypes: Array<ReservationTypeEnum>;
  crossSellAssignments: Array<FestivalEditionRestaurantCrossSell>;
  crossSells: Array<CrossSell>;
  currentTenant: Scalars['String'];
  defaultReservableFrom: Scalars['ISO8601DateTime'];
  defaultReservationType: ReservationTypeEnum;
  draft?: Maybe<Scalars['Boolean']>;
  externalSaleUrl?: Maybe<Scalars['String']>;
  ferInventoryItems: Array<FestivalEditionRestaurantInventoryItem>;
  festivalEdition: FestivalEdition;
  forceAgreement: Scalars['Boolean'];
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  imageFiles: Array<ImageFile>;
  incomingChanges?: Maybe<FestivalEditionRestaurantChanges>;
  labelA?: Maybe<Scalars['String']>;
  labelB?: Maybe<Scalars['String']>;
  menus?: Maybe<Array<Menu>>;
  menusAmountChangeable: Scalars['Boolean'];
  menusCount: Scalars['Int'];
  menusPerPerson: Scalars['Int'];
  metadatas: Array<Metadata>;
  notes?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  price: Scalars['Float'];
  reservableFrom: Scalars['ISO8601DateTime'];
  restaurant: Restaurant;
  rulesEditable: Scalars['Boolean'];
  rulesLocked: Scalars['Boolean'];
  sellableCrossSells: Array<CrossSell>;
  signed: Scalars['Boolean'];
  status: StatusableEnum;
  submission?: Maybe<Submission>;
  tags: Array<Tag>;
};


export type FestivalEditionRestaurantImageFilesArgs = {
  scope?: InputMaybe<FestivalEditionRestaurantImageScopesEnum>;
};

export type FestivalEditionRestaurantChanges = {
  __typename?: 'FestivalEditionRestaurantChanges';
  crossSellAssignments?: Maybe<Array<FestivalEditionRestaurantCrossSell>>;
  crossSellIds?: Maybe<Array<Scalars['ID']>>;
  currentTenant: Scalars['String'];
  ferInventoryItems?: Maybe<Array<FestivalEditionRestaurantInventoryItem>>;
  imageFiles?: Maybe<Array<ImageFile>>;
  labelA?: Maybe<Scalars['String']>;
  labelB?: Maybe<Scalars['String']>;
  menus?: Maybe<Array<Menu>>;
  notes?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['ID']>>;
};

export type FestivalEditionRestaurantCrossSell = {
  __typename?: 'FestivalEditionRestaurantCrossSell';
  createdAt: Scalars['ISO8601DateTime'];
  crossSellId?: Maybe<Scalars['ID']>;
  currentTenant: Scalars['String'];
  festivalEditionCrossSell?: Maybe<FestivalEditionCrossSell>;
  festivalEditionRestaurant: FestivalEditionRestaurant;
  saleEnabled: Scalars['Boolean'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** An edge in a connection. */
export type FestivalEditionRestaurantEdge = {
  __typename?: 'FestivalEditionRestaurantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<FestivalEditionRestaurant>;
};

export enum FestivalEditionRestaurantImageScopesEnum {
  FerOnly = 'FER_ONLY',
  WithRestaurant = 'WITH_RESTAURANT'
}

export type FestivalEditionRestaurantInventoryItem = {
  __typename?: 'FestivalEditionRestaurantInventoryItem';
  currentTenant: Scalars['String'];
  festivalEditionInventoryItem: FestivalEditionInventoryItem;
  festivalEditionRestaurant: FestivalEditionRestaurant;
  inventoryItem: InventoryItem;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
};

export enum FestivalEditionRestaurantSort {
  Position = 'POSITION'
}

/** The connection type for FestivalEditionRestaurant. */
export type FestivalEditionRestaurants = {
  __typename?: 'FestivalEditionRestaurants';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FestivalEditionRestaurantEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FestivalEditionRestaurant>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** The connection type for FestivalEdition. */
export type FestivalEditions = {
  __typename?: 'FestivalEditions';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FestivalEditionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FestivalEdition>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type FestivalEditionsOrderBy = {
  direction: OrderDirection;
  field: FestivalEditionOrderField;
};

export enum FestivalOrderField {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME'
}

export enum FestivalStateEnum {
  Incoming = 'INCOMING',
  Presale = 'PRESALE',
  Sale = 'SALE',
  Unavailable = 'UNAVAILABLE',
  Voucher = 'VOUCHER'
}

export enum FestivalTimingEnum {
  Current = 'CURRENT',
  CurrentOrFuture = 'CURRENT_OR_FUTURE',
  Future = 'FUTURE',
  Past = 'PAST'
}

export type FestivalsOrderBy = {
  direction: OrderDirection;
  field: FestivalOrderField;
};

/** Autogenerated return type of GoogleSignIn */
export type GoogleSignInPayload = {
  __typename?: 'GoogleSignInPayload';
  authToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type HourRange = {
  __typename?: 'HourRange';
  currentTenant: Scalars['String'];
  discount: Scalars['Int'];
  endsAt: Scalars['Int'];
  startsAt: Scalars['Int'];
  totalAllocation: Scalars['Int'];
};

export type Hours = {
  __typename?: 'Hours';
  currentTenant: Scalars['String'];
  day: Scalars['String'];
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type ImageFile = {
  __typename?: 'ImageFile';
  attachable?: Maybe<Restaurant>;
  createdAt: Scalars['Date'];
  cropData?: Maybe<CropData>;
  currentTenant: Scalars['String'];
  /** @deprecated You should get it directly */
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  original?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  preview?: Maybe<Scalars['String']>;
  profile?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};


export type ImageFileFileUrlArgs = {
  version?: InputMaybe<ImageVersionEnum>;
};

export enum ImageVersionEnum {
  Original = 'ORIGINAL',
  Preview = 'PREVIEW',
  Profile = 'PROFILE',
  Thumbnail = 'THUMBNAIL'
}

export type IncomeData = {
  __typename?: 'IncomeData';
  crossSellsIncome: Scalars['Float'];
  currentTenant: Scalars['String'];
  overallIncome: Scalars['Float'];
  ticketsIncome: Scalars['Float'];
};

export type InventoryItem = {
  __typename?: 'InventoryItem';
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<ImageFile>;
  name: Scalars['String'];
};

/** The connection type for InventoryItem. */
export type InventoryItems = {
  __typename?: 'InventoryItems';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InventoryItemsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InventoryItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type InventoryItemsEdge = {
  __typename?: 'InventoryItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<InventoryItem>;
};

export type KlarnaOrder = {
  __typename?: 'KlarnaOrder';
  currentTenant: Scalars['String'];
  fraudStatus?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  payload: Scalars['JSON'];
  redirectUrl: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type Like = {
  __typename?: 'Like';
  currentTenant: Scalars['String'];
  review: Review;
  user: User;
};

export enum LocaleEnum {
  Cs = 'cs',
  De = 'de',
  En = 'en',
  Pl = 'pl'
}

export type ManualReservation = {
  __typename?: 'ManualReservation';
  attachmentFile?: Maybe<ImageFile>;
  code: Scalars['String'];
  confirmed: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  date: Scalars['Date'];
  email?: Maybe<Scalars['String']>;
  guestNotes?: Maybe<Scalars['String']>;
  hall?: Maybe<Scalars['String']>;
  hour: Scalars['String'];
  id: Scalars['ID'];
  peopleCount: Scalars['Int'];
  phoneCountryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
  restaurant: Restaurant;
  restauratorNotes?: Maybe<Scalars['String']>;
  slot: Scalars['Int'];
  slotDuration: Scalars['Int'];
  /** @deprecated Use slot attribute */
  slotVariant?: Maybe<Scalars['Int']>;
  status: ManualReservationStatusEnum;
  table?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  vatId?: Maybe<Scalars['String']>;
};

export enum ManualReservationStatusEnum {
  Arrived = 'ARRIVED',
  Canceled = 'CANCELED',
  Finished = 'FINISHED',
  NoShow = 'NO_SHOW',
  Pending = 'PENDING'
}

export type Menu = {
  __typename?: 'Menu';
  currentTenant: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  imageFile?: Maybe<ImageFile>;
  label: Scalars['String'];
  position: Scalars['Int'];
  positions: Array<MenuPosition>;
  positionsCount: Scalars['Int'];
  tags: Array<Tag>;
};

export enum MenuKindEnum {
  A = 'A',
  Ab = 'AB',
  Abc = 'ABC',
  Abcd = 'ABCD',
  Abcde = 'ABCDE',
  Abcdef = 'ABCDEF',
  Abcdefg = 'ABCDEFG',
  Abcdefgh = 'ABCDEFGH',
  Abcdefh = 'ABCDEFH',
  Abcdeg = 'ABCDEG',
  Abcdegh = 'ABCDEGH',
  Abcdeh = 'ABCDEH',
  Abcdf = 'ABCDF',
  Abcdfg = 'ABCDFG',
  Abcdfgh = 'ABCDFGH',
  Abcdfh = 'ABCDFH',
  Abcdg = 'ABCDG',
  Abcdgh = 'ABCDGH',
  Abcdh = 'ABCDH',
  Abce = 'ABCE',
  Abcef = 'ABCEF',
  Abcefg = 'ABCEFG',
  Abcefgh = 'ABCEFGH',
  Abcefh = 'ABCEFH',
  Abceg = 'ABCEG',
  Abcegh = 'ABCEGH',
  Abceh = 'ABCEH',
  Abcf = 'ABCF',
  Abcfg = 'ABCFG',
  Abcfgh = 'ABCFGH',
  Abcfh = 'ABCFH',
  Abcg = 'ABCG',
  Abcgh = 'ABCGH',
  Abch = 'ABCH',
  Abd = 'ABD',
  Abde = 'ABDE',
  Abdef = 'ABDEF',
  Abdefg = 'ABDEFG',
  Abdefgh = 'ABDEFGH',
  Abdefh = 'ABDEFH',
  Abdeg = 'ABDEG',
  Abdegh = 'ABDEGH',
  Abdeh = 'ABDEH',
  Abdf = 'ABDF',
  Abdfg = 'ABDFG',
  Abdfgh = 'ABDFGH',
  Abdfh = 'ABDFH',
  Abdg = 'ABDG',
  Abdgh = 'ABDGH',
  Abdh = 'ABDH',
  Abe = 'ABE',
  Abef = 'ABEF',
  Abefg = 'ABEFG',
  Abefgh = 'ABEFGH',
  Abefh = 'ABEFH',
  Abeg = 'ABEG',
  Abegh = 'ABEGH',
  Abeh = 'ABEH',
  Abf = 'ABF',
  Abfg = 'ABFG',
  Abfgh = 'ABFGH',
  Abfh = 'ABFH',
  Abg = 'ABG',
  Abgh = 'ABGH',
  Abh = 'ABH',
  Ac = 'AC',
  Acd = 'ACD',
  Acde = 'ACDE',
  Acdef = 'ACDEF',
  Acdefg = 'ACDEFG',
  Acdefgh = 'ACDEFGH',
  Acdefh = 'ACDEFH',
  Acdeg = 'ACDEG',
  Acdegh = 'ACDEGH',
  Acdeh = 'ACDEH',
  Acdf = 'ACDF',
  Acdfg = 'ACDFG',
  Acdfgh = 'ACDFGH',
  Acdfh = 'ACDFH',
  Acdg = 'ACDG',
  Acdgh = 'ACDGH',
  Acdh = 'ACDH',
  Ace = 'ACE',
  Acef = 'ACEF',
  Acefg = 'ACEFG',
  Acefgh = 'ACEFGH',
  Acefh = 'ACEFH',
  Aceg = 'ACEG',
  Acegh = 'ACEGH',
  Aceh = 'ACEH',
  Acf = 'ACF',
  Acfg = 'ACFG',
  Acfgh = 'ACFGH',
  Acfh = 'ACFH',
  Acg = 'ACG',
  Acgh = 'ACGH',
  Ach = 'ACH',
  Ad = 'AD',
  Ade = 'ADE',
  Adef = 'ADEF',
  Adefg = 'ADEFG',
  Adefgh = 'ADEFGH',
  Adefh = 'ADEFH',
  Adeg = 'ADEG',
  Adegh = 'ADEGH',
  Adeh = 'ADEH',
  Adf = 'ADF',
  Adfg = 'ADFG',
  Adfgh = 'ADFGH',
  Adfh = 'ADFH',
  Adg = 'ADG',
  Adgh = 'ADGH',
  Adh = 'ADH',
  Ae = 'AE',
  Aef = 'AEF',
  Aefg = 'AEFG',
  Aefgh = 'AEFGH',
  Aefh = 'AEFH',
  Aeg = 'AEG',
  Aegh = 'AEGH',
  Aeh = 'AEH',
  Af = 'AF',
  Afg = 'AFG',
  Afgh = 'AFGH',
  Afh = 'AFH',
  Ag = 'AG',
  Agh = 'AGH',
  Ah = 'AH',
  B = 'B',
  Bc = 'BC',
  Bcd = 'BCD',
  Bcde = 'BCDE',
  Bcdef = 'BCDEF',
  Bcdefg = 'BCDEFG',
  Bcdefgh = 'BCDEFGH',
  Bcdefh = 'BCDEFH',
  Bcdeg = 'BCDEG',
  Bcdegh = 'BCDEGH',
  Bcdeh = 'BCDEH',
  Bcdf = 'BCDF',
  Bcdfg = 'BCDFG',
  Bcdfgh = 'BCDFGH',
  Bcdfh = 'BCDFH',
  Bcdg = 'BCDG',
  Bcdgh = 'BCDGH',
  Bcdh = 'BCDH',
  Bce = 'BCE',
  Bcef = 'BCEF',
  Bcefg = 'BCEFG',
  Bcefgh = 'BCEFGH',
  Bcefh = 'BCEFH',
  Bceg = 'BCEG',
  Bcegh = 'BCEGH',
  Bceh = 'BCEH',
  Bcf = 'BCF',
  Bcfg = 'BCFG',
  Bcfgh = 'BCFGH',
  Bcfh = 'BCFH',
  Bcg = 'BCG',
  Bcgh = 'BCGH',
  Bch = 'BCH',
  Bd = 'BD',
  Bde = 'BDE',
  Bdef = 'BDEF',
  Bdefg = 'BDEFG',
  Bdefgh = 'BDEFGH',
  Bdefh = 'BDEFH',
  Bdeg = 'BDEG',
  Bdegh = 'BDEGH',
  Bdeh = 'BDEH',
  Bdf = 'BDF',
  Bdfg = 'BDFG',
  Bdfgh = 'BDFGH',
  Bdfh = 'BDFH',
  Bdg = 'BDG',
  Bdgh = 'BDGH',
  Bdh = 'BDH',
  Be = 'BE',
  Bef = 'BEF',
  Befg = 'BEFG',
  Befgh = 'BEFGH',
  Befh = 'BEFH',
  Beg = 'BEG',
  Begh = 'BEGH',
  Beh = 'BEH',
  Bf = 'BF',
  Bfg = 'BFG',
  Bfgh = 'BFGH',
  Bfh = 'BFH',
  Bg = 'BG',
  Bgh = 'BGH',
  Bh = 'BH',
  C = 'C',
  Cd = 'CD',
  Cde = 'CDE',
  Cdef = 'CDEF',
  Cdefg = 'CDEFG',
  Cdefgh = 'CDEFGH',
  Cdefh = 'CDEFH',
  Cdeg = 'CDEG',
  Cdegh = 'CDEGH',
  Cdeh = 'CDEH',
  Cdf = 'CDF',
  Cdfg = 'CDFG',
  Cdfgh = 'CDFGH',
  Cdfh = 'CDFH',
  Cdg = 'CDG',
  Cdgh = 'CDGH',
  Cdh = 'CDH',
  Ce = 'CE',
  Cef = 'CEF',
  Cefg = 'CEFG',
  Cefgh = 'CEFGH',
  Cefh = 'CEFH',
  Ceg = 'CEG',
  Cegh = 'CEGH',
  Ceh = 'CEH',
  Cf = 'CF',
  Cfg = 'CFG',
  Cfgh = 'CFGH',
  Cfh = 'CFH',
  Cg = 'CG',
  Cgh = 'CGH',
  Ch = 'CH',
  D = 'D',
  De = 'DE',
  Def = 'DEF',
  Defg = 'DEFG',
  Defgh = 'DEFGH',
  Defh = 'DEFH',
  Deg = 'DEG',
  Degh = 'DEGH',
  Deh = 'DEH',
  Df = 'DF',
  Dfg = 'DFG',
  Dfgh = 'DFGH',
  Dfh = 'DFH',
  Dg = 'DG',
  Dgh = 'DGH',
  Dh = 'DH',
  E = 'E',
  Ef = 'EF',
  Efg = 'EFG',
  Efgh = 'EFGH',
  Efh = 'EFH',
  Eg = 'EG',
  Egh = 'EGH',
  Eh = 'EH',
  F = 'F',
  Fg = 'FG',
  Fgh = 'FGH',
  Fh = 'FH',
  G = 'G',
  Gh = 'GH',
  H = 'H'
}

export type MenuPosition = {
  __typename?: 'MenuPosition';
  content: Scalars['String'];
  currentTenant: Scalars['String'];
  imageFiles: Array<ImageFile>;
  index: Scalars['Int'];
  menu: Menu;
  name: Scalars['String'];
  restaurant: Restaurant;
  title?: Maybe<Scalars['String']>;
};

/** The connection type for MenuPosition. */
export type MenuPositions = {
  __typename?: 'MenuPositions';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MenuPositionsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MenuPosition>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MenuPositionsEdge = {
  __typename?: 'MenuPositionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MenuPosition>;
};

export type Metadata = {
  __typename?: 'Metadata';
  currentTenant: Scalars['String'];
  dataType: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  metadatableId?: Maybe<Scalars['Int']>;
  metadatableType?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptRegulation: User;
  addReservationGuest: ReservationGuest;
  addUrlResolverEntry: Scalars['Boolean'];
  adminCancelReservation: Reservation;
  appleSignIn: AppleSignInPayload;
  applyPaymentMethodDiscount: Reservation;
  cancelDailyReservation: Reservation;
  cancelReservation: Reservation;
  confirmManualReservation: ManualReservation;
  confirmReservationGuest: ReservationGuest;
  confirmUser: ConfirmUserPayload;
  connectReservation: Reservation;
  createDailyReservation: Reservation;
  createEventReservation: Reservation;
  createFavorite: Favorite;
  createFestivalReservation: Reservation;
  createGuest: CreateGuestPayload;
  createLike: Like;
  createManualReservation: ManualReservation;
  createPageDetail: PageDetail;
  createReview: Review;
  createUser: CreateUserPayload;
  createVoucher: Voucher;
  currentTenant: Scalars['String'];
  deleteCard?: Maybe<Card>;
  deleteUser: Scalars['Boolean'];
  destroyFavorite: Favorite;
  destroyLike: Like;
  destroyManualReservation: ManualReservation;
  destroyPageDetail: PageDetail;
  facebookSignIn: FacebookSignInPayload;
  googleSignIn: GoogleSignInPayload;
  klarnaCreateOrder: KlarnaOrder;
  klarnaCreateSession: Session;
  klarnaUpdateSession: Scalars['Boolean'];
  moderateReview: Review;
  newsletterSignUp: NewsletterSignUp;
  payuCreateOrder: CreateOrderResponse;
  payuDeleteTokenizedCard: Scalars['Boolean'];
  purchaseReservation: PurchaseReservationPayload;
  purchaseVoucher: PurchaseVoucherPayload;
  redeemDiscount: Reservation;
  releaseSlot: Reservation;
  rememberMe: ManualReservation;
  resetPasswordRequest: ResetPasswordRequestPayload;
  restaurateurUpdateReservation: Reservation;
  sendReservationNotification: Scalars['Boolean'];
  sendSmsCode: User;
  setDefaultCard: Card;
  setManualReservationStatus: ManualReservation;
  setPassword: User;
  signIn?: Maybe<SignInPayload>;
  signInRestaurant: Restaurant;
  signOut: Scalars['Boolean'];
  signOutRestaurant: Scalars['Boolean'];
  updateDailyReservation: Reservation;
  updateEventReservation: Reservation;
  updateFestivalReservation: Reservation;
  updateManualReservation: ManualReservation;
  updateOrder: Order;
  updatePageDetail: PageDetail;
  updateUser: User;
  verifySmsCode: User;
};


export type MutationAddReservationGuestArgs = {
  email: Scalars['String'];
  reservationId: Scalars['ID'];
};


export type MutationAddUrlResolverEntryArgs = {
  objectId: Scalars['ID'];
  objectType: Scalars['String'];
  slug: Scalars['String'];
};


export type MutationAdminCancelReservationArgs = {
  code: Scalars['String'];
};


export type MutationAppleSignInArgs = {
  appleIdentityToken: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userIdentityId?: InputMaybe<Scalars['String']>;
};


export type MutationApplyPaymentMethodDiscountArgs = {
  code: Scalars['String'];
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
};


export type MutationCancelDailyReservationArgs = {
  code: Scalars['String'];
};


export type MutationCancelReservationArgs = {
  code: Scalars['String'];
};


export type MutationConfirmManualReservationArgs = {
  code: Scalars['String'];
};


export type MutationConfirmReservationGuestArgs = {
  token: Scalars['String'];
};


export type MutationConfirmUserArgs = {
  confirmationToken: Scalars['String'];
};


export type MutationConnectReservationArgs = {
  code: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationCreateDailyReservationArgs = {
  crossSellsList?: InputMaybe<Array<CrossSellsList>>;
  date: Scalars['Date'];
  notes?: InputMaybe<Scalars['String']>;
  peopleCount: Scalars['Int'];
  reservableExtraAttrs?: InputMaybe<Array<ReservableExtraAttrInput>>;
  reservationSource?: InputMaybe<Scalars['Int']>;
  restaurantId: Scalars['ID'];
  slot: Scalars['Int'];
  vatId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateEventReservationArgs = {
  date: Scalars['Date'];
  eventId: Scalars['ID'];
  menus?: InputMaybe<Array<Scalars['Int']>>;
  notes?: InputMaybe<Scalars['String']>;
  peopleCount: Scalars['Int'];
  reservationSource?: InputMaybe<Scalars['Int']>;
  slot: Scalars['Int'];
  vatId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateFavoriteArgs = {
  restaurantId: Scalars['ID'];
};


export type MutationCreateFestivalReservationArgs = {
  crossSellsList?: InputMaybe<Array<CrossSellsList>>;
  date: Scalars['Date'];
  festivalEditionId: Scalars['ID'];
  guestEmails?: InputMaybe<Array<Scalars['String']>>;
  menus?: InputMaybe<Array<Scalars['Int']>>;
  notes?: InputMaybe<Scalars['String']>;
  peopleCount?: InputMaybe<Scalars['Int']>;
  reservationSource?: InputMaybe<Scalars['Int']>;
  reservationType?: InputMaybe<ReservationTypeEnum>;
  restaurantId: Scalars['ID'];
  slot: Scalars['Int'];
  vatId?: InputMaybe<Scalars['String']>;
  voucherCode?: InputMaybe<Scalars['String']>;
};


export type MutationCreateGuestArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  marketingConsentAccepted?: InputMaybe<Scalars['Boolean']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  regulationAccepted?: InputMaybe<Scalars['Boolean']>;
  regulationConsentAccepted?: InputMaybe<Scalars['Boolean']>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateLikeArgs = {
  reviewId: Scalars['ID'];
};


export type MutationCreateManualReservationArgs = {
  attachmentFileId?: InputMaybe<Scalars['ID']>;
  date: Scalars['Date'];
  guestNotes?: InputMaybe<Scalars['String']>;
  hall?: InputMaybe<Scalars['String']>;
  peopleCount: Scalars['Int'];
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  restauratorNotes?: InputMaybe<Scalars['String']>;
  slot?: InputMaybe<Scalars['Int']>;
  slotDuration: Scalars['Int'];
  slotVariant?: InputMaybe<Scalars['Int']>;
  table?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
  vatId?: InputMaybe<Scalars['String']>;
};


export type MutationCreatePageDetailArgs = {
  middleBannerId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  topBannerId?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateReviewArgs = {
  atmosphereRating?: InputMaybe<Scalars['Int']>;
  menuRating?: InputMaybe<Scalars['Int']>;
  ratings: RatingAttributes;
  reservationCode: Scalars['String'];
  securityToken?: InputMaybe<Scalars['String']>;
  staffRating?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};


export type MutationCreateUserArgs = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  consents?: InputMaybe<Array<UserConsentInput>>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  marketingConsentAccepted?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  regulationAccepted?: InputMaybe<Scalars['Boolean']>;
  regulationConsentAccepted?: InputMaybe<Scalars['Boolean']>;
  subscribed?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateVoucherArgs = {
  festivalEditionId: Scalars['ID'];
  peopleCount: Scalars['Int'];
  permittedPaymentMethods?: InputMaybe<Array<ProviderSpecificPaymentMethodEnum>>;
  permittedSources?: InputMaybe<Array<ReservationSourceEnum>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteCardArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationDestroyFavoriteArgs = {
  restaurantId: Scalars['ID'];
};


export type MutationDestroyLikeArgs = {
  reviewId: Scalars['ID'];
};


export type MutationDestroyManualReservationArgs = {
  id: Scalars['ID'];
  notifyGuest: Scalars['Boolean'];
};


export type MutationDestroyPageDetailArgs = {
  id: Scalars['ID'];
};


export type MutationFacebookSignInArgs = {
  accessToken: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
};


export type MutationGoogleSignInArgs = {
  accessToken: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
};


export type MutationKlarnaCreateOrderArgs = {
  authToken: Scalars['String'];
  reservationId: Scalars['ID'];
};


export type MutationKlarnaCreateSessionArgs = {
  reservationId: Scalars['ID'];
};


export type MutationKlarnaUpdateSessionArgs = {
  reservationId: Scalars['ID'];
  sessionId: Scalars['String'];
};


export type MutationModerateReviewArgs = {
  id: Scalars['ID'];
  status: ReviewStatusEnum;
};


export type MutationNewsletterSignUpArgs = {
  email: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
};


export type MutationPayuCreateOrderArgs = {
  extraParams?: InputMaybe<PaymentExtraParamsInput>;
  paymentMethod: PaymentMethodEnum;
  reservationId: Scalars['ID'];
};


export type MutationPayuDeleteTokenizedCardArgs = {
  token: Scalars['String'];
};


export type MutationPurchaseReservationArgs = {
  cardId?: InputMaybe<Scalars['ID']>;
  code: Scalars['String'];
  consents?: InputMaybe<Array<UserConsentInput>>;
  extraParams?: InputMaybe<PaymentExtraParamsInput>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
  rcRegulationAccord?: InputMaybe<Scalars['Boolean']>;
  restaurantRegulationAccord?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPurchaseVoucherArgs = {
  cardId?: InputMaybe<Scalars['ID']>;
  code: Scalars['String'];
  extraParams?: InputMaybe<PaymentExtraParamsInput>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
};


export type MutationRedeemDiscountArgs = {
  code: Scalars['String'];
  redeemCode?: InputMaybe<Scalars['String']>;
};


export type MutationReleaseSlotArgs = {
  reservationCode: Scalars['String'];
};


export type MutationRememberMeArgs = {
  code: Scalars['String'];
  email: Scalars['String'];
  marketingConsent?: InputMaybe<Scalars['Boolean']>;
  rodoConsent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationResetPasswordRequestArgs = {
  email: Scalars['String'];
};


export type MutationRestaurateurUpdateReservationArgs = {
  code: Scalars['String'];
  hall?: InputMaybe<Scalars['String']>;
  restauratorNotes?: InputMaybe<Scalars['String']>;
  table?: InputMaybe<Scalars['String']>;
};


export type MutationSendReservationNotificationArgs = {
  id: Scalars['ID'];
  type: ReservationNotificationTypeEnum;
};


export type MutationSendSmsCodeArgs = {
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type MutationSetDefaultCardArgs = {
  id: Scalars['ID'];
};


export type MutationSetManualReservationStatusArgs = {
  id: Scalars['ID'];
  status: ManualReservationStatusEnum;
};


export type MutationSetPasswordArgs = {
  password: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};


export type MutationSignInArgs = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};


export type MutationSignInRestaurantArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUpdateDailyReservationArgs = {
  code: Scalars['String'];
  crossSellsList?: InputMaybe<Array<CrossSellsList>>;
  date?: InputMaybe<Scalars['Date']>;
  notes?: InputMaybe<Scalars['String']>;
  peopleCount?: InputMaybe<Scalars['Int']>;
  redeemCode?: InputMaybe<Scalars['String']>;
  reservableExtraAttrs?: InputMaybe<Array<ReservableExtraAttrInput>>;
  slot?: InputMaybe<Scalars['Int']>;
  vatId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateEventReservationArgs = {
  code: Scalars['String'];
  date?: InputMaybe<Scalars['Date']>;
  menus?: InputMaybe<Array<Scalars['Int']>>;
  notes?: InputMaybe<Scalars['String']>;
  peopleCount?: InputMaybe<Scalars['Int']>;
  redeemCode?: InputMaybe<Scalars['String']>;
  slot?: InputMaybe<Scalars['Int']>;
  userAcceptedMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  vatId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateFestivalReservationArgs = {
  _force?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  crossSellsList?: InputMaybe<Array<CrossSellsList>>;
  date?: InputMaybe<Scalars['Date']>;
  deliveryAddress?: InputMaybe<DeliveryAddressInput>;
  guestEmails?: InputMaybe<Array<Scalars['String']>>;
  menus?: InputMaybe<Array<Scalars['Int']>>;
  notes?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  peopleCount?: InputMaybe<Scalars['Int']>;
  redeemCode?: InputMaybe<Scalars['String']>;
  reservationType?: InputMaybe<ReservationTypeEnum>;
  restaurantId?: InputMaybe<Scalars['ID']>;
  slot?: InputMaybe<Scalars['Int']>;
  userAcceptedMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  vatId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateManualReservationArgs = {
  attachmentFileId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
  guestNotes?: InputMaybe<Scalars['String']>;
  hall?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  peopleCount?: InputMaybe<Scalars['Int']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  restauratorNotes?: InputMaybe<Scalars['String']>;
  slot?: InputMaybe<Scalars['Int']>;
  slotDuration?: InputMaybe<Scalars['Int']>;
  slotVariant?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ManualReservationStatusEnum>;
  table?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  vatId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrderArgs = {
  id: Scalars['ID'];
  status?: InputMaybe<OrderStatusEnum>;
  transactionId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePageDetailArgs = {
  id: Scalars['ID'];
  middleBannerId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  topBannerId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateUserArgs = {
  consents?: InputMaybe<Array<UserConsentInput>>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  hasMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<LocaleEnum>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type MutationVerifySmsCodeArgs = {
  code: Scalars['String'];
};

export enum MyReservationsTypeEnum {
  All = 'ALL',
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type NewsletterSignUp = {
  __typename?: 'NewsletterSignUp';
  currentTenant: Scalars['String'];
  salesmanagoContactId?: Maybe<Scalars['String']>;
};

export type OpeningHoursChanges = {
  __typename?: 'OpeningHoursChanges';
  currentTenant: Scalars['String'];
  day?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  canceledAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
  price: Scalars['Float'];
  provider: PaymentProviderEnum;
  status: OrderStatusEnum;
  statusDetails?: Maybe<OrderStatusDetailsEnum>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderStatusDetailsEnum {
  AuthenticationFailed = 'AUTHENTICATION_FAILED',
  AuthorizationFailed = 'AUTHORIZATION_FAILED',
  CardExpired = 'CARD_EXPIRED',
  DeclinedByIssuingBank = 'DECLINED_BY_ISSUING_BANK',
  FraudDetected = 'FRAUD_DETECTED',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  InvalidCardData = 'INVALID_CARD_DATA',
  PaymentCanceled = 'PAYMENT_CANCELED',
  PaymentGatewayError = 'PAYMENT_GATEWAY_ERROR',
  PaymentTimeExpired = 'PAYMENT_TIME_EXPIRED',
  PossiblyDuplicatedTransaction = 'POSSIBLY_DUPLICATED_TRANSACTION',
  ReservationProcessInterrupted = 'RESERVATION_PROCESS_INTERRUPTED',
  TransactionDeclined = 'TRANSACTION_DECLINED'
}

export enum OrderStatusEnum {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
  Terminated = 'TERMINATED'
}

export enum OverridableTagTypeEnum {
  Atmosphere = 'ATMOSPHERE',
  Category = 'CATEGORY',
  Cuisine = 'CUISINE',
  Deliveryregion = 'DELIVERYREGION',
  Diet = 'DIET',
  Dish = 'DISH',
  Establishmenttype = 'ESTABLISHMENTTYPE',
  Menutag = 'MENUTAG',
  Occasion = 'OCCASION',
  Other = 'OTHER',
  Price = 'PRICE',
  Reservationtype = 'RESERVATIONTYPE'
}

export type PageDetail = {
  __typename?: 'PageDetail';
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
  middleBanner?: Maybe<Banner>;
  name: Scalars['String'];
  slug: Scalars['String'];
  topBanner?: Maybe<Banner>;
};

/** An edge in a connection. */
export type PageDetailEdge = {
  __typename?: 'PageDetailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PageDetail>;
};

/** The connection type for PageDetail. */
export type PageDetails = {
  __typename?: 'PageDetails';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PageDetailEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PageDetail>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PayByLinkMethod = {
  __typename?: 'PayByLinkMethod';
  brandImageUrl?: Maybe<Scalars['String']>;
  currentTenant: Scalars['String'];
  maxAmount: Scalars['Int'];
  minAmount: Scalars['Int'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type PaymentExtraParamsInput = {
  applePayAuthorizationCode?: InputMaybe<Scalars['String']>;
  blikAppKeyAssignmentId?: InputMaybe<Scalars['String']>;
  blikCode?: InputMaybe<Scalars['String']>;
  blikRegisterToken?: InputMaybe<Scalars['Boolean']>;
  blikTokenValue?: InputMaybe<Scalars['String']>;
  /** Types::Enums::CardTransactionTypeEnum */
  cardTokenType?: InputMaybe<Scalars['String']>;
  cardTransactionType?: InputMaybe<CardTransactionTypeEnum>;
  continueUrl?: InputMaybe<Scalars['String']>;
  failureUrl?: InputMaybe<Scalars['String']>;
  googlePayAuthorizationCode?: InputMaybe<Scalars['String']>;
  payuCardToken?: InputMaybe<Scalars['String']>;
  pblMethodValue?: InputMaybe<Scalars['String']>;
  successUrl?: InputMaybe<Scalars['String']>;
  userAddress?: InputMaybe<UserAddressInput>;
  vmPhoneNumber?: InputMaybe<Scalars['String']>;
};

export enum PaymentMethodEnum {
  ApplePay = 'APPLE_PAY',
  BlikAuthorizationCode = 'BLIK_AUTHORIZATION_CODE',
  BlikToken = 'BLIK_TOKEN',
  Card = 'CARD',
  CardWhitelabel = 'CARD_WHITELABEL',
  GooglePay = 'GOOGLE_PAY',
  Link = 'LINK',
  PaymentMethod = 'PAYMENT_METHOD',
  Pbl = 'PBL',
  VisaMobile = 'VISA_MOBILE'
}

export type PaymentMethods = {
  __typename?: 'PaymentMethods';
  currentTenant: Scalars['String'];
  payByLinks: Array<PayByLinkMethod>;
};

export enum PaymentProviderEnum {
  Internal = 'INTERNAL',
  Klarna = 'KLARNA',
  Paypo = 'PAYPO',
  Payu = 'PAYU',
  Straal = 'STRAAL'
}

export type PayuCard = {
  __typename?: 'PayuCard';
  brandImageUrl: Scalars['String'];
  cardBrand: Scalars['String'];
  cardExpirationMonth: Scalars['Int'];
  cardExpirationYear: Scalars['String'];
  cardNumberMasked: Scalars['String'];
  cardScheme?: Maybe<Scalars['String']>;
  currentTenant: Scalars['String'];
  preferred: Scalars['Boolean'];
  status: Scalars['String'];
  value: Scalars['String'];
};

export type PdfFile = {
  __typename?: 'PdfFile';
  attachable?: Maybe<Restaurant>;
  createdAt: Scalars['Date'];
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
  original?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
};

export type PeopleData = {
  __typename?: 'PeopleData';
  currentTenant: Scalars['String'];
  peopleCount: Scalars['Int'];
  reservationsCount: Scalars['Int'];
};

export type PercentageCoupon = Redeemable & {
  __typename?: 'PercentageCoupon';
  billingMethod: DiscountBillingMethodEnum;
  category: DiscountCategoryEnum;
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  discountAssignments: Array<DiscountAssignment>;
  enabled: Scalars['Boolean'];
  events: Array<FestivalEdition>;
  expired: Scalars['ISO8601DateTime'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated Use festivalEditions */
  festivalEdition?: Maybe<FestivalEdition>;
  festivalEditions: Array<FestivalEdition>;
  id: Scalars['ID'];
  isCustomCode: Scalars['Boolean'];
  marketingConsentRequired: Scalars['Boolean'];
  maxMenuPrice?: Maybe<Scalars['Int']>;
  maxUsesCount: Scalars['Int'];
  metadatas: Array<Metadata>;
  minMenuPrice?: Maybe<Scalars['Int']>;
  minPeopleCount?: Maybe<Scalars['Int']>;
  minPeopleCountEnabled: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  order: Order;
  pdfUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use value */
  peopleCount: Scalars['Int'];
  permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum>;
  permittedSources: Array<ReservationSourceEnum>;
  primeTimeIncluded: Scalars['Boolean'];
  singleUse: Scalars['Boolean'];
  slots?: Maybe<Array<Scalars['Int']>>;
  /** TOTAL or PERCENT */
  type: Scalars['String'];
  used: Scalars['Int'];
  user?: Maybe<User>;
  value: Scalars['Float'];
  weekDays: Array<WeekDayEnum>;
};

export type Point = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type PolymorphicCollection = {
  __typename?: 'PolymorphicCollection';
  category: CollectionCategoryEnum;
  country: Country;
  countryCode: Scalars['String'];
  countryId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  elements?: Maybe<Array<CollectionElement>>;
  festivalEdition?: Maybe<FestivalEdition>;
  festivalEditionRestaurants: Array<FestivalEditionRestaurant>;
  id: Scalars['ID'];
  position: Scalars['Int'];
  region?: Maybe<Region>;
  regionId?: Maybe<Scalars['ID']>;
  reservableExtras?: Maybe<Array<ReservableExtra>>;
  restaurants?: Maybe<Array<Restaurant>>;
  section: Section;
  sectionId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  validFrom: Scalars['ISO8601DateTime'];
  validTo?: Maybe<Scalars['ISO8601DateTime']>;
  visible: Scalars['Boolean'];
};

export type PriceValues = {
  __typename?: 'PriceValues';
  basePrice: Scalars['Float'];
  basePriceWithCrossSells: Scalars['Float'];
  baseUnitPrice?: Maybe<Scalars['Float']>;
  crossSellsPrice: Scalars['Float'];
  currentTenant: Scalars['String'];
  deliveryFee: Scalars['Float'];
  discountValue: Scalars['Float'];
  discountablePrice: Scalars['Float'];
  feeablePeopleCount?: Maybe<Scalars['Int']>;
  originalBaseUnitPrice?: Maybe<Scalars['Float']>;
  priceToPay: Scalars['Float'];
  primeTimeFeeIncludedInBaseUnitPrice?: Maybe<Scalars['Float']>;
  reservableExtrasPrice: Scalars['Float'];
  reservationFee: Scalars['Float'];
  reservationFeeUnitPrice: Scalars['Float'];
  totalValue: Scalars['Float'];
};

/** The connection type for ProductableLogEntry. */
export type ProductableLogEntries = {
  __typename?: 'ProductableLogEntries';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductableLogEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductableLogEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductableLogEntry = {
  __typename?: 'ProductableLogEntry';
  action: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  deliveryStatus?: Maybe<Scalars['String']>;
  emailType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  messageId?: Maybe<Scalars['String']>;
  productableId: Scalars['ID'];
  productableType: Scalars['String'];
  recipient?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export enum ProductableLogEntryActionEnum {
  Cancellation = 'CANCELLATION',
  EmailClicked = 'EMAIL_CLICKED',
  EmailComplained = 'EMAIL_COMPLAINED',
  EmailDelivered = 'EMAIL_DELIVERED',
  EmailEnqueued = 'EMAIL_ENQUEUED',
  EmailFailed = 'EMAIL_FAILED',
  EmailOpened = 'EMAIL_OPENED',
  EmailPermanentFail = 'EMAIL_PERMANENT_FAIL',
  EmailUnsubscribed = 'EMAIL_UNSUBSCRIBED',
  KlarnaNotification = 'KLARNA_NOTIFICATION',
  Refund = 'REFUND',
  SmsEnqueued = 'SMS_ENQUEUED',
  SmsFailed = 'SMS_FAILED',
  SmsSent = 'SMS_SENT',
  StraalNotification = 'STRAAL_NOTIFICATION'
}

/** An edge in a connection. */
export type ProductableLogEntryEdge = {
  __typename?: 'ProductableLogEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductableLogEntry>;
};

export enum ProviderSpecificPaymentMethodEnum {
  InternalPaymentMethod = 'INTERNAL_PAYMENT_METHOD',
  KlarnaPaymentMethod = 'KLARNA_PAYMENT_METHOD',
  PaypoPaymentMethod = 'PAYPO_PAYMENT_METHOD',
  PayuApplePay = 'PAYU_APPLE_PAY',
  PayuBlikAuthorizationCode = 'PAYU_BLIK_AUTHORIZATION_CODE',
  PayuBlikToken = 'PAYU_BLIK_TOKEN',
  PayuCard = 'PAYU_CARD',
  PayuCardWhitelabel = 'PAYU_CARD_WHITELABEL',
  PayuGooglePay = 'PAYU_GOOGLE_PAY',
  PayuPbl = 'PAYU_PBL',
  PayuVisaMobile = 'PAYU_VISA_MOBILE',
  StraalCard = 'STRAAL_CARD',
  StraalLink = 'STRAAL_LINK'
}

/** Autogenerated return type of PurchaseReservation */
export type PurchaseReservationPayload = {
  __typename?: 'PurchaseReservationPayload';
  checkoutPageUrl?: Maybe<Scalars['String']>;
  cryptKey?: Maybe<Scalars['String']>;
  reservation: Reservation;
};

/** Autogenerated return type of PurchaseVoucher */
export type PurchaseVoucherPayload = {
  __typename?: 'PurchaseVoucherPayload';
  checkoutPageUrl?: Maybe<Scalars['String']>;
  cryptKey?: Maybe<Scalars['String']>;
  voucher: Voucher;
};

export type Query = {
  __typename?: 'Query';
  /** List of banners for admin panel */
  adminBanners: Banners;
  adminCollections: Collections;
  /** List of documents for admin */
  adminDocuments: Documents;
  /** Get list of events */
  adminEvents: Events;
  /** List of festival edition restaurants for restaurators and admins */
  adminFestivalEditionRestaurants: FestivalEditionRestaurants;
  adminPageDetails: PageDetails;
  /** List of productable log entries for object */
  adminProductableLogs: ProductableLogEntries;
  adminReservableExtras: ReservableExtras;
  adminReservables: Array<Reservable>;
  adminReservations: Reservations;
  adminReservationsXlsx: Reservations;
  adminRestaurant?: Maybe<Restaurant>;
  adminRestaurants: Restaurants;
  adminReview?: Maybe<Review>;
  adminReviews: Reviews;
  adminSlots: Array<Slot>;
  adminSlotsUsage: Scalars['JSON'];
  adminSponsors: Sponsors;
  adminVoucherSales: Redeemables;
  attachment?: Maybe<ImageFile>;
  attachments: Attachments;
  /** Get single banner */
  banner: Banner;
  /** List of banners */
  banners: Banners;
  calendarRevisionSlots: Array<Slot>;
  calendarRevisions: Array<CalendarRevision>;
  /** Check if card was created */
  checkCard?: Maybe<Card>;
  clientConfigs: ClientConfig;
  /** Get single polymorphic collection */
  collection: PolymorphicCollection;
  /** List of polymorphic collections */
  collections: Collections;
  companyTypes: Array<Company>;
  /** List of festival edition or daily cross sells */
  crossSells: CrossSells;
  currentFestivalEdition?: Maybe<FestivalEdition>;
  currentRestaurant?: Maybe<Restaurant>;
  currentTenant: Scalars['String'];
  dashboard: FestivalEditionData;
  decodeRestaurant: DecodedRestaurant;
  /** Get single discount */
  discount: Redeemable;
  /** List of discounts */
  discounts: Redeemables;
  document: Document;
  /** List of public documents */
  documents: Documents;
  /** Get single event */
  event: Event;
  eventSlotsUsage: Scalars['JSON'];
  /** List of restaurants favorited by current user */
  favoriteRestaurants: Array<Restaurant>;
  festival?: Maybe<Festival>;
  festivalEdition: FestivalEdition;
  festivalEditionRestaurant?: Maybe<FestivalEditionRestaurant>;
  /** List of festival edition restaurants */
  festivalEditionRestaurants: FestivalEditionRestaurants;
  /** List of festival editions */
  festivalEditions: FestivalEditions;
  /** List of festival regions */
  festivalRegions: Array<Region>;
  festivalRegulation?: Maybe<Document>;
  festivals: Array<Festival>;
  findUser?: Maybe<User>;
  geoRegion: Array<Region>;
  googleTranslate: Array<Scalars['String']>;
  incomingEvents: Events;
  /** List of incoming events regions */
  incomingEventsRegions: Array<Region>;
  inventoryItems: InventoryItems;
  manualReservation?: Maybe<ManualReservation>;
  menuPositions: MenuPositions;
  mgmInvitationCode?: Maybe<Scalars['String']>;
  /** List of user discounts */
  myDiscounts: Discounts;
  /** Fetch current user reservations (festival/d2d/event reservations - ONLY PAID) and vouchers (also ONLY PAID) */
  myPurchases: UserPurchases;
  /** List of user reservations */
  myReservations: Reservations;
  /** Nearest slot in given restaurant. People count default equals `2` */
  nearestSlot: Scalars['JSON'];
  ongoingFestivalEditions?: Maybe<Array<FestivalEdition>>;
  otherDatesRestaurants: Restaurants;
  /** Get single page detail object */
  pageDetail?: Maybe<PageDetail>;
  payuPaymentMethods: PaymentMethods;
  popularRestaurants: Array<Restaurant>;
  popularTags: Array<Tag>;
  randomIncomingEvent?: Maybe<Event>;
  /** List of regions */
  regions: Array<Region>;
  /** Regulations for festival edition */
  regulations: Array<Document>;
  reservable: Reservable;
  reservableExtra: ReservableExtra;
  reservableExtras: ReservableExtras;
  reservables: Array<Reservable>;
  /** Get info about reservation */
  reservation?: Maybe<Reservation>;
  reservationCancellationDeadline?: Maybe<Scalars['Date']>;
  reservationPossibility: ReservationPossibility;
  /** Resolves slug to attachable object */
  resolveUrlSlug?: Maybe<UrlResolverResult>;
  restaurant?: Maybe<Restaurant>;
  restaurantLink: Scalars['String'];
  /** Get all restaurant reservations for date */
  restaurantReservations: Array<BookReservation>;
  restaurants: Restaurants;
  rules: Array<Rule>;
  /** Full text search for tags, collections or restaurants */
  search: Array<SearchResult>;
  /** List of sections */
  sections: Sections;
  selectedRegion?: Maybe<CookieRegion>;
  slotDiscountRule: SlotDiscountRule;
  /** List of SlotDiscountRules */
  slotDiscountRules: SlotDiscountRules;
  slots: Array<Slot>;
  slotsUsage: Scalars['JSON'];
  sponsor?: Maybe<Sponsor>;
  sponsors: Sponsors;
  strapi: Scalars['JSON'];
  submissions: Submissions;
  /** List of tags */
  tags: Array<Tag>;
  user?: Maybe<User>;
  /** List of users */
  users: Users;
  /** Find a voucher by code */
  voucher?: Maybe<Voucher>;
};


export type QueryAdminBannersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  section_slug?: InputMaybe<Scalars['String']>;
  service_id?: InputMaybe<Scalars['ID']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAdminCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CollectionCategoryEnum>;
  country_id?: InputMaybe<Scalars['ID']>;
  festival_edition_code?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  section_slug?: InputMaybe<Scalars['String']>;
  service_id?: InputMaybe<Scalars['ID']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAdminDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  festival_edition_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DocumentTypeEnum>;
};


export type QueryAdminEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EventOrder>;
  region_id?: InputMaybe<Scalars['ID']>;
  restaurant_ids?: InputMaybe<Array<Scalars['ID']>>;
  slotless?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<TagFilter>>>;
};


export type QueryAdminFestivalEditionRestaurantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  festival_edition_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  region_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<StatusableEnum>>;
};


export type QueryAdminPageDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminProductableLogsArgs = {
  action?: InputMaybe<Array<ProductableLogEntryActionEnum>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  productableId?: InputMaybe<Scalars['Int']>;
  productableType?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminReservableExtrasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date_range?: InputMaybe<DateRange>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  regionIds?: InputMaybe<Array<Scalars['ID']>>;
  restaurantIds?: InputMaybe<Array<Scalars['ID']>>;
  restaurant_tags?: InputMaybe<Array<InputMaybe<TagFilter>>>;
  slot_range?: InputMaybe<SlotRange>;
  type?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryAdminReservablesArgs = {
  dates: DateRange;
  restaurantId: Scalars['ID'];
};


export type QueryAdminReservationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  changed_since?: InputMaybe<Scalars['ISO8601DateTime']>;
  date_range?: InputMaybe<DateRange>;
  event_id?: InputMaybe<Scalars['ID']>;
  festival_edition_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdminReservationsOrderBy>>;
  reservable_type?: InputMaybe<ReservableEnum>;
  restaurant_id?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  slot_range?: InputMaybe<SlotRange>;
  status?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['ID']>;
  voucher_id?: InputMaybe<Scalars['ID']>;
};


export type QueryAdminReservationsXlsxArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  changed_since?: InputMaybe<Scalars['ISO8601DateTime']>;
  date_range?: InputMaybe<DateRange>;
  event_id?: InputMaybe<Scalars['ID']>;
  festival_edition_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdminReservationsOrderBy>>;
  reservable_type?: InputMaybe<ReservableEnum>;
  restaurant_id?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  slot_range?: InputMaybe<SlotRange>;
  status?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['ID']>;
  voucher_id?: InputMaybe<Scalars['ID']>;
};


export type QueryAdminRestaurantArgs = {
  id: Scalars['ID'];
};


export type QueryAdminRestaurantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  collection_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  festival_edition_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  in_area?: InputMaybe<Area>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<RestaurantsOrderBy>>;
  region_id?: InputMaybe<Scalars['ID']>;
  reservables?: InputMaybe<Array<ReservableInput>>;
  reservation_filters?: InputMaybe<ReservationFilter>;
  sort?: InputMaybe<RestaurantSort>;
  tag_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags?: InputMaybe<Array<InputMaybe<TagFilter>>>;
  with_D2D?: InputMaybe<Scalars['Boolean']>;
  with_reservable_extras?: InputMaybe<Scalars['Boolean']>;
  zone_id?: InputMaybe<Scalars['ID']>;
};


export type QueryAdminReviewArgs = {
  review_id: Scalars['ID'];
};


export type QueryAdminReviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  festival_edition_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<ReviewOrder>;
  restaurant_id?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<ReviewStatusEnum>>;
  type?: InputMaybe<Array<ReservableEnum>>;
};


export type QueryAdminSlotsArgs = {
  dates: DateRange;
  reservables: Array<ReservableInput>;
  withReservableExtra?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAdminSlotsUsageArgs = {
  dateRange?: InputMaybe<DateRange>;
  restaurantId: Scalars['ID'];
};


export type QueryAdminSponsorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clubSponsors?: InputMaybe<Scalars['Boolean']>;
  festivalEditionId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['ID']>;
};


export type QueryAdminVoucherSalesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRange>;
  festivalEditionId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<AdminVoucherSalesOrder>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OrderStatusEnum>;
};


export type QueryAttachmentArgs = {
  attachment_id: Scalars['ID'];
};


export type QueryAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  restaurant_id?: InputMaybe<Scalars['ID']>;
};


export type QueryBannerArgs = {
  id: Scalars['ID'];
};


export type QueryBannersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  section_slug?: InputMaybe<Scalars['String']>;
  service_id?: InputMaybe<Scalars['ID']>;
};


export type QueryCalendarRevisionSlotsArgs = {
  revisionId: Scalars['ID'];
};


export type QueryCalendarRevisionsArgs = {
  restaurantId: Scalars['ID'];
};


export type QueryCheckCardArgs = {
  requestId: Scalars['String'];
};


export type QueryCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CollectionCategoryEnum>;
  country_id?: InputMaybe<Scalars['ID']>;
  festival_edition_code?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  section_slug?: InputMaybe<Scalars['String']>;
  service_id?: InputMaybe<Scalars['ID']>;
};


export type QueryCrossSellsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  daily_id?: InputMaybe<Scalars['ID']>;
  festival_edition_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CrossSellsOrderBy>>;
};


export type QueryCurrentFestivalEditionArgs = {
  code?: InputMaybe<FestivalCodesEnum>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryDashboardArgs = {
  festivalEditionId: Scalars['ID'];
  restaurantId?: InputMaybe<Scalars['ID']>;
};


export type QueryDecodeRestaurantArgs = {
  code: Scalars['ID'];
};


export type QueryDiscountArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryDiscountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRange>;
  discountable_id?: InputMaybe<Scalars['ID']>;
  discountable_type?: InputMaybe<DiscountableTypeEnum>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  event_id?: InputMaybe<Scalars['ID']>;
  festival_edition_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<DiscountOrder>;
  prefix?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DiscountTypes>;
  userId?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};


export type QueryDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  festival_edition_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DocumentTypeEnum>;
};


export type QueryEventArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryEventSlotsUsageArgs = {
  dateRange?: InputMaybe<DateRange>;
  eventId: Scalars['ID'];
};


export type QueryFestivalArgs = {
  festivalId: Scalars['ID'];
};


export type QueryFestivalEditionArgs = {
  id: Scalars['ID'];
};


export type QueryFestivalEditionRestaurantArgs = {
  festivalEditionId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  restaurantId?: InputMaybe<Scalars['ID']>;
};


export type QueryFestivalEditionRestaurantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  festival_edition_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  price_from?: InputMaybe<Scalars['Int']>;
  price_to?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  reservation_filters?: InputMaybe<ReservationFilter>;
  restaurant_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sort?: InputMaybe<FestivalEditionRestaurantSort>;
  tag_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags?: InputMaybe<Array<InputMaybe<TagFilter>>>;
  zone_id?: InputMaybe<Scalars['ID']>;
};


export type QueryFestivalEditionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  festival_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FestivalEditionsOrderBy>>;
  restaurant_id?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Array<FestivalStateEnum>>;
  timing?: InputMaybe<FestivalTimingEnum>;
  with_hidden?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFestivalRegionsArgs = {
  festivalEditionId: Scalars['ID'];
};


export type QueryFestivalRegulationArgs = {
  festivalEditionId: Scalars['ID'];
};


export type QueryFestivalsArgs = {
  orderBy?: InputMaybe<Array<FestivalsOrderBy>>;
};


export type QueryFindUserArgs = {
  id: Scalars['ID'];
};


export type QueryGeoRegionArgs = {
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};


export type QueryGoogleTranslateArgs = {
  contents: Array<Scalars['String']>;
  langFrom: Scalars['String'];
  langTo: Scalars['String'];
};


export type QueryIncomingEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<EventOrder>;
  region_id?: InputMaybe<Scalars['ID']>;
  restaurant_ids?: InputMaybe<Array<Scalars['ID']>>;
  slotless?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<TagFilter>>>;
};


export type QueryIncomingEventsRegionsArgs = {
  slotless?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInventoryItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryManualReservationArgs = {
  code: Scalars['String'];
};


export type QueryMenuPositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  festivalEditionId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  index?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  regionId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryMyDiscountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyPurchasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  festival?: InputMaybe<FestivalCodesEnum>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyReservationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reservable_type?: InputMaybe<ReservableEnum>;
  type?: InputMaybe<MyReservationsTypeEnum>;
};


export type QueryNearestSlotArgs = {
  festivalEditionId: Scalars['ID'];
  peopleCount?: InputMaybe<Scalars['Int']>;
  restaurantId: Scalars['ID'];
};


export type QueryOngoingFestivalEditionsArgs = {
  regionIds?: InputMaybe<Array<Scalars['ID']>>;
  withVoucher?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOtherDatesRestaurantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  collection_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  festival_edition_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  in_area?: InputMaybe<Area>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<RestaurantsOrderBy>>;
  region_id?: InputMaybe<Scalars['ID']>;
  reservables?: InputMaybe<Array<ReservableInput>>;
  reservation_filters?: InputMaybe<ReservationFilter>;
  sort?: InputMaybe<RestaurantSort>;
  tag_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags?: InputMaybe<Array<InputMaybe<TagFilter>>>;
  with_D2D?: InputMaybe<Scalars['Boolean']>;
  with_reservable_extras?: InputMaybe<Scalars['Boolean']>;
  zone_id?: InputMaybe<Scalars['ID']>;
};


export type QueryPageDetailArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPopularRestaurantsArgs = {
  region_id: Scalars['ID'];
};


export type QueryPopularTagsArgs = {
  region_id: Scalars['ID'];
};


export type QueryRandomIncomingEventArgs = {
  region_id?: InputMaybe<Scalars['ID']>;
  slotless?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<InputMaybe<TagFilter>>>;
};


export type QueryRegionsArgs = {
  visible?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRegulationsArgs = {
  festivalEditionId: Scalars['ID'];
};


export type QueryReservableArgs = {
  id: Scalars['ID'];
  type: ReservableEnum;
};


export type QueryReservableExtraArgs = {
  id: Scalars['ID'];
};


export type QueryReservableExtrasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date_range?: InputMaybe<DateRange>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  regionIds?: InputMaybe<Array<Scalars['ID']>>;
  restaurantIds?: InputMaybe<Array<Scalars['ID']>>;
  restaurant_tags?: InputMaybe<Array<InputMaybe<TagFilter>>>;
  slot_range?: InputMaybe<SlotRange>;
  type?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryReservablesArgs = {
  dates: DateRange;
  restaurantId: Scalars['ID'];
};


export type QueryReservationArgs = {
  code?: InputMaybe<Scalars['String']>;
  securityToken?: InputMaybe<Scalars['String']>;
};


export type QueryReservationCancellationDeadlineArgs = {
  code: Scalars['String'];
};


export type QueryReservationPossibilityArgs = {
  approxStartAt: Scalars['Int'];
  date: Scalars['Date'];
  isDefinitive?: InputMaybe<Scalars['Boolean']>;
  num_people: Scalars['Int'];
  reservable_id: Scalars['ID'];
  reservation_id?: InputMaybe<Scalars['ID']>;
  restaurant_id: Scalars['ID'];
};


export type QueryResolveUrlSlugArgs = {
  slug: Scalars['String'];
};


export type QueryRestaurantArgs = {
  id: Scalars['ID'];
};


export type QueryRestaurantLinkArgs = {
  restaurant_id: Scalars['ID'];
};


export type QueryRestaurantReservationsArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type QueryRestaurantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  collection_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  festival_edition_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  in_area?: InputMaybe<Area>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<RestaurantsOrderBy>>;
  region_id?: InputMaybe<Scalars['ID']>;
  reservables?: InputMaybe<Array<ReservableInput>>;
  reservation_filters?: InputMaybe<ReservationFilter>;
  sort?: InputMaybe<RestaurantSort>;
  tag_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags?: InputMaybe<Array<InputMaybe<TagFilter>>>;
  with_D2D?: InputMaybe<Scalars['Boolean']>;
  with_reservable_extras?: InputMaybe<Scalars['Boolean']>;
  zone_id?: InputMaybe<Scalars['ID']>;
};


export type QueryRulesArgs = {
  dates?: InputMaybe<DateRange>;
  restaurantId: Scalars['ID'];
};


export type QuerySearchArgs = {
  regionId?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
};


export type QuerySectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QuerySlotDiscountRuleArgs = {
  id: Scalars['ID'];
};


export type QuerySlotDiscountRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySlotsArgs = {
  dates: DateRange;
  reservables: Array<ReservableInput>;
  withReservableExtra?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySlotsUsageArgs = {
  dateRange?: InputMaybe<DateRange>;
  restaurantId: Scalars['ID'];
};


export type QuerySponsorArgs = {
  id: Scalars['ID'];
};


export type QuerySponsorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clubSponsors?: InputMaybe<Scalars['Boolean']>;
  festivalEditionId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<SponsorsOrderBy>>;
  regionId?: InputMaybe<Scalars['ID']>;
};


export type QueryStrapiArgs = {
  query: Scalars['String'];
};


export type QuerySubmissionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SubmissionsOrderBy>>;
};


export type QueryTagsArgs = {
  festivalEditionId?: InputMaybe<Scalars['ID']>;
  regionId?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  role?: InputMaybe<RoleEnum>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryVoucherArgs = {
  code: Scalars['String'];
};

export type RatingAttributes = {
  atmosphere?: InputMaybe<Scalars['Int']>;
  delivery?: InputMaybe<Scalars['Int']>;
  dessert?: InputMaybe<Scalars['Int']>;
  mainDish?: InputMaybe<Scalars['Int']>;
  meals?: InputMaybe<Scalars['Int']>;
  menu?: InputMaybe<MenuKindEnum>;
  package?: InputMaybe<Scalars['Int']>;
  sideDish?: InputMaybe<Scalars['Int']>;
  staff?: InputMaybe<Scalars['Int']>;
};

export type RatingData = {
  __typename?: 'RatingData';
  atmosphere?: Maybe<Scalars['Int']>;
  currentTenant: Scalars['String'];
  delivery?: Maybe<Scalars['Int']>;
  dessert?: Maybe<Scalars['Int']>;
  mainDish?: Maybe<Scalars['Int']>;
  meals?: Maybe<Scalars['Int']>;
  menu?: Maybe<MenuKindEnum>;
  menuRating?: Maybe<Scalars['Int']>;
  package?: Maybe<Scalars['Int']>;
  sideDish?: Maybe<Scalars['Int']>;
  staff?: Maybe<Scalars['Int']>;
};

/** Something able to be exchanged for goods, a discount, or money */
export type Redeemable = {
  billingMethod: DiscountBillingMethodEnum;
  category: DiscountCategoryEnum;
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  discountAssignments: Array<DiscountAssignment>;
  enabled: Scalars['Boolean'];
  events: Array<FestivalEdition>;
  expired: Scalars['ISO8601DateTime'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated Use festivalEditions */
  festivalEdition?: Maybe<FestivalEdition>;
  festivalEditions: Array<FestivalEdition>;
  id: Scalars['ID'];
  isCustomCode: Scalars['Boolean'];
  marketingConsentRequired: Scalars['Boolean'];
  maxMenuPrice?: Maybe<Scalars['Int']>;
  maxUsesCount: Scalars['Int'];
  minMenuPrice?: Maybe<Scalars['Int']>;
  minPeopleCount?: Maybe<Scalars['Int']>;
  minPeopleCountEnabled: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  order: Order;
  pdfUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use value */
  peopleCount: Scalars['Int'];
  permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum>;
  permittedSources: Array<ReservationSourceEnum>;
  primeTimeIncluded: Scalars['Boolean'];
  singleUse: Scalars['Boolean'];
  slots?: Maybe<Array<Scalars['Int']>>;
  /** TOTAL or PERCENT */
  type: Scalars['String'];
  used: Scalars['Int'];
  user?: Maybe<User>;
  value: Scalars['Float'];
  weekDays: Array<WeekDayEnum>;
};

/** An edge in a connection. */
export type RedeemableEdge = {
  __typename?: 'RedeemableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Redeemable>;
};

/** The connection type for Redeemable. */
export type Redeemables = {
  __typename?: 'Redeemables';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RedeemableEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Redeemable>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Region = {
  __typename?: 'Region';
  currentTenant: Scalars['String'];
  eventsEnabled: Scalars['Boolean'];
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
  zones: Array<Zone>;
};

export enum RegulationStatusEnum {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  NotAccepted = 'NOT_ACCEPTED'
}

export type Reservable = Daily | Event | FestivalEditionRestaurant;

export enum ReservableEnum {
  Daily = 'Daily',
  Event = 'Event',
  FestivalEditionRestaurant = 'FestivalEditionRestaurant'
}

export type ReservableExtra = {
  __typename?: 'ReservableExtra';
  currentTenant: Scalars['String'];
  defaultReservableFrom: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  eatingDuration: Scalars['Int'];
  editableByRestaurateur: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  image?: Maybe<ImageFile>;
  menus?: Maybe<Array<Menu>>;
  name: Scalars['String'];
  price: Scalars['Float'];
  promoted: Scalars['Boolean'];
  reservableFrom: Scalars['ISO8601DateTime'];
  restaurant: Restaurant;
  rules: Array<ReservableExtraRule>;
  slug: Scalars['String'];
  /** @deprecated There will be only one type of RE */
  type: Scalars['String'];
};

export type ReservableExtraAssignment = {
  __typename?: 'ReservableExtraAssignment';
  currentTenant: Scalars['String'];
  menu: Menu;
  menuId: Scalars['ID'];
  quantity: Scalars['Int'];
  reservableExtra: ReservableExtra;
  reservableExtraId: Scalars['ID'];
};

export type ReservableExtraAttrInput = {
  menuId: Scalars['ID'];
  quantity: Scalars['Int'];
  reservableExtraId: Scalars['ID'];
};

/** An edge in a connection. */
export type ReservableExtraEdge = {
  __typename?: 'ReservableExtraEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ReservableExtra>;
};

export type ReservableExtraRule = {
  __typename?: 'ReservableExtraRule';
  active: Scalars['Boolean'];
  currentTenant: Scalars['String'];
  enabled: Scalars['Boolean'];
  endsAt: Scalars['Int'];
  endsOn?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  startsAt: Scalars['Int'];
  startsOn: Scalars['Date'];
  weekDays?: Maybe<Array<WeekDayEnum>>;
  weekdaysFlags: Scalars['Int'];
};

/** The connection type for ReservableExtra. */
export type ReservableExtras = {
  __typename?: 'ReservableExtras';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReservableExtraEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ReservableExtra>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ReservableInput = {
  id: Scalars['ID'];
  type: ReservableEnum;
};

export type Reservation = {
  __typename?: 'Reservation';
  adminNotes?: Maybe<Scalars['String']>;
  autoDiscountsAvailable: Array<ProviderSpecificPaymentMethodEnum>;
  canBeCancelled: Scalars['Boolean'];
  canBeDiscounted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  date: Scalars['Date'];
  deliveryAddress?: Maybe<DeliveryAddress>;
  discount?: Maybe<Redeemable>;
  email?: Maybe<Scalars['String']>;
  expired: Scalars['Boolean'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  festivalDrinkRequiredQuantity: Scalars['Int'];
  guestInvitationUrl?: Maybe<Scalars['String']>;
  hall?: Maybe<Scalars['String']>;
  hasReservableExtra: Scalars['Boolean'];
  hour: Scalars['String'];
  id: Scalars['ID'];
  lastOrderPrice?: Maybe<Scalars['Float']>;
  logEntries?: Maybe<Array<ProductableLogEntry>>;
  menus: Array<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  orders: Array<Order>;
  passed: Scalars['Boolean'];
  paymentMethod: Scalars['String'];
  peopleCount: Scalars['Int'];
  permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum>;
  previousReservation?: Maybe<Reservation>;
  priceValues: PriceValues;
  reservable?: Maybe<Reservable>;
  reservableExtraAssignments?: Maybe<Array<ReservableExtraAssignment>>;
  reservableExtras: Array<ReservableExtra>;
  reservableExtrasAvailable: Scalars['Boolean'];
  reservationCrossSells?: Maybe<Array<ReservationCrossSell>>;
  reservationEditUrl?: Maybe<Scalars['String']>;
  reservationGuests: Array<ReservationGuest>;
  reservationSummarySheet: Array<ReservationSummarySheet>;
  reservationType: ReservationTypeEnum;
  restauratorNotes?: Maybe<Scalars['String']>;
  review?: Maybe<Review>;
  slot: Scalars['Int'];
  slotDiscountValue: Scalars['Int'];
  status: OrderStatusEnum;
  statusDetails?: Maybe<OrderStatusDetailsEnum>;
  table?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  vatId?: Maybe<Scalars['String']>;
};

export type ReservationClosingRule = {
  __typename?: 'ReservationClosingRule';
  currentTenant: Scalars['String'];
  daysOffset: Scalars['Int'];
  minutesSinceMidnight: Scalars['Int'];
};

export type ReservationCrossSell = {
  __typename?: 'ReservationCrossSell';
  crossSell: CrossSell;
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
  isApplicable: Scalars['Boolean'];
  quantity: Scalars['Int'];
  reservation: Reservation;
};

export type ReservationFilter = {
  endsOn: Scalars['Date'];
  hours: Array<Scalars['Int']>;
  peopleCount: Scalars['Int'];
  reservableType?: InputMaybe<ReservableEnum>;
  startsOn: Scalars['Date'];
};

export type ReservationGuest = {
  __typename?: 'ReservationGuest';
  confirmedAt?: Maybe<Scalars['Date']>;
  currentTenant: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  reservationId: Scalars['ID'];
  user?: Maybe<User>;
};

export type ReservationHourAvailability = {
  __typename?: 'ReservationHourAvailability';
  available: Scalars['Boolean'];
  currentTenant: Scalars['String'];
  hour: Scalars['String'];
  hourAsSlot: Scalars['Int'];
};

export enum ReservationNotificationTypeEnum {
  UserConfirmationEmail = 'USER_CONFIRMATION_EMAIL'
}

export type ReservationPossibility = {
  __typename?: 'ReservationPossibility';
  availableReservableExtras: Array<ReservableExtra>;
  currentTenant: Scalars['String'];
  hoursAvailability: Array<ReservationHourAvailability>;
  reservation: Reservation;
  reservationPossible: Scalars['Boolean'];
};

export enum ReservationSourceEnum {
  Android = 'ANDROID',
  AutoEmail = 'AUTO_EMAIL',
  AutoFacebook = 'AUTO_FACEBOOK',
  AutoInstagram = 'AUTO_INSTAGRAM',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  Instagram = 'INSTAGRAM',
  Ios = 'IOS',
  Mobile = 'MOBILE',
  Other = 'OTHER',
  Phone = 'PHONE',
  QrCode = 'QR_CODE',
  SignEmail = 'SIGN_EMAIL',
  Web = 'WEB'
}

export enum ReservationSummaryIdentifier {
  CrossSell = 'CROSS_SELL',
  Discount = 'DISCOUNT',
  Menu = 'MENU',
  PrimeTimeFee = 'PRIME_TIME_FEE',
  ReservationFee = 'RESERVATION_FEE',
  Summary = 'SUMMARY'
}

export type ReservationSummarySheet = {
  __typename?: 'ReservationSummarySheet';
  currentTenant: Scalars['String'];
  details?: Maybe<Scalars['String']>;
  identifier: ReservationSummaryIdentifier;
  label: Scalars['String'];
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Int']>;
};

export enum ReservationTypeEnum {
  Delivery = 'DELIVERY',
  Onsite = 'ONSITE',
  TakeAway = 'TAKE_AWAY'
}

/** The connection type for Reservation. */
export type Reservations = {
  __typename?: 'Reservations';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReservationsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Reservation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ReservationsData = {
  __typename?: 'ReservationsData';
  allocationsCount: Scalars['Int'];
  currentTenant: Scalars['String'];
  date: Scalars['Date'];
  dayOfWeek: Scalars['Int'];
  income: Scalars['Float'];
  name: Scalars['String'];
  peopleCount: Scalars['Int'];
  reservationCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ReservationsEdge = {
  __typename?: 'ReservationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Reservation>;
};

/** Autogenerated return type of ResetPasswordRequest */
export type ResetPasswordRequestPayload = {
  __typename?: 'ResetPasswordRequestPayload';
  sent: Scalars['Boolean'];
};

export type Restaurant = {
  __typename?: 'Restaurant';
  additionalEmail?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  billingData?: Maybe<RestaurantBillingData>;
  capacity?: Maybe<Scalars['Int']>;
  chef?: Maybe<Scalars['String']>;
  chefSocialMediaUrl?: Maybe<Scalars['String']>;
  clubAgreement?: Maybe<Agreement>;
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  draft?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  establishmentYear?: Maybe<Scalars['Int']>;
  externalSourceUrls: Array<RestaurantExternalSourceUrl>;
  facebookUrl?: Maybe<Scalars['String']>;
  favorited: Scalars['Boolean'];
  festivalEditionRestaurants: Array<FestivalEditionRestaurant>;
  forceClubAgreement: Scalars['Boolean'];
  hidden: Scalars['Boolean'];
  hours: Array<Scalars['String']>;
  id: Scalars['ID'];
  imageFiles: Array<ImageFile>;
  incomingChanges?: Maybe<RestaurantChanges>;
  instagramUrl?: Maybe<Scalars['String']>;
  interiorDesigner?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  menuFile?: Maybe<PdfFile>;
  menuFileUrl?: Maybe<Scalars['String']>;
  metadatas: Array<Metadata>;
  name: Scalars['String'];
  nearestFestivalEdition?: Maybe<FestivalEdition>;
  notificationNumber?: Maybe<Scalars['String']>;
  notificationNumberCountryCode?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Array<Hours>>;
  openingHoursToday?: Maybe<Hours>;
  openingState: Scalars['String'];
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  rating?: Maybe<Scalars['Float']>;
  ratingCount: Scalars['Int'];
  region: Region;
  reservableExtras: Array<ReservableExtra>;
  reservables: Array<Reservable>;
  restaurantDeliveryZones: Array<RestaurantDeliveryZone>;
  restaurateurSocialMediaUrl?: Maybe<Scalars['String']>;
  restaurator?: Maybe<Scalars['String']>;
  restaurators: Array<User>;
  reviews: Array<Review>;
  salesforceId?: Maybe<Scalars['ID']>;
  slotDuration: Scalars['Int'];
  slots: Array<SlotDefinition>;
  slug: Scalars['String'];
  status: Scalars['String'];
  submission?: Maybe<Submission>;
  tables: Array<Table>;
  tags: Array<Tag>;
  updatedAt: Scalars['ISO8601DateTime'];
  urls?: Maybe<Array<RestaurantUrl>>;
  userAgreedToReceiveMarketing?: Maybe<Scalars['Boolean']>;
  validClubAgreement: Scalars['Boolean'];
  webUrl?: Maybe<Scalars['String']>;
  zone: Zone;
};


export type RestaurantHoursArgs = {
  weekDay: Scalars['Int'];
};


export type RestaurantImageFilesArgs = {
  scope?: InputMaybe<RestaurantImageScopesEnum>;
};


export type RestaurantReservableExtrasArgs = {
  visible?: InputMaybe<Scalars['String']>;
};

export type RestaurantBillingData = {
  __typename?: 'RestaurantBillingData';
  bankAccountNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyType?: Maybe<CompanyTypeEnum>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
  phoneCountryCode?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  representName?: Maybe<Scalars['String']>;
  restaurant?: Maybe<Restaurant>;
  street?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
};

export type RestaurantChanges = {
  __typename?: 'RestaurantChanges';
  additionalEmail?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  chef?: Maybe<Scalars['String']>;
  chefSocialMediaUrl?: Maybe<Scalars['String']>;
  currentTenant: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  establishmentYear?: Maybe<Scalars['Int']>;
  facebookUrl?: Maybe<Scalars['String']>;
  imageFiles?: Maybe<Array<ImageFile>>;
  instagramUrl?: Maybe<Scalars['String']>;
  interiorDesigner?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /** @deprecated Renamed to capacity */
  maxPeopleCount?: Maybe<Scalars['Int']>;
  menuFile?: Maybe<PdfFile>;
  name?: Maybe<Scalars['String']>;
  notificationNumber?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Array<OpeningHoursChanges>>;
  phoneNumber?: Maybe<Scalars['String']>;
  restaurantBillingData?: Maybe<BillingDataChanges>;
  restaurantDeliveryZones?: Maybe<Array<RestaurantDeliveryZoneChanges>>;
  restaurateurSocialMediaUrl?: Maybe<Scalars['String']>;
  restaurator?: Maybe<Scalars['String']>;
  tables?: Maybe<Array<TableChanges>>;
  tagIds?: Maybe<Array<Scalars['ID']>>;
  zone?: Maybe<Zone>;
};

export type RestaurantDeliveryZone = {
  __typename?: 'RestaurantDeliveryZone';
  color?: Maybe<Scalars['String']>;
  currentTenant: Scalars['String'];
  deliveryRadius: Scalars['Int'];
  label: Scalars['String'];
  price: Scalars['Float'];
};

export type RestaurantDeliveryZoneChanges = {
  __typename?: 'RestaurantDeliveryZoneChanges';
  color?: Maybe<Scalars['String']>;
  currentTenant: Scalars['String'];
  deliveryRadius: Scalars['Int'];
  label: Scalars['String'];
  price: Scalars['Float'];
};

export type RestaurantExternalSourceUrl = {
  __typename?: 'RestaurantExternalSourceUrl';
  currentTenant: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export enum RestaurantImageScopesEnum {
  Restaurant = 'RESTAURANT',
  WithAllFers = 'WITH_ALL_FERS',
  WithFer = 'WITH_FER'
}

export enum RestaurantOrderField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export enum RestaurantSort {
  Distance = 'DISTANCE',
  MostScored = 'MOST_SCORED',
  Position = 'POSITION',
  Rating = 'RATING'
}

export type RestaurantUrl = {
  __typename?: 'RestaurantUrl';
  currentTenant: Scalars['String'];
  restaurant: Restaurant;
  url: Scalars['String'];
  urlType: RestaurantUrlTypeEnum;
};

export enum RestaurantUrlTypeEnum {
  ChefSocialMedia = 'CHEF_SOCIAL_MEDIA',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  Instagram = 'INSTAGRAM',
  RestaurateurSocialMedia = 'RESTAURATEUR_SOCIAL_MEDIA',
  Tiktok = 'TIKTOK',
  TripAdvisor = 'TRIP_ADVISOR',
  Website = 'WEBSITE'
}

/** The connection type for Restaurant. */
export type Restaurants = {
  __typename?: 'Restaurants';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RestaurantsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Restaurant>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type RestaurantsEdge = {
  __typename?: 'RestaurantsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Restaurant>;
};

export type RestaurantsOrderBy = {
  direction: OrderDirection;
  field: RestaurantOrderField;
};

export type Review = {
  __typename?: 'Review';
  /** @deprecated Deprecated */
  atmosphereRating?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
  liked: Scalars['Boolean'];
  /** @deprecated Deprecated */
  menuRating?: Maybe<Scalars['Int']>;
  moderatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  rating: Scalars['Int'];
  ratings: RatingData;
  reservation: Reservation;
  /** @deprecated Warning, this will be deprecated */
  restaurant: Restaurant;
  /** @deprecated Deprecated */
  staffRating?: Maybe<Scalars['Int']>;
  status?: Maybe<ReviewStatusEnum>;
  text?: Maybe<Scalars['String']>;
  user: User;
};

export enum ReviewOrder {
  Recent = 'RECENT'
}

export enum ReviewStatusEnum {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** The connection type for Review. */
export type Reviews = {
  __typename?: 'Reviews';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReviewsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Review>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ReviewsEdge = {
  __typename?: 'ReviewsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Review>;
};

export enum RoleEnum {
  Admin = 'ADMIN',
  Manager = 'MANAGER',
  Restaurator = 'RESTAURATOR',
  User = 'USER'
}

export type Rule = {
  __typename?: 'Rule';
  active: Scalars['Boolean'];
  currentTenant: Scalars['String'];
  endsOn: Scalars['Date'];
  id: Scalars['ID'];
  reservable: Reservable;
  slots: Array<Scalars['Int']>;
  startsOn: Scalars['Date'];
  weekDays?: Maybe<Array<WeekDay>>;
};

/** Objects which may be returned by search query */
export type SearchResult = Collection | Restaurant | Tag;

export type SeatsData = {
  __typename?: 'SeatsData';
  allocCapacityPercent: Scalars['Float'];
  currentTenant: Scalars['String'];
  freeSeatsCount: Scalars['Int'];
  maximalCapacity: Scalars['Int'];
  seatsCount: Scalars['Int'];
  soldCapacityRatio: Scalars['Float'];
  takenSeatsCount: Scalars['Int'];
};

export type Section = {
  __typename?: 'Section';
  banners: Array<Banner>;
  collections: Array<PolymorphicCollection>;
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** An edge in a connection. */
export type SectionEdge = {
  __typename?: 'SectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Section>;
};

/** The connection type for Section. */
export type Sections = {
  __typename?: 'Sections';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SectionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Section>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Session = {
  __typename?: 'Session';
  clientToken: Scalars['String'];
  currentTenant: Scalars['String'];
  payload: Scalars['JSON'];
  paymentMethodCategories?: Maybe<Scalars['JSON']>;
  sessionId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SignIn */
export type SignInPayload = {
  __typename?: 'SignInPayload';
  authToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type Slot = {
  __typename?: 'Slot';
  allocated: Scalars['Int'];
  currentTenant: Scalars['String'];
  date: Scalars['Date'];
  debugInfo?: Maybe<Scalars['JSON']>;
  discount: Scalars['Int'];
  duration: Scalars['Int'];
  inProgress: Scalars['Int'];
  interval: Scalars['Int'];
  paid: Scalars['Int'];
  primeTimeFee?: Maybe<Scalars['Float']>;
  reservable?: Maybe<Reservable>;
  runningOut: Scalars['Boolean'];
  sizes: Array<Scalars['Int']>;
  slot: Scalars['Int'];
  used: Scalars['Int'];
  voucherRequired: Scalars['Boolean'];
};

export type SlotDefinition = {
  __typename?: 'SlotDefinition';
  currentTenant: Scalars['String'];
  duration: Scalars['Int'];
  hours: Array<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  interval: Scalars['Int'];
  possibleSlots: Array<Scalars['Int']>;
  slotEnd: Scalars['Int'];
  slotStart: Scalars['Int'];
  slotable: Slotable;
  weekDay?: Maybe<Scalars['Int']>;
};

export type SlotDiscountRule = {
  __typename?: 'SlotDiscountRule';
  currentTenant: Scalars['String'];
  discount: Scalars['Float'];
  enabled: Scalars['Boolean'];
  endsOn?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  slotEnd?: Maybe<Scalars['Int']>;
  slotStart?: Maybe<Scalars['Int']>;
  startsOn?: Maybe<Scalars['Date']>;
};

/** The connection type for SlotDiscountRule. */
export type SlotDiscountRules = {
  __typename?: 'SlotDiscountRules';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SlotDiscountRulesEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SlotDiscountRule>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SlotDiscountRulesEdge = {
  __typename?: 'SlotDiscountRulesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SlotDiscountRule>;
};

export type SlotRange = {
  slotFrom: Scalars['Int'];
  slotTo: Scalars['Int'];
};

/** Slot Definition can be assigned to FestivalEdition, Restaurant or Event */
export type Slotable = Daily | Event | FestivalEdition | Restaurant;

export type SlotsData = {
  __typename?: 'SlotsData';
  allocationsCount: Scalars['Int'];
  currentTenant: Scalars['String'];
  dayOfWeek: Scalars['Int'];
  peopleCount: Scalars['Int'];
  reservationsCount: Scalars['Int'];
  slot: Scalars['Int'];
};

export type Sponsor = {
  __typename?: 'Sponsor';
  currentTenant: Scalars['String'];
  festivalEditions?: Maybe<Array<FestivalEdition>>;
  id: Scalars['ID'];
  image?: Maybe<ImageFile>;
  kind: SponsorKindsEnum;
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  region?: Maybe<Region>;
  subkind?: Maybe<SponsorSubkindsEnum>;
  url?: Maybe<Scalars['String']>;
};

export enum SponsorKindsEnum {
  Main = 'MAIN',
  Partner = 'PARTNER',
  Patron = 'PATRON',
  PlebiscitePartner = 'PLEBISCITE_PARTNER',
  Regional = 'REGIONAL'
}

export enum SponsorOrderField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export enum SponsorSubkindsEnum {
  Aerial = 'AERIAL',
  Cocktail = 'COCKTAIL',
  Culinary = 'CULINARY',
  Edition = 'EDITION',
  Logistical = 'LOGISTICAL',
  Media = 'MEDIA',
  Regular = 'REGULAR'
}

/** The connection type for Sponsor. */
export type Sponsors = {
  __typename?: 'Sponsors';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SponsorsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Sponsor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SponsorsEdge = {
  __typename?: 'SponsorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Sponsor>;
};

export type SponsorsOrderBy = {
  direction: OrderDirection;
  field: SponsorOrderField;
};

export enum StatusableEnum {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  Pending = 'PENDING'
}

export type Submission = {
  __typename?: 'Submission';
  currentTenant: Scalars['String'];
  draft: Scalars['Boolean'];
  id: Scalars['ID'];
  submissionable: Submissionable;
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum SubmissionOrderField {
  CreatedAt = 'CREATED_AT'
}

/** Objects which may be referenced submissionable of submission */
export type Submissionable = FestivalEditionRestaurant | Restaurant;

/** The connection type for Submission. */
export type Submissions = {
  __typename?: 'Submissions';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubmissionsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Submission>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SubmissionsEdge = {
  __typename?: 'SubmissionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Submission>;
};

export type SubmissionsOrderBy = {
  direction: OrderDirection;
  field: SubmissionOrderField;
};

export type Table = {
  __typename?: 'Table';
  amount: Scalars['Int'];
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
  isModular: Scalars['Boolean'];
  peopleCount: Scalars['Int'];
  restaurant: Restaurant;
};

export type TableChanges = {
  __typename?: 'TableChanges';
  amount?: Maybe<Scalars['Int']>;
  currentTenant: Scalars['String'];
  peopleCount?: Maybe<Scalars['Int']>;
};

export type Tag = {
  __typename?: 'Tag';
  currentTenant: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<TagIconEnum>;
  id: Scalars['ID'];
  name: Scalars['String'];
  position: Scalars['Int'];
  tagCount: Scalars['Int'];
  type: Scalars['String'];
};

export type TagFilter = {
  id: Scalars['ID'];
  type: Scalars['String'];
};

export enum TagIconEnum {
  IconFoodRestrictionFish = 'icon_food_restriction_fish',
  IconFoodRestrictionFlexitarian = 'icon_food_restriction_flexitarian',
  IconFoodRestrictionGeneric = 'icon_food_restriction_generic',
  IconFoodRestrictionGlutenFree = 'icon_food_restriction_gluten_free',
  IconFoodRestrictionHealthy = 'icon_food_restriction_healthy',
  IconFoodRestrictionLactoseFree = 'icon_food_restriction_lactose_free',
  IconFoodRestrictionVegan = 'icon_food_restriction_vegan',
  IconFoodRestrictionVege = 'icon_food_restriction_vege'
}

export type UrlResolverResult = {
  __typename?: 'UrlResolverResult';
  currentTenant: Scalars['String'];
  defaultSlug?: Maybe<Scalars['String']>;
  objectId: Scalars['ID'];
  objectType: Scalars['String'];
  slug: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  accessLevel: RoleEnum;
  agreedForMarketingFromRestaurant: Scalars['Boolean'];
  anonymous: Scalars['Boolean'];
  blocked: Scalars['Boolean'];
  card?: Maybe<Card>;
  cards?: Maybe<Array<Card>>;
  consents: Array<UserConsent>;
  currentTenant: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hasMarketingConsent: Scalars['Boolean'];
  hasPernodConsent: Scalars['Boolean'];
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  metadatas: Array<Metadata>;
  payuCards?: Maybe<Array<PayuCard>>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberVerified?: Maybe<Scalars['Boolean']>;
  regions: Array<Region>;
  regulationStatus: RegulationStatusEnum;
  restaurants: Array<Restaurant>;
  /** @deprecated Use access_level instead. */
  role: Scalars['String'];
  salesmanagoContactId?: Maybe<Scalars['String']>;
  subscribed: Scalars['Boolean'];
  verified: Scalars['Boolean'];
};


export type UserAgreedForMarketingFromRestaurantArgs = {
  restaurantId: Scalars['ID'];
};

export type UserAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UserConsent = {
  __typename?: 'UserConsent';
  consentSubtype?: Maybe<UserConsentSubtypeEnum>;
  consentType: UserConsentTypeEnum;
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
};

export type UserConsentInput = {
  consentSubtype?: InputMaybe<UserConsentSubtypeEnum>;
  consentType: UserConsentTypeEnum;
  given: Scalars['Boolean'];
};

export enum UserConsentSubtypeEnum {
  Pernod = 'PERNOD'
}

export enum UserConsentTypeEnum {
  GdprConsent = 'GDPR_CONSENT',
  MarketingConsent = 'MARKETING_CONSENT',
  PartnerConsent = 'PARTNER_CONSENT',
  RcRegulationConsent = 'RC_REGULATION_CONSENT',
  RestaurantMarketingConsent = 'RESTAURANT_MARKETING_CONSENT'
}

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export enum UserOrderField {
  CreatedAt = 'CREATED_AT'
}

export type UserPurchase = PercentageCoupon | Reservation | ValueCoupon | Voucher;

/** The connection type for UserPurchase. */
export type UserPurchases = {
  __typename?: 'UserPurchases';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserPurchasesEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserPurchase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserPurchasesEdge = {
  __typename?: 'UserPurchasesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<UserPurchase>;
};

/** The connection type for User. */
export type Users = {
  __typename?: 'Users';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UsersData = {
  __typename?: 'UsersData';
  currentTenant: Scalars['String'];
  newUsersCount: Scalars['Int'];
  oldUsersCount: Scalars['Int'];
  usersCount: Scalars['Int'];
};

export type UsersOrderBy = {
  direction: OrderDirection;
  field: UserOrderField;
};

export type ValueCoupon = Redeemable & {
  __typename?: 'ValueCoupon';
  billingMethod: DiscountBillingMethodEnum;
  category: DiscountCategoryEnum;
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  discountAssignments: Array<DiscountAssignment>;
  enabled: Scalars['Boolean'];
  events: Array<FestivalEdition>;
  expired: Scalars['ISO8601DateTime'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated Use festivalEditions */
  festivalEdition?: Maybe<FestivalEdition>;
  festivalEditions: Array<FestivalEdition>;
  id: Scalars['ID'];
  isCustomCode: Scalars['Boolean'];
  marketingConsentRequired: Scalars['Boolean'];
  maxMenuPrice?: Maybe<Scalars['Int']>;
  maxUsesCount: Scalars['Int'];
  metadatas: Array<Metadata>;
  minMenuPrice?: Maybe<Scalars['Int']>;
  minPeopleCount?: Maybe<Scalars['Int']>;
  minPeopleCountEnabled: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  order: Order;
  pdfUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use value */
  peopleCount: Scalars['Int'];
  permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum>;
  permittedSources: Array<ReservationSourceEnum>;
  primeTimeIncluded: Scalars['Boolean'];
  singleUse: Scalars['Boolean'];
  slots?: Maybe<Array<Scalars['Int']>>;
  /** TOTAL or PERCENT */
  type: Scalars['String'];
  used: Scalars['Int'];
  user?: Maybe<User>;
  value: Scalars['Float'];
  weekDays: Array<WeekDayEnum>;
};

export type Voucher = Redeemable & {
  __typename?: 'Voucher';
  billingMethod: DiscountBillingMethodEnum;
  category: DiscountCategoryEnum;
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  currentTenant: Scalars['String'];
  discountAssignments: Array<DiscountAssignment>;
  email?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  events: Array<FestivalEdition>;
  expired: Scalars['ISO8601DateTime'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated Use festivalEditions */
  festivalEdition?: Maybe<FestivalEdition>;
  festivalEditions: Array<FestivalEdition>;
  id: Scalars['ID'];
  isCustomCode: Scalars['Boolean'];
  marketingConsentRequired: Scalars['Boolean'];
  maxMenuPrice?: Maybe<Scalars['Int']>;
  maxUsesCount: Scalars['Int'];
  minMenuPrice?: Maybe<Scalars['Int']>;
  minPeopleCount?: Maybe<Scalars['Int']>;
  minPeopleCountEnabled: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  order: Order;
  pdfUrl?: Maybe<Scalars['String']>;
  peopleCount: Scalars['Int'];
  permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum>;
  permittedSources: Array<ReservationSourceEnum>;
  primeTimeIncluded: Scalars['Boolean'];
  singleUse: Scalars['Boolean'];
  slots?: Maybe<Array<Scalars['Int']>>;
  status?: Maybe<OrderStatusEnum>;
  /** TOTAL or PERCENT */
  type: Scalars['String'];
  used: Scalars['Int'];
  user?: Maybe<User>;
  value: Scalars['Float'];
  weekDays: Array<WeekDayEnum>;
};

export type WeekDay = {
  __typename?: 'WeekDay';
  currentTenant: Scalars['String'];
  hourRanges?: Maybe<Array<HourRange>>;
  wday: WeekDayEnum;
};

export enum WeekDayEnum {
  All = 'all',
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Sunday = 'sunday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday'
}

export type Zone = {
  __typename?: 'Zone';
  currentTenant: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  region: Region;
};

export type AcceptRegulationMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptRegulationMutation = { __typename?: 'Mutation', acceptRegulation: { __typename?: 'User', id: string, verified: boolean, subscribed: boolean, regulationStatus: RegulationStatusEnum } };

export type CreateReviewMutationVariables = Exact<{
  text: Scalars['String'];
  code: Scalars['String'];
  ratings: RatingAttributes;
  securityToken?: InputMaybe<Scalars['String']>;
}>;


export type CreateReviewMutation = { __typename?: 'Mutation', createReview: { __typename?: 'Review', id: string } };

export type CreateUserMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  marketingConsentAccepted?: InputMaybe<Scalars['Boolean']>;
  regulationConsentAccepted?: InputMaybe<Scalars['Boolean']>;
  anonymous?: InputMaybe<Scalars['Boolean']>;
  consents?: InputMaybe<Array<UserConsentInput> | UserConsentInput>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CreateUserPayload', user?: { __typename?: 'User', id: string, email?: string | null, phoneNumber?: string | null, firstName?: string | null, lastName?: string | null, verified: boolean, salesmanagoContactId?: string | null, regulationStatus: RegulationStatusEnum, hasMarketingConsent: boolean, hasPernodConsent: boolean, anonymous: boolean } | null } };

export type ResetPasswordRequestMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetPasswordRequestMutation = { __typename?: 'Mutation', resetPasswordRequest: { __typename?: 'ResetPasswordRequestPayload', sent: boolean } };

export type SetPasswordMutationVariables = Exact<{
  resetPasswordToken: Scalars['String'];
  password: Scalars['String'];
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword: { __typename?: 'User', id: string } };

export type SignInMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn?: { __typename?: 'SignInPayload', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, verified: boolean, salesmanagoContactId?: string | null, regulationStatus: RegulationStatusEnum } | null } | null };

export type SignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutMutation = { __typename?: 'Mutation', signOut: boolean };

export type UpdateUserMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  hasMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  consents?: InputMaybe<Array<UserConsentInput> | UserConsentInput>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, hasMarketingConsent: boolean, hasPernodConsent: boolean, subscribed: boolean } };

export type AddReservationGuestMutationVariables = Exact<{
  reservationId: Scalars['ID'];
  email: Scalars['String'];
}>;


export type AddReservationGuestMutation = { __typename?: 'Mutation', addReservationGuest: { __typename?: 'ReservationGuest', email: string, id: string, confirmedAt?: string | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, id: string } | null } };

export type ConfirmReservationMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type ConfirmReservationMutation = { __typename?: 'Mutation', confirmManualReservation: { __typename?: 'ManualReservation', id: string, code: string, confirmed: boolean, date: string, username: string, phoneNumber: string, peopleCount: number, hour: string, slot: number, slotDuration: number, restaurant: { __typename?: 'Restaurant', id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } } };

export type RememberMeMutationVariables = Exact<{
  code: Scalars['String'];
  email: Scalars['String'];
  rodoConsent?: InputMaybe<Scalars['Boolean']>;
  marketingConsent?: InputMaybe<Scalars['Boolean']>;
}>;


export type RememberMeMutation = { __typename?: 'Mutation', rememberMe: { __typename?: 'ManualReservation', id: string } };

export type ConfirmReservationGuestMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ConfirmReservationGuestMutation = { __typename?: 'Mutation', confirmReservationGuest: { __typename?: 'ReservationGuest', email: string, id: string } };

export type InviteDataFragment = { __typename?: 'Reservation', id: string, canBeUpdated: boolean, canBeCancelled: boolean, passed: boolean, code: string, createdAt: string, date: string, slot: number, peopleCount: number, status: OrderStatusEnum, guestInvitationUrl?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, reservationGuests: Array<{ __typename?: 'ReservationGuest', id: string, confirmedAt?: string | null, email: string, user?: { __typename?: 'User', id: string, firstName?: string | null } | null }>, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null, reservable?: { __typename: 'Daily', id: string, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } } | { __typename: 'Event', id: string, title: string, slotless: boolean, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }>, eventRestaurant?: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } | null, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } | { __typename: 'FestivalEditionRestaurant', id: string, allDaySlots: boolean, festivalEdition: { __typename?: 'FestivalEdition', id: string, festival: { __typename?: 'Festival', id: string, code: string } }, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } } | null };

export type InvitePageQueryVariables = Exact<{
  securityToken?: InputMaybe<Scalars['String']>;
}>;


export type InvitePageQuery = { __typename?: 'Query', reservation?: { __typename?: 'Reservation', id: string, canBeUpdated: boolean, canBeCancelled: boolean, passed: boolean, code: string, createdAt: string, date: string, slot: number, peopleCount: number, status: OrderStatusEnum, guestInvitationUrl?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, reservationGuests: Array<{ __typename?: 'ReservationGuest', id: string, confirmedAt?: string | null, email: string, user?: { __typename?: 'User', id: string, firstName?: string | null } | null }>, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null, reservable?: { __typename: 'Daily', id: string, slotDuration: number, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } } | { __typename: 'Event', id: string, title: string, slotless: boolean, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }>, eventRestaurant?: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } | null, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }>, slots?: Array<{ __typename?: 'SlotDefinition', duration: number }> | null } | { __typename: 'FestivalEditionRestaurant', id: string, allDaySlots: boolean, festivalEdition: { __typename?: 'FestivalEdition', id: string, allDaySlots: boolean, slotDuration: number, festival: { __typename?: 'Festival', id: string, code: string } }, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } } | null } | null };

export type KlarnaCreateOrderMutationVariables = Exact<{
  reservationId: Scalars['ID'];
  authToken: Scalars['String'];
}>;


export type KlarnaCreateOrderMutation = { __typename?: 'Mutation', klarnaCreateOrder: { __typename?: 'KlarnaOrder', fraudStatus?: string | null, orderId?: string | null, redirectUrl: string, payload: any } };

export type KlarnaCreateSessionMutationVariables = Exact<{
  reservationId: Scalars['ID'];
}>;


export type KlarnaCreateSessionMutation = { __typename?: 'Mutation', klarnaCreateSession: { __typename?: 'Session', clientToken: string, sessionId?: string | null, paymentMethodCategories?: any | null, payload: any } };

export type KlarnaUpdateSessionMutationVariables = Exact<{
  reservationId: Scalars['ID'];
  sessionId: Scalars['String'];
}>;


export type KlarnaUpdateSessionMutation = { __typename?: 'Mutation', klarnaUpdateSession: boolean };

export type LeanCrossSellFragment = { __typename?: 'CrossSell', id: string, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, festivalDrink: boolean, image?: { __typename?: 'ImageFile', preview?: string | null } | null };

export type LeanReservationGuestFragment = { __typename?: 'ReservationGuest', id: string, confirmedAt?: string | null, email: string, user?: { __typename?: 'User', id: string, firstName?: string | null } | null };

export type CheckoutFerOfferSlotsQueryVariables = Exact<{
  dates: DateRange;
  reservables: Array<ReservableInput> | ReservableInput;
}>;


export type CheckoutFerOfferSlotsQuery = { __typename?: 'Query', slots: Array<{ __typename?: 'Slot', sizes: Array<number>, slot: number, date: string, reservable?: { __typename?: 'Daily' } | { __typename?: 'Event' } | { __typename?: 'FestivalEditionRestaurant', id: string, festivalEdition: { __typename?: 'FestivalEdition', id: string, price: number, festival: { __typename?: 'Festival', name: string, image?: { __typename?: 'ImageFile', preview?: string | null, id: string } | null } }, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, restaurant: { __typename?: 'Restaurant', imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } } | null }> };

export type PayuPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PayuPaymentMethodsQuery = { __typename?: 'Query', payuPaymentMethods: { __typename?: 'PaymentMethods', currentTenant: string, payByLinks: Array<{ __typename?: 'PayByLinkMethod', name: string, value: string, brandImageUrl?: string | null }> } };

export type PurchaseReservationMutationVariables = Exact<{
  code: Scalars['String'];
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
  extraParams?: InputMaybe<PaymentExtraParamsInput>;
  cardId?: InputMaybe<Scalars['ID']>;
}>;


export type PurchaseReservationMutation = { __typename?: 'Mutation', purchaseReservation: { __typename?: 'PurchaseReservationPayload', checkoutPageUrl?: string | null, cryptKey?: string | null, reservation: { __typename?: 'Reservation', id: string, code: string, guestInvitationUrl?: string | null, status: OrderStatusEnum, lastOrderPrice?: number | null } } };

export type ReleaseSlotMutationVariables = Exact<{
  reservationCode: Scalars['String'];
}>;


export type ReleaseSlotMutation = { __typename?: 'Mutation', releaseSlot: { __typename?: 'Reservation', id: string } };

export type ReservationGuestsQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
  securityToken?: InputMaybe<Scalars['String']>;
}>;


export type ReservationGuestsQuery = { __typename?: 'Query', reservation?: { __typename?: 'Reservation', id: string, reservationGuests: Array<{ __typename?: 'ReservationGuest', id: string, confirmedAt?: string | null, email: string, user?: { __typename?: 'User', id: string, firstName?: string | null } | null }> } | null };

export type ReservationStatusQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
  securityToken?: InputMaybe<Scalars['String']>;
}>;


export type ReservationStatusQuery = { __typename?: 'Query', reservation?: { __typename?: 'Reservation', id: string, status: OrderStatusEnum } | null };

export type SelectedFerMenusFragment = { __typename?: 'FestivalEditionRestaurant', id: string, menus?: Array<{ __typename?: 'Menu', label: string }> | null, festivalEdition: { __typename?: 'FestivalEdition', id: string, forceLabels: boolean } };

export type SelectedMenusFragment = { __typename?: 'Reservation', menus: Array<number>, reservable?: { __typename?: 'Daily' } | { __typename?: 'Event' } | { __typename?: 'FestivalEditionRestaurant', id: string, menus?: Array<{ __typename?: 'Menu', label: string }> | null, festivalEdition: { __typename?: 'FestivalEdition', id: string, forceLabels: boolean } } | null };

export type SuccessPageQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type SuccessPageQuery = { __typename?: 'Query', reservation?: { __typename?: 'Reservation', id: string, canBeUpdated: boolean, canBeCancelled: boolean, passed: boolean, code: string, createdAt: string, date: string, slot: number, peopleCount: number, status: OrderStatusEnum, guestInvitationUrl?: string | null, lastOrderPrice?: number | null, menus: Array<number>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, reservationGuests: Array<{ __typename?: 'ReservationGuest', id: string, confirmedAt?: string | null, email: string, user?: { __typename?: 'User', id: string, firstName?: string | null } | null }>, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null, reservable?: { __typename: 'Daily', id: string, slotDuration: number, price: number, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } } | { __typename: 'Event', id: string, title: string, slotless: boolean, price: number, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }>, eventRestaurant?: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } | null, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }>, slots?: Array<{ __typename?: 'SlotDefinition', duration: number }> | null } | { __typename: 'FestivalEditionRestaurant', id: string, allDaySlots: boolean, price: number, festivalEdition: { __typename?: 'FestivalEdition', id: string, allDaySlots: boolean, slotDuration: number, code: string, price: number, forceLabels: boolean, festival: { __typename?: 'Festival', id: string, code: string, name: string } }, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } }, menus?: Array<{ __typename?: 'Menu', label: string }> | null } | null, discount?: { __typename?: 'PercentageCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'ValueCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'Voucher', value: number, code: string, id: string, type: string } | null, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', isApplicable: boolean, quantity: number, id: string, crossSell: { __typename?: 'CrossSell', name: string, price: number, id: string } }> | null, priceValues: { __typename?: 'PriceValues', basePrice: number, crossSellsPrice: number, deliveryFee: number, feeablePeopleCount?: number | null, priceToPay: number, totalValue: number, reservationFee: number, reservationFeeUnitPrice: number, discountValue: number, reservableExtrasPrice: number, primeTimeFeeIncludedInBaseUnitPrice?: number | null }, reservationSummarySheet: Array<{ __typename?: 'ReservationSummarySheet', currentTenant: string, details?: string | null, identifier: ReservationSummaryIdentifier, label: string, price: number, quantity?: number | null }>, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, price: number }> } | null };

export type SuccessPageVoucherQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type SuccessPageVoucherQuery = { __typename?: 'Query', voucher?: { __typename?: 'Voucher', id: string, code: string, status?: OrderStatusEnum | null, peopleCount: number, email?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, festivalEdition?: { __typename?: 'FestivalEdition', id: string, code: string, price: number, state: FestivalStateEnum, festival: { __typename?: 'Festival', id: string, code: string, name: string } } | null } | null };

export type LeanReservableExtraFragment = { __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null };

export type ReservableExtraMenusFragment = { __typename?: 'ReservableExtra', menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null };

export type ReservableExtraSlugQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReservableExtraSlugQuery = { __typename?: 'Query', reservableExtra: { __typename?: 'ReservableExtra', slug: string } };

export type RestaurantInReservableExtraFragment = { __typename?: 'Restaurant', id: string, name: string, slug: string, chef?: string | null, description?: string | null, establishmentYear?: number | null, favorited: boolean, reservables: Array<{ __typename?: 'Daily', id: string, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null } | { __typename?: 'Event', id: string } | { __typename?: 'FestivalEditionRestaurant', id: string }>, openingHours?: Array<{ __typename?: 'Hours', day: string, from?: string | null, to?: string | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> };

export type SingleReservableExtraQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SingleReservableExtraQuery = { __typename?: 'Query', reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, restaurant: { __typename?: 'Restaurant', id: string, name: string, slug: string, chef?: string | null, description?: string | null, establishmentYear?: number | null, favorited: boolean, reservables: Array<{ __typename?: 'Daily', id: string, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null } | { __typename?: 'Event', id: string } | { __typename?: 'FestivalEditionRestaurant', id: string }>, openingHours?: Array<{ __typename?: 'Hours', day: string, from?: string | null, to?: string | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> }, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null } };

export type CollectionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CollectionQuery = { __typename?: 'Query', collection: { __typename?: 'PolymorphicCollection', id: string, category: CollectionCategoryEnum, title?: string | null, regionId?: string | null, festivalEditionRestaurants: Array<{ __typename?: 'FestivalEditionRestaurant', restaurant: { __typename?: 'Restaurant', id: string, name: string, slug: string, description?: string | null, favorited: boolean, position: number, latitude?: number | null, longitude?: number | null, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, reservables: Array<{ __typename: 'Daily', id: string } | { __typename: 'Event', id: string } | { __typename: 'FestivalEditionRestaurant', id: string }> } }>, reservableExtras?: Array<{ __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, restaurant: { __typename?: 'Restaurant', name: string, id: string, slug: string, favorited: boolean, reservables: Array<{ __typename?: 'Daily', id: string, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', id?: string | null, possibleSlots: Array<number> }> | null } | { __typename?: 'Event', id: string } | { __typename?: 'FestivalEditionRestaurant', id: string }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> } }> | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name: string, slug: string, description?: string | null, favorited: boolean, position: number, latitude?: number | null, longitude?: number | null, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, reservables: Array<{ __typename: 'Daily', id: string } | { __typename: 'Event', id: string } | { __typename: 'FestivalEditionRestaurant', id: string }> }> | null } };

export type LeanCollectionFragment = { __typename?: 'PolymorphicCollection', id: string, category: CollectionCategoryEnum, title?: string | null, regionId?: string | null, festivalEditionRestaurants: Array<{ __typename?: 'FestivalEditionRestaurant', restaurant: { __typename?: 'Restaurant', id: string, name: string, slug: string, description?: string | null, favorited: boolean, position: number, latitude?: number | null, longitude?: number | null, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, reservables: Array<{ __typename: 'Daily', id: string } | { __typename: 'Event', id: string } | { __typename: 'FestivalEditionRestaurant', id: string }> } }>, reservableExtras?: Array<{ __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, restaurant: { __typename?: 'Restaurant', name: string, id: string, slug: string, favorited: boolean, reservables: Array<{ __typename?: 'Daily', id: string, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', id?: string | null, possibleSlots: Array<number> }> | null } | { __typename?: 'Event', id: string } | { __typename?: 'FestivalEditionRestaurant', id: string }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> } }> | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name: string, slug: string, description?: string | null, favorited: boolean, position: number, latitude?: number | null, longitude?: number | null, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, reservables: Array<{ __typename: 'Daily', id: string } | { __typename: 'Event', id: string } | { __typename: 'FestivalEditionRestaurant', id: string }> }> | null };

export type MenuPositionsQueryVariables = Exact<{
  festivalEditionId: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  regionId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  index?: InputMaybe<Scalars['Int']>;
}>;


export type MenuPositionsQuery = { __typename?: 'Query', menuPositions: { __typename?: 'MenuPositions', totalCount: number, nodes?: Array<{ __typename?: 'MenuPosition', content: string, index: number, name: string, title?: string | null, menu: { __typename?: 'Menu', id?: string | null, label: string }, restaurant: { __typename?: 'Restaurant', name: string, slug: string, id: string, festivalEditionRestaurants: Array<{ __typename?: 'FestivalEditionRestaurant', id: string, festivalEdition: { __typename?: 'FestivalEdition', id: string } }> } } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null } } };

export type ClosestFestivalEditionRestaurantQueryVariables = Exact<{
  festivalEditionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ClosestFestivalEditionRestaurantQuery = { __typename?: 'Query', restaurants: { __typename?: 'Restaurants', nodes?: Array<{ __typename?: 'Restaurant', id: string, name: string, slug: string, distance?: number | null, region: { __typename?: 'Region', id: string } } | null> | null } };

export type CurrentFestivalEditionQueryVariables = Exact<{
  code?: InputMaybe<FestivalCodesEnum>;
  slug?: InputMaybe<Scalars['String']>;
}>;


export type CurrentFestivalEditionQuery = { __typename?: 'Query', currentFestivalEdition?: { __typename?: 'FestivalEdition', id: string, state: FestivalStateEnum, voucher: boolean, startsAt: string, endsAt: string, price: number, externalSale: boolean, minPeopleCount: number, maxPeopleCount: number, reservableFrom: string, code: string, defaultReservableFrom: string, festival: { __typename?: 'Festival', code: string, slug: string }, slots?: Array<{ __typename?: 'SlotDefinition', duration: number, interval: number, possibleSlots: Array<number>, slotStart: number }> | null } | null };

export type EventsRegionsListQueryVariables = Exact<{
  slotless?: InputMaybe<Scalars['Boolean']>;
}>;


export type EventsRegionsListQuery = { __typename?: 'Query', incomingEventsRegions: Array<{ __typename?: 'Region', id: string }> };

export type FerModalQueryVariables = Exact<{
  ferId: Scalars['ID'];
}>;


export type FerModalQuery = { __typename?: 'Query', festivalEditionRestaurant?: { __typename?: 'FestivalEditionRestaurant', id: string, price: number, allDaySlots: boolean, externalSaleUrl?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null }>, restaurant: { __typename?: 'Restaurant', id: string, name: string, favorited: boolean, description?: string | null, slug: string, latitude?: number | null, longitude?: number | null, address?: string | null, phoneNumber?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }> }, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, festivalEdition: { __typename?: 'FestivalEdition', id: string, price: number, startsAt: string, endsAt: string, reservableFrom: string, forceLabels: boolean, reservationFeeUnitPrice: number, state: FestivalStateEnum, code: string, maxPeopleCount: number, minPeopleCount: number, slots?: Array<{ __typename?: 'SlotDefinition', slotStart: number }> | null, festival: { __typename?: 'Festival', id: string, code: string, name: string, slogan: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null } | null } } } | null };

export type FestivalMenuRegionRestaurantsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  regionId: Scalars['ID'];
  festivalEditionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type FestivalMenuRegionRestaurantsQuery = { __typename?: 'Query', restaurants: { __typename?: 'Restaurants', nodes?: Array<{ __typename?: 'Restaurant', id: string, name: string, slug: string, distance?: number | null } | null> | null } };

export type FestivalRegionsListQueryVariables = Exact<{
  festivalEditionId: Scalars['ID'];
}>;


export type FestivalRegionsListQuery = { __typename?: 'Query', festivalRegions: Array<{ __typename?: 'Region', id: string, name: string }> };

export type FestivalSponsorsListQueryVariables = Exact<{
  festivalEditionId?: InputMaybe<Scalars['ID']>;
  regionId?: InputMaybe<Scalars['ID']>;
  clubSponsors?: InputMaybe<Scalars['Boolean']>;
}>;


export type FestivalSponsorsListQuery = { __typename?: 'Query', sponsors: { __typename?: 'Sponsors', nodes?: Array<{ __typename?: 'Sponsor', id: string, label?: string | null, kind: SponsorKindsEnum, subkind?: SponsorSubkindsEnum | null, url?: string | null, image?: { __typename?: 'ImageFile', id: string, preview?: string | null } | null } | null> | null } };

export type OngoingFestivalsListQueryVariables = Exact<{ [key: string]: never; }>;


export type OngoingFestivalsListQuery = { __typename?: 'Query', ongoingFestivalEditions?: Array<{ __typename?: 'FestivalEdition', id: string, code: string, price: number, startsAt: string, endsAt: string, state: FestivalStateEnum, minPeopleCount: number, maxPeopleCount: number, menuPositions: Array<{ __typename?: 'FestivalEditionMenuPosition', label: string }>, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }>, festival: { __typename?: 'Festival', id: string, code: string, url: string, name: string, slogan: string, about: string, shortDescription: string, slug: string, image?: { __typename?: 'ImageFile', preview?: string | null } | null }, slots?: Array<{ __typename?: 'SlotDefinition', id?: string | null, possibleSlots: Array<number> }> | null }> | null };

export type ReservationConnectDataQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ReservationConnectDataQuery = { __typename?: 'Query', reservation?: { __typename?: 'Reservation', id: string, code: string, user?: { __typename?: 'User', id: string } | null } | null };

export type RestaurantFestivalMenuQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestaurantFestivalMenuQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, name: string, reservables: Array<{ __typename?: 'Daily' } | { __typename?: 'Event' } | { __typename?: 'FestivalEditionRestaurant', id: string, festivalEdition: { __typename?: 'FestivalEdition', id: string, state: FestivalStateEnum, festival: { __typename?: 'Festival', id: string, code: string } }, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, positions: Array<{ __typename?: 'MenuPosition', name: string, title?: string | null, content: string, index: number }> }> | null, ferInventoryItems: Array<{ __typename?: 'FestivalEditionRestaurantInventoryItem', price?: number | null, inventoryItem: { __typename?: 'InventoryItem', id: string, name: string, image?: { __typename?: 'ImageFile', preview?: string | null } | null } }> }> } | null };

export type SingleFestivalEditionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SingleFestivalEditionQuery = { __typename?: 'Query', festivalEdition: { __typename?: 'FestivalEdition', id: string, code: string, state: FestivalStateEnum, voucher: boolean, startsAt: string, endsAt: string, price: number, minPeopleCount: number, maxPeopleCount: number, festival: { __typename?: 'Festival', id: string, slug: string, code: string, name: string } } };

export type EventBasicDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type EventBasicDataQuery = { __typename?: 'Query', event: { __typename?: 'Event', id: string } };

export type CreateVoucherMutationVariables = Exact<{
  peopleCount: Scalars['Int'];
  festivalEditionId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateVoucherMutation = { __typename?: 'Mutation', createVoucher: { __typename?: 'Voucher', id: string, code: string, peopleCount: number, permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum> } };

export type OngoingFestivalsWithMetadatasQueryVariables = Exact<{
  withVoucher?: InputMaybe<Scalars['Boolean']>;
}>;


export type OngoingFestivalsWithMetadatasQuery = { __typename?: 'Query', ongoingFestivalEditions?: Array<{ __typename?: 'FestivalEdition', id: string, code: string, price: number, startsAt: string, endsAt: string, minPeopleCount: number, state: FestivalStateEnum, festival: { __typename?: 'Festival', id: string, code: string, url: string, name: string, image?: { __typename?: 'ImageFile', original?: string | null, preview?: string | null } | null, logo?: { __typename?: 'ImageFile', original?: string | null, preview?: string | null } | null }, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> }> | null };

export type PurchaseVoucherMutationVariables = Exact<{
  code: Scalars['String'];
  paymentProvider?: InputMaybe<PaymentProviderEnum>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  extraParams?: InputMaybe<PaymentExtraParamsInput>;
  cardId?: InputMaybe<Scalars['ID']>;
}>;


export type PurchaseVoucherMutation = { __typename?: 'Mutation', purchaseVoucher: { __typename?: 'PurchaseVoucherPayload', checkoutPageUrl?: string | null, cryptKey?: string | null, voucher: { __typename?: 'Voucher', id: string, code: string, status?: OrderStatusEnum | null } } };

export type ReservableQueryVariables = Exact<{
  id: Scalars['ID'];
  type: ReservableEnum;
}>;


export type ReservableQuery = { __typename?: 'Query', reservable: { __typename?: 'Daily' } | { __typename?: 'Event', id: string, code: string, title: string, price: number, startsAt: string, endsAt: string, minMenusAmount: number, minPeopleCount: number, reservableFrom: string, slotless: boolean, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }>, slots?: Array<{ __typename?: 'SlotDefinition', id?: string | null, duration: number, possibleSlots: Array<number>, slotStart: number }> | null, menus?: Array<{ __typename?: 'Menu', label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, title?: string | null, content: string }> }> | null } | { __typename?: 'FestivalEditionRestaurant' } };

export type EventDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type EventDataQuery = { __typename?: 'Query', event: { __typename?: 'Event', id: string, title: string, description: string, startsAt: string, endsAt: string, minPeopleCount: number, maxPeopleCount: number, price: number, external: boolean, externalUrl?: string | null, slotless: boolean, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, menus?: Array<{ __typename?: 'Menu', id?: string | null }> | null, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } };

export type SideEventsListWithMetadatasQueryVariables = Exact<{
  slotless?: InputMaybe<Scalars['Boolean']>;
  regionId?: InputMaybe<Scalars['ID']>;
}>;


export type SideEventsListWithMetadatasQuery = { __typename?: 'Query', incomingEvents: { __typename?: 'Events', edges?: Array<{ __typename?: 'EventsEdge', node?: { __typename?: 'Event', id: string, title: string, price: number, startsAt: string, endsAt: string, slotless: boolean, minPeopleCount: number, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } | null } | null> | null } };

export type VoucherDataQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type VoucherDataQuery = { __typename?: 'Query', voucher?: { __typename?: 'Voucher', id: string, code: string, peopleCount: number, status?: OrderStatusEnum | null, permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum>, festivalEditions: Array<{ __typename?: 'FestivalEdition', id: string, code: string, state: FestivalStateEnum, voucher: boolean, startsAt: string, endsAt: string, price: number, minPeopleCount: number, maxPeopleCount: number, reservationFeeUnitPrice: number, festival: { __typename?: 'Festival', id: string, code: string, name: string, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } }> } | null };

export type VoucherStatusQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type VoucherStatusQuery = { __typename?: 'Query', voucher?: { __typename?: 'Voucher', status?: OrderStatusEnum | null } | null };

export type BannersQueryVariables = Exact<{
  section_slug?: InputMaybe<Scalars['String']>;
}>;


export type BannersQuery = { __typename?: 'Query', banners: { __typename?: 'Banners', nodes?: Array<{ __typename?: 'Banner', id: string, href?: string | null, files: any, alt: string } | null> | null } };

export type HomepageQueryQueryVariables = Exact<{
  region_id: Scalars['ID'];
  section_slug: Scalars['String'];
}>;


export type HomepageQueryQuery = { __typename?: 'Query', collections: { __typename?: 'Collections', edges?: Array<{ __typename?: 'CollectionEdge', node?: { __typename?: 'PolymorphicCollection', id: string, category: CollectionCategoryEnum, position: number, title?: string | null, festivalEdition?: { __typename?: 'FestivalEdition', festival: { __typename?: 'Festival', code: string, slug: string } } | null, restaurants?: Array<{ __typename?: 'Restaurant', id: string, name: string, description?: string | null, slug: string, favorited: boolean, position: number, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, position: number, type: string }>, reservables: Array<{ __typename?: 'Daily', id: string } | { __typename?: 'Event', id: string } | { __typename?: 'FestivalEditionRestaurant', id: string }> }> | null, reservableExtras?: Array<{ __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, restaurant: { __typename?: 'Restaurant', name: string, id: string, slug: string, favorited: boolean, reservables: Array<{ __typename?: 'Daily', id: string, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', id?: string | null, possibleSlots: Array<number> }> | null } | { __typename?: 'Event', id: string } | { __typename?: 'FestivalEditionRestaurant', id: string }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> } }> | null, elements?: Array<{ __typename?: 'CollectionElement', elementId: string, elementType: string }> | null, section: { __typename?: 'Section', slug: string } } | null } | null> | null } };

export type MainPageBannerFragment = { __typename?: 'Banner', id: string, href?: string | null, files: any, alt: string };

export type PopularRestaurantsQueryVariables = Exact<{
  region_id: Scalars['ID'];
}>;


export type PopularRestaurantsQuery = { __typename?: 'Query', popularRestaurants: Array<{ __typename?: 'Restaurant', id: string, name: string, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> }> };

export type FerListQueryVariables = Exact<{
  festival_edition_id: Scalars['ID'];
  region_id: Scalars['ID'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  reservation_filters?: InputMaybe<ReservationFilter>;
  tag_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  restaurant_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type FerListQuery = { __typename?: 'Query', festivalEditionRestaurants: { __typename?: 'FestivalEditionRestaurants', totalCount: number, nodes?: Array<{ __typename?: 'FestivalEditionRestaurant', id: string, externalSaleUrl?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null }>, restaurant: { __typename?: 'Restaurant', id: string, name: string, favorited: boolean, description?: string | null, latitude?: number | null, longitude?: number | null, address?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }> } } | null> | null } };

export type ListingSearchQueryVariables = Exact<{
  regionId?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
}>;


export type ListingSearchQuery = { __typename?: 'Query', search: Array<{ __typename: 'Collection', id: string } | { __typename: 'Restaurant', id: string } | { __typename: 'Tag', id: string }> };

export type PageDetailQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PageDetailQuery = { __typename?: 'Query', pageDetail?: { __typename?: 'PageDetail', id: string, name: string, slug: string, topBanner?: { __typename?: 'Banner', id: string, files: any, href?: string | null, visible: boolean } | null, middleBanner?: { __typename?: 'Banner', id: string, files: any, href?: string | null, visible: boolean } | null } | null };

export type GetRandomEventQueryVariables = Exact<{
  region_id?: InputMaybe<Scalars['ID']>;
  slotless?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetRandomEventQuery = { __typename?: 'Query', randomIncomingEvent?: { __typename?: 'Event', id: string, title: string, price: number, startsAt: string, endsAt: string, address: string, slotless: boolean, restaurant?: { __typename?: 'Restaurant', name: string } | null, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }>, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> } | null };

export type ApplyPaymentMethodDiscountMutationVariables = Exact<{
  code: Scalars['String'];
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
}>;


export type ApplyPaymentMethodDiscountMutation = { __typename?: 'Mutation', applyPaymentMethodDiscount: { __typename: 'Reservation', id: string, canBeUpdated: boolean, canBeCancelled: boolean, canBeDiscounted: boolean, code: string, createdAt: string, expired: boolean, festivalDrinkRequiredQuantity: number, reservableExtrasAvailable: boolean, hasReservableExtra: boolean, date: string, slot: number, menus: Array<number>, peopleCount: number, expiresAt?: string | null, timestamp?: string | null, status: OrderStatusEnum, notes?: string | null, vatId?: string | null, permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum>, autoDiscountsAvailable: Array<ProviderSpecificPaymentMethodEnum>, lastOrderPrice?: number | null, reservable?: { __typename: 'Daily', price: number, id: string, crossSells: Array<{ __typename?: 'CrossSell', festivalDrink: boolean, id: string, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, image?: { __typename?: 'ImageFile', preview?: string | null } | null }>, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, festivalEditionRestaurants: Array<{ __typename?: 'FestivalEditionRestaurant', id: string, festivalEdition: { __typename?: 'FestivalEdition', state: FestivalStateEnum } }>, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }>, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } }, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null } | { __typename: 'Event', price: number, title: string, id: string, code: string, slotless: boolean, minPeopleCount: number, maxPeopleCount: number, description: string, startsAt: string, endsAt: string, menusPerPerson: number, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, slots?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null, eventRestaurant?: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } | null, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } | { __typename: 'FestivalEditionRestaurant', price: number, id: string, menusPerPerson: number, allDaySlots: boolean, festivalEdition: { __typename?: 'FestivalEdition', code: string, price: number, id: string, forceLabels: boolean, festival: { __typename?: 'Festival', name: string, id: string, code: string, slug: string, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> }, slots?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null }, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null }>, crossSellAssignments: Array<{ __typename: 'FestivalEditionRestaurantCrossSell', saleEnabled: boolean, festivalEditionCrossSell?: { __typename: 'FestivalEditionCrossSell', crossSell: { __typename: 'CrossSell', id: string, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, image?: { __typename?: 'ImageFile', preview?: string | null } | null } } | null }>, crossSells: Array<{ __typename?: 'CrossSell', id: string, festivalDrink: boolean, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, image?: { __typename?: 'ImageFile', preview?: string | null } | null }>, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, price: number, slug: string, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }>, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null, previousReservation?: { __typename?: 'Reservation', peopleCount: number, slot: number, date: string, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', quantity: number, crossSell: { __typename?: 'CrossSell', id: string } }> | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', quantity: number, menuId: string, reservableExtraId: string }> | null } | null, discount?: { __typename?: 'PercentageCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'ValueCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'Voucher', value: number, code: string, id: string, type: string } | null, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', isApplicable: boolean, quantity: number, id: string, crossSell: { __typename?: 'CrossSell', name: string, price: number, id: string } }> | null, priceValues: { __typename?: 'PriceValues', basePrice: number, crossSellsPrice: number, deliveryFee: number, feeablePeopleCount?: number | null, priceToPay: number, totalValue: number, reservationFee: number, reservationFeeUnitPrice: number, discountValue: number, reservableExtrasPrice: number, primeTimeFeeIncludedInBaseUnitPrice?: number | null }, reservationSummarySheet: Array<{ __typename?: 'ReservationSummarySheet', currentTenant: string, details?: string | null, identifier: ReservationSummaryIdentifier, label: string, price: number, quantity?: number | null }> } };

export type AvailableDatesQueryVariables = Exact<{
  dates: DateRange;
  reservables: Array<ReservableInput> | ReservableInput;
  withReservableExtra?: InputMaybe<Scalars['Boolean']>;
}>;


export type AvailableDatesQuery = { __typename?: 'Query', slots: Array<{ __typename?: 'Slot', date: string, slot: number, sizes: Array<number>, reservable?: { __typename?: 'Daily', id: string } | { __typename?: 'Event', id: string } | { __typename?: 'FestivalEditionRestaurant', id: string } | null }> };

export type CancelDailyReservationMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type CancelDailyReservationMutation = { __typename?: 'Mutation', cancelDailyReservation: { __typename?: 'Reservation', id: string } };

export type CancelReservationMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type CancelReservationMutation = { __typename?: 'Mutation', cancelReservation: { __typename?: 'Reservation', id: string } };

export type ChefsMenuAssignmentFragment = { __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } };

export type ConnectReservationMutationVariables = Exact<{
  code: Scalars['String'];
  userId: Scalars['ID'];
}>;


export type ConnectReservationMutation = { __typename?: 'Mutation', connectReservation: { __typename?: 'Reservation', id: string, code: string } };

export type CreateDailyReservationMutationVariables = Exact<{
  reservableExtraAttrs?: InputMaybe<Array<ReservableExtraAttrInput> | ReservableExtraAttrInput>;
  restaurantId: Scalars['ID'];
  date: Scalars['Date'];
  slot: Scalars['Int'];
  peopleCount: Scalars['Int'];
  reservationSource?: InputMaybe<Scalars['Int']>;
}>;


export type CreateDailyReservationMutation = { __typename?: 'Mutation', createDailyReservation: { __typename?: 'Reservation', id: string, code: string, status: OrderStatusEnum, reservableExtrasAvailable: boolean, previousReservation?: { __typename?: 'Reservation', previousReservation?: { __typename?: 'Reservation', peopleCount: number, slot: number, date: string, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', quantity: number, crossSell: { __typename?: 'CrossSell', id: string } }> | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', quantity: number, menuId: string, reservableExtraId: string }> | null } | null } | null, priceValues: { __typename?: 'PriceValues', priceToPay: number, totalValue: number }, reservable?: { __typename: 'Daily', crossSells: Array<{ __typename?: 'CrossSell', id: string, festivalDrink: boolean }> } | { __typename: 'Event' } | { __typename: 'FestivalEditionRestaurant' } | null } };

export type CreateEventReservationMutationVariables = Exact<{
  eventId: Scalars['ID'];
  date: Scalars['Date'];
  slot: Scalars['Int'];
  peopleCount: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  menus: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type CreateEventReservationMutation = { __typename?: 'Mutation', createEventReservation: { __typename?: 'Reservation', id: string, code: string, previousReservation?: { __typename?: 'Reservation', previousReservation?: { __typename?: 'Reservation', peopleCount: number, slot: number, date: string, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', quantity: number, crossSell: { __typename?: 'CrossSell', id: string } }> | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', quantity: number, menuId: string, reservableExtraId: string }> | null } | null } | null, priceValues: { __typename?: 'PriceValues', priceToPay: number, discountValue: number } } };

export type CreateFestivalReservationMutationVariables = Exact<{
  festivalEditionId: Scalars['ID'];
  restaurantId: Scalars['ID'];
  date: Scalars['Date'];
  slot: Scalars['Int'];
  menus: Array<Scalars['Int']> | Scalars['Int'];
  voucherCode?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['Int']>;
  peopleCount: Scalars['Int'];
}>;


export type CreateFestivalReservationMutation = { __typename?: 'Mutation', createFestivalReservation: { __typename?: 'Reservation', id: string, code: string, reservableExtrasAvailable: boolean, reservable?: { __typename: 'Daily' } | { __typename: 'Event' } | { __typename: 'FestivalEditionRestaurant', id: string, crossSells: Array<{ __typename?: 'CrossSell', id: string, festivalDrink: boolean }> } | null } };

export type CrossSellsFragment = { __typename?: 'CrossSell', id: string, name: string, price: number, image?: { __typename?: 'ImageFile', id: string, preview?: string | null } | null };

export type DailyReservationReservableFragment = { __typename?: 'Daily', id: string, price: number, crossSells: Array<{ __typename?: 'CrossSell', festivalDrink: boolean, id: string, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, image?: { __typename?: 'ImageFile', preview?: string | null } | null }>, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, festivalEditionRestaurants: Array<{ __typename?: 'FestivalEditionRestaurant', id: string, festivalEdition: { __typename?: 'FestivalEdition', state: FestivalStateEnum } }>, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }>, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } }, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null };

export type EvaluationReservationQueryVariables = Exact<{
  code: Scalars['String'];
  securityToken?: InputMaybe<Scalars['String']>;
}>;


export type EvaluationReservationQuery = { __typename?: 'Query', reservation?: { __typename?: 'Reservation', id: string, code: string, passed: boolean, peopleCount: number, date: string, slot: number, hour: string, menus: Array<number>, review?: { __typename?: 'Review', id: string } | null, reservable?: { __typename: 'Daily', id: string, restaurant: { __typename?: 'Restaurant', id: string, address?: string | null, name: string, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> } } | { __typename: 'Event', id: string, code: string, title: string, slotless: boolean, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, eventRestaurant?: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } | null, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } | { __typename: 'FestivalEditionRestaurant', id: string, menusPerPerson: number, allDaySlots: boolean, menus?: Array<{ __typename?: 'Menu', label: string }> | null, restaurant: { __typename?: 'Restaurant', id: string, address?: string | null, name: string, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> }, festivalEdition: { __typename?: 'FestivalEdition', id: string, forceLabels: boolean, festival: { __typename?: 'Festival', id: string, code: string, name: string } } } | null, user?: { __typename?: 'User', id: string, firstName?: string | null } | null } | null };

export type EventReservationReservableFragment = { __typename?: 'Event', id: string, code: string, title: string, slotless: boolean, minPeopleCount: number, maxPeopleCount: number, description: string, startsAt: string, endsAt: string, menusPerPerson: number, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, slots?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null, eventRestaurant?: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } | null, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> };

export type FestivalReservationReservableFragment = { __typename?: 'FestivalEditionRestaurant', id: string, menusPerPerson: number, allDaySlots: boolean, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null }>, crossSellAssignments: Array<{ __typename: 'FestivalEditionRestaurantCrossSell', saleEnabled: boolean, festivalEditionCrossSell?: { __typename: 'FestivalEditionCrossSell', crossSell: { __typename: 'CrossSell', id: string, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, image?: { __typename?: 'ImageFile', preview?: string | null } | null } } | null }>, festivalEdition: { __typename?: 'FestivalEdition', id: string, code: string, forceLabels: boolean, slots?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null, festival: { __typename?: 'Festival', id: string, code: string, slug: string, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } }, crossSells: Array<{ __typename?: 'CrossSell', id: string, festivalDrink: boolean, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, image?: { __typename?: 'ImageFile', preview?: string | null } | null }>, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } };

export type FullMenuFragment = { __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> };

export type MinimumPreviousReservationFragment = { __typename?: 'Reservation', previousReservation?: { __typename?: 'Reservation', peopleCount: number, slot: number, date: string, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', quantity: number, crossSell: { __typename?: 'CrossSell', id: string } }> | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', quantity: number, menuId: string, reservableExtraId: string }> | null } | null };

export type MinimumReservationCrossSellFragment = { __typename?: 'ReservationCrossSell', quantity: number, crossSell: { __typename?: 'CrossSell', id: string } };

export type MyPurchasesQueryVariables = Exact<{
  festival?: InputMaybe<FestivalCodesEnum>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type MyPurchasesQuery = { __typename?: 'Query', myPurchases: { __typename?: 'UserPurchases', totalCount: number, edges?: Array<{ __typename?: 'UserPurchasesEdge', node?: { __typename?: 'PercentageCoupon' } | { __typename?: 'Reservation', id: string, canBeUpdated: boolean, code: string, date: string, hour: string, slot: number, createdAt: string, peopleCount: number, status: OrderStatusEnum, priceValues: { __typename?: 'PriceValues', totalValue: number }, review?: { __typename?: 'Review', id: string } | null, user?: { __typename?: 'User', id: string } | null, reservable?: { __typename?: 'Daily', id: string, dailyRestaurant: { __typename?: 'Restaurant', id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> } } | { __typename?: 'Event', id: string, title: string, slotless: boolean, eventRestaurant?: { __typename?: 'Restaurant', id: string, address?: string | null, latitude?: number | null, longitude?: number | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> } | null } | { __typename?: 'FestivalEditionRestaurant', id: string, festivalEdition: { __typename?: 'FestivalEdition', id: string, festival: { __typename?: 'Festival', id: string, code: string } }, restaurant: { __typename?: 'Restaurant', id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> } } | null, discount?: { __typename?: 'PercentageCoupon', id: string, code: string, type: string, value: number, festivalEdition?: { __typename?: 'FestivalEdition', id: string } | null } | { __typename?: 'ValueCoupon', id: string, code: string, type: string, value: number, festivalEdition?: { __typename?: 'FestivalEdition', id: string } | null } | { __typename?: 'Voucher', id: string, code: string, type: string, value: number, festivalEdition?: { __typename?: 'FestivalEdition', id: string } | null } | null, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', id: string, quantity: number, isApplicable: boolean, crossSell: { __typename?: 'CrossSell', id: string, name: string } }> | null } | { __typename?: 'ValueCoupon' } | { __typename?: 'Voucher', id: string, code: string, peopleCount: number, createdAt: string, used: number, festivalEdition?: { __typename?: 'FestivalEdition', id: string, endsAt: string, startsAt: string, state: FestivalStateEnum, festival: { __typename?: 'Festival', id: string, name: string, code: string, logo?: { __typename?: 'ImageFile', id: string, thumbnail?: string | null } | null } } | null } | null } | null> | null } };

export type ReservableExtraListQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  restaurantTags?: InputMaybe<Array<InputMaybe<TagFilter>> | InputMaybe<TagFilter>>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  regionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ReservableExtraListQuery = { __typename?: 'Query', reservableExtras: { __typename?: 'ReservableExtras', totalCount: number, nodes?: Array<{ __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, restaurant: { __typename?: 'Restaurant', id: string, name: string, slug: string, chef?: string | null, description?: string | null, establishmentYear?: number | null, favorited: boolean, reservables: Array<{ __typename?: 'Daily', id: string, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null } | { __typename?: 'Event', id: string } | { __typename?: 'FestivalEditionRestaurant', id: string }>, openingHours?: Array<{ __typename?: 'Hours', day: string, from?: string | null, to?: string | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> }, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null } } };

export type ReservationCrossSellFragmentFragment = { __typename?: 'ReservationCrossSell', id: string, quantity: number, crossSell: { __typename?: 'CrossSell', id: string, name: string, price: number } };

export type ReservationDetailsGuestQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type ReservationDetailsGuestQuery = { __typename?: 'Query', reservation?: { __typename?: 'Reservation', id: string, canBeUpdated: boolean, canBeCancelled: boolean, passed: boolean, code: string, createdAt: string, date: string, slot: number, peopleCount: number, status: OrderStatusEnum, guestInvitationUrl?: string | null, menus: Array<number>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, reservationGuests: Array<{ __typename?: 'ReservationGuest', id: string, confirmedAt?: string | null, email: string, user?: { __typename?: 'User', id: string, firstName?: string | null } | null }>, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null, reservable?: { __typename: 'Daily', id: string, slotDuration: number, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } } | { __typename: 'Event', id: string, title: string, slotless: boolean, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }>, eventRestaurant?: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } | null, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }>, slots?: Array<{ __typename?: 'SlotDefinition', duration: number }> | null } | { __typename: 'FestivalEditionRestaurant', id: string, allDaySlots: boolean, festivalEdition: { __typename?: 'FestivalEdition', id: string, allDaySlots: boolean, slotDuration: number, forceLabels: boolean, festival: { __typename?: 'Festival', id: string, code: string } }, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } }, menus?: Array<{ __typename?: 'Menu', label: string }> | null } | null } | null };

export type ReservationListElementFragment = { __typename?: 'Reservation', id: string, canBeCancelled: boolean, canBeUpdated: boolean, code: string, passed: boolean, peopleCount: number, date: string, slot: number, review?: { __typename?: 'Review', id: string } | null, user?: { __typename?: 'User', id: string } | null, reservable?: { __typename: 'Daily', id: string, restaurant: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } } | { __typename: 'Event', id: string, title: string, slotless: boolean, eventRestaurant?: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }>, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } | { __typename: 'FestivalEditionRestaurant', id: string, allDaySlots: boolean, festivalEdition: { __typename?: 'FestivalEdition', festival: { __typename?: 'Festival', name: string } }, restaurant: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } } | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null };

export type RestaurantDataFragment = { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> };

export type ReservationModalFragment = { __typename?: 'Reservation', date: string, slot: number, reservable?: { __typename: 'Daily', id: string, restaurant: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } } | { __typename: 'Event', id: string, title: string, slotless: boolean, eventRestaurant?: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }>, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } | { __typename: 'FestivalEditionRestaurant', id: string, allDaySlots: boolean, festivalEdition: { __typename?: 'FestivalEdition', festival: { __typename?: 'Festival', name: string } }, restaurant: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } } | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null };

export type ReservationOfferFragment = { __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, restaurant: { __typename?: 'Restaurant', name: string, id: string, slug: string, favorited: boolean, reservables: Array<{ __typename?: 'Daily', id: string, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', id?: string | null, possibleSlots: Array<number> }> | null } | { __typename?: 'Event', id: string } | { __typename?: 'FestivalEditionRestaurant', id: string }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> } };

export type ReservationOffersListQueryVariables = Exact<{
  region_id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<TagFilter>> | InputMaybe<TagFilter>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<RestaurantSort>;
}>;


export type ReservationOffersListQuery = { __typename?: 'Query', restaurants: { __typename?: 'Restaurants', totalCount: number, nodes?: Array<{ __typename?: 'Restaurant', id: string, name: string, slug: string, chef?: string | null, description?: string | null, establishmentYear?: number | null, favorited: boolean, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }>, reservables: Array<{ __typename?: 'Daily', id: string, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null } | { __typename?: 'Event', id: string } | { __typename?: 'FestivalEditionRestaurant', id: string }>, openingHours?: Array<{ __typename?: 'Hours', day: string, from?: string | null, to?: string | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }> } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null } } };

export type ReservationPricesFragment = { __typename?: 'Reservation', lastOrderPrice?: number | null, discount?: { __typename?: 'PercentageCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'ValueCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'Voucher', value: number, code: string, id: string, type: string } | null, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', isApplicable: boolean, quantity: number, id: string, crossSell: { __typename?: 'CrossSell', name: string, price: number, id: string } }> | null, priceValues: { __typename?: 'PriceValues', basePrice: number, crossSellsPrice: number, deliveryFee: number, feeablePeopleCount?: number | null, priceToPay: number, totalValue: number, reservationFee: number, reservationFeeUnitPrice: number, discountValue: number, reservableExtrasPrice: number, primeTimeFeeIncludedInBaseUnitPrice?: number | null }, reservationSummarySheet: Array<{ __typename?: 'ReservationSummarySheet', currentTenant: string, details?: string | null, identifier: ReservationSummaryIdentifier, label: string, price: number, quantity?: number | null }>, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, price: number }>, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null, reservable?: { __typename?: 'Daily', price: number } | { __typename?: 'Event', price: number, title: string } | { __typename?: 'FestivalEditionRestaurant', price: number, festivalEdition: { __typename?: 'FestivalEdition', code: string, price: number, festival: { __typename?: 'Festival', name: string } } } | null };

export type ReservationSummaryDataFragment = { __typename: 'Reservation', id: string, canBeUpdated: boolean, canBeCancelled: boolean, canBeDiscounted: boolean, code: string, createdAt: string, expired: boolean, festivalDrinkRequiredQuantity: number, reservableExtrasAvailable: boolean, hasReservableExtra: boolean, date: string, slot: number, menus: Array<number>, peopleCount: number, expiresAt?: string | null, timestamp?: string | null, status: OrderStatusEnum, notes?: string | null, vatId?: string | null, permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum>, autoDiscountsAvailable: Array<ProviderSpecificPaymentMethodEnum>, lastOrderPrice?: number | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, price: number, slug: string, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }>, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null, previousReservation?: { __typename?: 'Reservation', peopleCount: number, slot: number, date: string, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', quantity: number, crossSell: { __typename?: 'CrossSell', id: string } }> | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', quantity: number, menuId: string, reservableExtraId: string }> | null } | null, discount?: { __typename?: 'PercentageCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'ValueCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'Voucher', value: number, code: string, id: string, type: string } | null, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', isApplicable: boolean, quantity: number, id: string, crossSell: { __typename?: 'CrossSell', name: string, price: number, id: string } }> | null, priceValues: { __typename?: 'PriceValues', basePrice: number, crossSellsPrice: number, deliveryFee: number, feeablePeopleCount?: number | null, priceToPay: number, totalValue: number, reservationFee: number, reservationFeeUnitPrice: number, discountValue: number, reservableExtrasPrice: number, primeTimeFeeIncludedInBaseUnitPrice?: number | null }, reservationSummarySheet: Array<{ __typename?: 'ReservationSummarySheet', currentTenant: string, details?: string | null, identifier: ReservationSummaryIdentifier, label: string, price: number, quantity?: number | null }>, reservable?: { __typename?: 'Daily', price: number } | { __typename?: 'Event', price: number, title: string } | { __typename?: 'FestivalEditionRestaurant', price: number, festivalEdition: { __typename?: 'FestivalEdition', code: string, price: number, festival: { __typename?: 'Festival', name: string } } } | null };

export type ReservationSummaryQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ReservationSummaryQuery = { __typename?: 'Query', reservation?: { __typename: 'Reservation', id: string, canBeUpdated: boolean, canBeCancelled: boolean, canBeDiscounted: boolean, code: string, createdAt: string, expired: boolean, festivalDrinkRequiredQuantity: number, reservableExtrasAvailable: boolean, hasReservableExtra: boolean, date: string, slot: number, menus: Array<number>, peopleCount: number, expiresAt?: string | null, timestamp?: string | null, status: OrderStatusEnum, notes?: string | null, vatId?: string | null, permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum>, autoDiscountsAvailable: Array<ProviderSpecificPaymentMethodEnum>, lastOrderPrice?: number | null, reservable?: { __typename: 'Daily', price: number, id: string, crossSells: Array<{ __typename?: 'CrossSell', festivalDrink: boolean, id: string, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, image?: { __typename?: 'ImageFile', preview?: string | null } | null }>, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, festivalEditionRestaurants: Array<{ __typename?: 'FestivalEditionRestaurant', id: string, festivalEdition: { __typename?: 'FestivalEdition', state: FestivalStateEnum } }>, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }>, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } }, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null } | { __typename: 'Event', price: number, title: string, id: string, code: string, slotless: boolean, minPeopleCount: number, maxPeopleCount: number, description: string, startsAt: string, endsAt: string, menusPerPerson: number, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, slots?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null, eventRestaurant?: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } | null, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } | { __typename: 'FestivalEditionRestaurant', price: number, id: string, menusPerPerson: number, allDaySlots: boolean, festivalEdition: { __typename?: 'FestivalEdition', code: string, price: number, id: string, forceLabels: boolean, festival: { __typename?: 'Festival', name: string, id: string, code: string, slug: string, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> }, slots?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null }, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null }>, crossSellAssignments: Array<{ __typename: 'FestivalEditionRestaurantCrossSell', saleEnabled: boolean, festivalEditionCrossSell?: { __typename: 'FestivalEditionCrossSell', crossSell: { __typename: 'CrossSell', id: string, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, image?: { __typename?: 'ImageFile', preview?: string | null } | null } } | null }>, crossSells: Array<{ __typename?: 'CrossSell', id: string, festivalDrink: boolean, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, image?: { __typename?: 'ImageFile', preview?: string | null } | null }>, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, price: number, slug: string, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }>, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null, previousReservation?: { __typename?: 'Reservation', peopleCount: number, slot: number, date: string, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', quantity: number, crossSell: { __typename?: 'CrossSell', id: string } }> | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', quantity: number, menuId: string, reservableExtraId: string }> | null } | null, discount?: { __typename?: 'PercentageCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'ValueCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'Voucher', value: number, code: string, id: string, type: string } | null, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', isApplicable: boolean, quantity: number, id: string, crossSell: { __typename?: 'CrossSell', name: string, price: number, id: string } }> | null, priceValues: { __typename?: 'PriceValues', basePrice: number, crossSellsPrice: number, deliveryFee: number, feeablePeopleCount?: number | null, priceToPay: number, totalValue: number, reservationFee: number, reservationFeeUnitPrice: number, discountValue: number, reservableExtrasPrice: number, primeTimeFeeIncludedInBaseUnitPrice?: number | null }, reservationSummarySheet: Array<{ __typename?: 'ReservationSummarySheet', currentTenant: string, details?: string | null, identifier: ReservationSummaryIdentifier, label: string, price: number, quantity?: number | null }> } | null };

export type ReservationWithCrossSellsFragment = { __typename?: 'Reservation', id: string, code: string };

export type SendReservationNotificationMutationVariables = Exact<{
  id: Scalars['ID'];
  type: ReservationNotificationTypeEnum;
}>;


export type SendReservationNotificationMutation = { __typename?: 'Mutation', sendReservationNotification: boolean };

export type SlotDurationFragment = { __typename?: 'Reservation', reservable?: { __typename: 'Daily', slotDuration: number } | { __typename: 'Event', slots?: Array<{ __typename?: 'SlotDefinition', duration: number }> | null } | { __typename: 'FestivalEditionRestaurant', festivalEdition: { __typename?: 'FestivalEdition', allDaySlots: boolean, slotDuration: number } } | null };

export type SlotsUsageQueryVariables = Exact<{
  dates: DateRange;
  reservables: Array<ReservableInput> | ReservableInput;
  withReservableExtra?: InputMaybe<Scalars['Boolean']>;
}>;


export type SlotsUsageQuery = { __typename?: 'Query', slots: Array<{ __typename?: 'Slot', date: string, discount: number, runningOut: boolean, sizes: Array<number>, slot: number, interval: number, primeTimeFee?: number | null, reservable?: { __typename?: 'Daily', id: string } | { __typename?: 'Event', id: string } | { __typename?: 'FestivalEditionRestaurant', id: string } | null }> };

export type UpdateDailyReservationMutationVariables = Exact<{
  code: Scalars['String'];
  reservableExtraAttrs?: InputMaybe<Array<ReservableExtraAttrInput> | ReservableExtraAttrInput>;
  crossSellsList?: InputMaybe<Array<CrossSellsList> | CrossSellsList>;
  redeemCode?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  slot?: InputMaybe<Scalars['Int']>;
  peopleCount?: InputMaybe<Scalars['Int']>;
  vatId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDailyReservationMutation = { __typename?: 'Mutation', updateDailyReservation: { __typename: 'Reservation', id: string, canBeUpdated: boolean, canBeCancelled: boolean, canBeDiscounted: boolean, code: string, createdAt: string, expired: boolean, festivalDrinkRequiredQuantity: number, reservableExtrasAvailable: boolean, hasReservableExtra: boolean, date: string, slot: number, menus: Array<number>, peopleCount: number, expiresAt?: string | null, timestamp?: string | null, status: OrderStatusEnum, notes?: string | null, vatId?: string | null, permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum>, autoDiscountsAvailable: Array<ProviderSpecificPaymentMethodEnum>, lastOrderPrice?: number | null, reservable?: { __typename: 'Daily', price: number, id: string, crossSells: Array<{ __typename?: 'CrossSell', festivalDrink: boolean, id: string, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, image?: { __typename?: 'ImageFile', preview?: string | null } | null }>, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, festivalEditionRestaurants: Array<{ __typename?: 'FestivalEditionRestaurant', id: string, festivalEdition: { __typename?: 'FestivalEdition', state: FestivalStateEnum } }>, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }>, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } }, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null } | { __typename: 'Event', price: number, title: string } | { __typename: 'FestivalEditionRestaurant', price: number, festivalEdition: { __typename?: 'FestivalEdition', code: string, price: number, festival: { __typename?: 'Festival', name: string } } } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, price: number, slug: string, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }>, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null, previousReservation?: { __typename?: 'Reservation', peopleCount: number, slot: number, date: string, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', quantity: number, crossSell: { __typename?: 'CrossSell', id: string } }> | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', quantity: number, menuId: string, reservableExtraId: string }> | null } | null, discount?: { __typename?: 'PercentageCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'ValueCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'Voucher', value: number, code: string, id: string, type: string } | null, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', isApplicable: boolean, quantity: number, id: string, crossSell: { __typename?: 'CrossSell', name: string, price: number, id: string } }> | null, priceValues: { __typename?: 'PriceValues', basePrice: number, crossSellsPrice: number, deliveryFee: number, feeablePeopleCount?: number | null, priceToPay: number, totalValue: number, reservationFee: number, reservationFeeUnitPrice: number, discountValue: number, reservableExtrasPrice: number, primeTimeFeeIncludedInBaseUnitPrice?: number | null }, reservationSummarySheet: Array<{ __typename?: 'ReservationSummarySheet', currentTenant: string, details?: string | null, identifier: ReservationSummaryIdentifier, label: string, price: number, quantity?: number | null }> } };

export type UpdateEventReservationMutationVariables = Exact<{
  code: Scalars['String'];
  vatId?: InputMaybe<Scalars['String']>;
  redeemCode?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  menus?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  userAcceptedMarketingConsent?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateEventReservationMutation = { __typename?: 'Mutation', updateEventReservation: { __typename: 'Reservation', id: string, canBeUpdated: boolean, canBeCancelled: boolean, canBeDiscounted: boolean, code: string, createdAt: string, expired: boolean, festivalDrinkRequiredQuantity: number, reservableExtrasAvailable: boolean, hasReservableExtra: boolean, date: string, slot: number, menus: Array<number>, peopleCount: number, expiresAt?: string | null, timestamp?: string | null, status: OrderStatusEnum, notes?: string | null, vatId?: string | null, permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum>, autoDiscountsAvailable: Array<ProviderSpecificPaymentMethodEnum>, lastOrderPrice?: number | null, reservable?: { __typename: 'Daily', price: number } | { __typename: 'Event', price: number, title: string, id: string, code: string, slotless: boolean, minPeopleCount: number, maxPeopleCount: number, description: string, startsAt: string, endsAt: string, menusPerPerson: number, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, slots?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null, eventRestaurant?: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } | null, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } | { __typename: 'FestivalEditionRestaurant', price: number, festivalEdition: { __typename?: 'FestivalEdition', code: string, price: number, festival: { __typename?: 'Festival', name: string } } } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, price: number, slug: string, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }>, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null, previousReservation?: { __typename?: 'Reservation', peopleCount: number, slot: number, date: string, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', quantity: number, crossSell: { __typename?: 'CrossSell', id: string } }> | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', quantity: number, menuId: string, reservableExtraId: string }> | null } | null, discount?: { __typename?: 'PercentageCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'ValueCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'Voucher', value: number, code: string, id: string, type: string } | null, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', isApplicable: boolean, quantity: number, id: string, crossSell: { __typename?: 'CrossSell', name: string, price: number, id: string } }> | null, priceValues: { __typename?: 'PriceValues', basePrice: number, crossSellsPrice: number, deliveryFee: number, feeablePeopleCount?: number | null, priceToPay: number, totalValue: number, reservationFee: number, reservationFeeUnitPrice: number, discountValue: number, reservableExtrasPrice: number, primeTimeFeeIncludedInBaseUnitPrice?: number | null }, reservationSummarySheet: Array<{ __typename?: 'ReservationSummarySheet', currentTenant: string, details?: string | null, identifier: ReservationSummaryIdentifier, label: string, price: number, quantity?: number | null }> } };

export type UpdateFestivalReservationMutationVariables = Exact<{
  code: Scalars['String'];
  crossSellsList?: InputMaybe<Array<CrossSellsList> | CrossSellsList>;
  menus?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  date?: InputMaybe<Scalars['Date']>;
  slot?: InputMaybe<Scalars['Int']>;
  peopleCount?: InputMaybe<Scalars['Int']>;
  redeemCode?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  vatId?: InputMaybe<Scalars['String']>;
  userAcceptedMarketingConsent?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateFestivalReservationMutation = { __typename?: 'Mutation', updateFestivalReservation: { __typename: 'Reservation', id: string, canBeUpdated: boolean, canBeCancelled: boolean, canBeDiscounted: boolean, code: string, createdAt: string, expired: boolean, festivalDrinkRequiredQuantity: number, reservableExtrasAvailable: boolean, hasReservableExtra: boolean, date: string, slot: number, menus: Array<number>, peopleCount: number, expiresAt?: string | null, timestamp?: string | null, status: OrderStatusEnum, notes?: string | null, vatId?: string | null, permittedPaymentMethods: Array<ProviderSpecificPaymentMethodEnum>, autoDiscountsAvailable: Array<ProviderSpecificPaymentMethodEnum>, lastOrderPrice?: number | null, reservable?: { __typename: 'Daily', price: number } | { __typename: 'Event', price: number, title: string } | { __typename: 'FestivalEditionRestaurant', price: number, id: string, menusPerPerson: number, allDaySlots: boolean, festivalEdition: { __typename?: 'FestivalEdition', code: string, price: number, id: string, forceLabels: boolean, festival: { __typename?: 'Festival', name: string, id: string, code: string, slug: string, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> }, slots?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null }, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null }>, crossSellAssignments: Array<{ __typename: 'FestivalEditionRestaurantCrossSell', saleEnabled: boolean, festivalEditionCrossSell?: { __typename: 'FestivalEditionCrossSell', crossSell: { __typename: 'CrossSell', id: string, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, image?: { __typename?: 'ImageFile', preview?: string | null } | null } } | null }>, crossSells: Array<{ __typename?: 'CrossSell', id: string, festivalDrink: boolean, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, image?: { __typename?: 'ImageFile', preview?: string | null } | null }>, restaurant: { __typename?: 'Restaurant', slug: string, id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } } } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, price: number, slug: string, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }>, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null, previousReservation?: { __typename?: 'Reservation', peopleCount: number, slot: number, date: string, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', quantity: number, crossSell: { __typename?: 'CrossSell', id: string } }> | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', quantity: number, menuId: string, reservableExtraId: string }> | null } | null, discount?: { __typename?: 'PercentageCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'ValueCoupon', value: number, code: string, id: string, type: string } | { __typename?: 'Voucher', value: number, code: string, id: string, type: string } | null, reservationCrossSells?: Array<{ __typename?: 'ReservationCrossSell', isApplicable: boolean, quantity: number, id: string, crossSell: { __typename?: 'CrossSell', name: string, price: number, id: string } }> | null, priceValues: { __typename?: 'PriceValues', basePrice: number, crossSellsPrice: number, deliveryFee: number, feeablePeopleCount?: number | null, priceToPay: number, totalValue: number, reservationFee: number, reservationFeeUnitPrice: number, discountValue: number, reservableExtrasPrice: number, primeTimeFeeIncludedInBaseUnitPrice?: number | null }, reservationSummarySheet: Array<{ __typename?: 'ReservationSummarySheet', currentTenant: string, details?: string | null, identifier: ReservationSummaryIdentifier, label: string, price: number, quantity?: number | null }> } };

export type ValidateVoucherQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ValidateVoucherQuery = { __typename?: 'Query', voucher?: { __typename?: 'Voucher', id: string, code: string, marketingConsentRequired: boolean, festivalEditions: Array<{ __typename?: 'FestivalEdition', code: string }> } | null };

export type IntegrationLinkPageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IntegrationLinkPageQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, name: string, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string }> } | null };

export type ContactDetailsFragment = { __typename?: 'Restaurant', id: string, name: string, address?: string | null, latitude?: number | null, longitude?: number | null, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, region: { __typename?: 'Region', id: string, name: string } };

export type CreateFavouriteRestaurantMutationVariables = Exact<{
  restaurantId: Scalars['ID'];
}>;


export type CreateFavouriteRestaurantMutation = { __typename?: 'Mutation', createFavorite: { __typename?: 'Favorite', restaurant: { __typename?: 'Restaurant', id: string, favorited: boolean } } };

export type DailyRestaurantListElementFragment = { __typename?: 'Restaurant', id: string, name: string, slug: string, description?: string | null, favorited: boolean, position: number, openingHours?: Array<{ __typename?: 'Hours', day: string, from?: string | null, to?: string | null }> | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null, position: number }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, reservables: Array<{ __typename?: 'Daily', id: string } | { __typename?: 'Event' } | { __typename?: 'FestivalEditionRestaurant' }> };

export type DestroyFavouriteRestaurantMutationVariables = Exact<{
  restaurantId: Scalars['ID'];
}>;


export type DestroyFavouriteRestaurantMutation = { __typename?: 'Mutation', destroyFavorite: { __typename?: 'Favorite', restaurant: { __typename?: 'Restaurant', id: string, favorited: boolean } } };

export type FerNodeFragment = { __typename?: 'FestivalEditionRestaurant', id: string, externalSaleUrl?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null }>, restaurant: { __typename?: 'Restaurant', id: string, name: string, favorited: boolean, description?: string | null, latitude?: number | null, longitude?: number | null, address?: string | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }> } };

export type FullRestaurantFragment = { __typename?: 'Restaurant', id: string, slug: string, address?: string | null, latitude?: number | null, longitude?: number | null, chef?: string | null, restaurator?: string | null, description?: string | null, establishmentYear?: number | null, name: string, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, rating?: number | null, favorited: boolean, ratingCount: number, openingState: string, menuFileUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, reservables: Array<{ __typename?: 'Daily', id: string, reservableFrom: string, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null } | { __typename?: 'Event', id: string, reservableFrom: string } | { __typename?: 'FestivalEditionRestaurant', id: string, price: number, allDaySlots: boolean, menusPerPerson: number, reservableFrom: string, externalSaleUrl?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null }>, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, festivalEdition: { __typename?: 'FestivalEdition', id: string, code: string, state: FestivalStateEnum, price: number, reservationFeeUnitPrice: number, forceLabels: boolean, startsAt: string, endsAt: string, reservableFrom: string, slots?: Array<{ __typename?: 'SlotDefinition', slotStart: number }> | null, festival: { __typename?: 'Festival', id: string, code: string, name: string, slogan: string, slug: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null } | null } } }>, openingHoursToday?: { __typename?: 'Hours', to?: string | null, day: string, from?: string | null } | null, restaurantDeliveryZones: Array<{ __typename?: 'RestaurantDeliveryZone', label: string, deliveryRadius: number, price: number }>, openingHours?: Array<{ __typename?: 'Hours', day: string, from?: string | null, to?: string | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, icon?: TagIconEnum | null, name: string, type: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null }>, zone: { __typename?: 'Zone', id: string, name: string, region: { __typename?: 'Region', id: string, name: string } }, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }> };

export type LeanMenuFragment = { __typename?: 'Menu', id?: string | null, label: string, position: number, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> };

export type LikeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LikeQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', favorited: boolean } | null };

export type OtherDatesRestaurantsQueryVariables = Exact<{
  region_id?: InputMaybe<Scalars['ID']>;
  reservation_filters?: InputMaybe<ReservationFilter>;
  tag_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  with_reservable_extras?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<RestaurantSort>;
}>;


export type OtherDatesRestaurantsQuery = { __typename?: 'Query', otherDatesRestaurants: { __typename?: 'Restaurants', totalCount: number, nodes?: Array<{ __typename?: 'Restaurant', id: string, name: string, slug: string, description?: string | null, favorited: boolean, position: number, latitude?: number | null, longitude?: number | null, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, reservables: Array<{ __typename: 'Daily', id: string } | { __typename: 'Event', id: string } | { __typename: 'FestivalEditionRestaurant', id: string }> } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null } } };

export type ReservablesQueryVariables = Exact<{
  restaurantId: Scalars['ID'];
  dates: DateRange;
}>;


export type ReservablesQuery = { __typename?: 'Query', reservables: Array<{ __typename?: 'Daily', id: string, possibleSlots?: Array<number> | null, reservableFrom: string, minPeopleCount: number, maxPeopleCount: number, restaurant: { __typename?: 'Restaurant', id: string }, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null, crossSells: Array<{ __typename?: 'CrossSell', id: string, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, festivalDrink: boolean, image?: { __typename?: 'ImageFile', preview?: string | null } | null }> } | { __typename?: 'Event' } | { __typename?: 'FestivalEditionRestaurant', id: string, allDaySlots: boolean, notes?: string | null, price: number, menusPerPerson: number, availableReservationTypes: Array<ReservationTypeEnum>, reservableFrom: string, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, restaurant: { __typename?: 'Restaurant', id: string }, festivalEdition: { __typename?: 'FestivalEdition', id: string, code: string, startsAt: string, endsAt: string, state: FestivalStateEnum, price: number, minPeopleCount: number, maxPeopleCount: number, forceLabels: boolean, reservableFrom: string, menuPositions: Array<{ __typename: 'FestivalEditionMenuPosition' }>, festival: { __typename?: 'Festival', id: string, code: string, name: string, slogan: string, shortDescription: string, slug: string }, slots?: Array<{ __typename?: 'SlotDefinition', id?: string | null, possibleSlots: Array<number>, slotStart: number }> | null }, crossSells: Array<{ __typename?: 'CrossSell', id: string, name: string, description: string, extraDescription?: string | null, price: number, peopleCountLimited: boolean, quantityLimitedToOne: boolean, adult: boolean, internal: boolean, fill: boolean, position: number, categorySlug?: string | null, festivalDrink: boolean, image?: { __typename?: 'ImageFile', preview?: string | null } | null }> }> };

export type RestaurantListElementFragment = { __typename?: 'Restaurant', id: string, name: string, slug: string, description?: string | null, favorited: boolean, position: number, latitude?: number | null, longitude?: number | null, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, reservables: Array<{ __typename: 'Daily', id: string } | { __typename: 'Event', id: string } | { __typename: 'FestivalEditionRestaurant', id: string }> };

export type RestaurantMenuQueryVariables = Exact<{
  ferId: Scalars['ID'];
  type: ReservableEnum;
}>;


export type RestaurantMenuQuery = { __typename?: 'Query', reservable: { __typename?: 'Daily' } | { __typename?: 'Event' } | { __typename?: 'FestivalEditionRestaurant', menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null } };

export type RestaurantSlugQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestaurantSlugQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', slug: string } | null };

export type RestaurantsListQueryVariables = Exact<{
  region_id?: InputMaybe<Scalars['ID']>;
  reservation_filters?: InputMaybe<ReservationFilter>;
  tag_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  with_reservable_extras?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<RestaurantSort>;
}>;


export type RestaurantsListQuery = { __typename?: 'Query', restaurants: { __typename?: 'Restaurants', totalCount: number, nodes?: Array<{ __typename?: 'Restaurant', id: string, name: string, slug: string, description?: string | null, favorited: boolean, position: number, latitude?: number | null, longitude?: number | null, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, reservables: Array<{ __typename: 'Daily', id: string } | { __typename: 'Event', id: string } | { __typename: 'FestivalEditionRestaurant', id: string }> } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null } } };

export type RestaurantsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type RestaurantsQueryQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }> };

export type GetBasicRestaurantQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBasicRestaurantQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string } | null };

export type SingleRestaurantQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SingleRestaurantQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', favorited: boolean, id: string, slug: string, address?: string | null, latitude?: number | null, longitude?: number | null, chef?: string | null, restaurator?: string | null, description?: string | null, establishmentYear?: number | null, name: string, phoneNumber?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, rating?: number | null, ratingCount: number, openingState: string, menuFileUrl?: string | null, urls?: Array<{ __typename?: 'RestaurantUrl', url: string, urlType: RestaurantUrlTypeEnum }> | null, reservables: Array<{ __typename?: 'Daily', id: string, reservableFrom: string, slotDefinitions?: Array<{ __typename?: 'SlotDefinition', possibleSlots: Array<number> }> | null } | { __typename?: 'Event', id: string, reservableFrom: string } | { __typename?: 'FestivalEditionRestaurant', id: string, price: number, allDaySlots: boolean, menusPerPerson: number, reservableFrom: string, externalSaleUrl?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null }>, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null, festivalEdition: { __typename?: 'FestivalEdition', id: string, code: string, state: FestivalStateEnum, price: number, reservationFeeUnitPrice: number, forceLabels: boolean, startsAt: string, endsAt: string, reservableFrom: string, slots?: Array<{ __typename?: 'SlotDefinition', slotStart: number }> | null, festival: { __typename?: 'Festival', id: string, code: string, name: string, slogan: string, slug: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null } | null } } }>, openingHoursToday?: { __typename?: 'Hours', to?: string | null, day: string, from?: string | null } | null, restaurantDeliveryZones: Array<{ __typename?: 'RestaurantDeliveryZone', label: string, deliveryRadius: number, price: number }>, openingHours?: Array<{ __typename?: 'Hours', day: string, from?: string | null, to?: string | null }> | null, tags: Array<{ __typename?: 'Tag', id: string, icon?: TagIconEnum | null, name: string, type: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null }>, zone: { __typename?: 'Zone', id: string, name: string, region: { __typename?: 'Region', id: string, name: string } }, reservableExtras: Array<{ __typename?: 'ReservableExtra', id: string, name: string, slug: string, price: number, description: string, enabled: boolean, reservableFrom: string, image?: { __typename?: 'ImageFile', id: string, preview?: string | null, original?: string | null, thumbnail?: string | null } | null, menus?: Array<{ __typename?: 'Menu', id?: string | null, label: string, position: number, imageFile?: { __typename?: 'ImageFile', id: string, original?: string | null, preview?: string | null } | null, positions: Array<{ __typename?: 'MenuPosition', name: string, content: string }> }> | null }> } | null };

export type PrivacyPolicyQueryVariables = Exact<{
  type?: InputMaybe<DocumentTypeEnum>;
}>;


export type PrivacyPolicyQuery = { __typename?: 'Query', documents: { __typename?: 'Documents', nodes?: Array<{ __typename?: 'Document', id: string, title: string, richText: string } | null> | null } };

export type RegulationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RegulationQuery = { __typename?: 'Query', document: { __typename?: 'Document', id: string, title: string, richText: string } };

export type RegulationsQueryVariables = Exact<{ [key: string]: never; }>;


export type RegulationsQuery = { __typename?: 'Query', documents: { __typename?: 'Documents', nodes?: Array<{ __typename?: 'Document', id: string, title: string, festivalEdition?: { __typename?: 'FestivalEdition', id: string } | null } | null> | null } };

export type AppleSignInMutationVariables = Exact<{
  appleIdentityToken: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userIdentityId?: InputMaybe<Scalars['String']>;
}>;


export type AppleSignInMutation = { __typename?: 'Mutation', appleSignIn: { __typename?: 'AppleSignInPayload', authToken?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null } };

export type CardImageFragment = { __typename?: 'Card', brand: string, canBeDestroyed: boolean, default: boolean, expiryDate: string, id: string, last4Digits: string, name: string };

export type CheckCardQueryVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type CheckCardQuery = { __typename?: 'Query', checkCard?: { __typename?: 'Card', id: string } | null };

export type ConfirmUserMutationVariables = Exact<{
  confirmationToken: Scalars['String'];
}>;


export type ConfirmUserMutation = { __typename?: 'Mutation', confirmUser: { __typename?: 'ConfirmUserPayload', user: { __typename?: 'User', id: string } } };

export type DeleteCardMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCardMutation = { __typename?: 'Mutation', deleteCard?: { __typename?: 'Card', id: string } | null };

export type FacebookSignInMutationVariables = Exact<{
  accessToken: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
}>;


export type FacebookSignInMutation = { __typename?: 'Mutation', facebookSignIn: { __typename?: 'FacebookSignInPayload', authToken?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null } };

export type FavoriteRestaurantsQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoriteRestaurantsQuery = { __typename?: 'Query', favoriteRestaurants: Array<{ __typename?: 'Restaurant', id: string, name: string, slug: string, description?: string | null, favorited: boolean, position: number, latitude?: number | null, longitude?: number | null, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', id: string, preview?: string | null }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }>, reservables: Array<{ __typename: 'Daily', id: string } | { __typename: 'Event', id: string } | { __typename: 'FestivalEditionRestaurant', id: string }> }> };

export type GoogleSignInMutationVariables = Exact<{
  accessToken: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
}>;


export type GoogleSignInMutation = { __typename?: 'Mutation', googleSignIn: { __typename?: 'GoogleSignInPayload', authToken?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null } };

export type MyPastReservationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type MyPastReservationsQuery = { __typename?: 'Query', myReservations: { __typename?: 'Reservations', totalCount: number, nodes?: Array<{ __typename?: 'Reservation', id: string, canBeCancelled: boolean, canBeUpdated: boolean, code: string, passed: boolean, peopleCount: number, date: string, slot: number, review?: { __typename?: 'Review', id: string } | null, user?: { __typename?: 'User', id: string } | null, reservable?: { __typename: 'Daily', id: string, restaurant: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } } | { __typename: 'Event', id: string, title: string, slotless: boolean, eventRestaurant?: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }>, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } | { __typename: 'FestivalEditionRestaurant', id: string, allDaySlots: boolean, festivalEdition: { __typename?: 'FestivalEdition', festival: { __typename?: 'Festival', name: string } }, restaurant: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } } | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null } | null> | null } };

export type MyReservationsQueryVariables = Exact<{
  type: MyReservationsTypeEnum;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type MyReservationsQuery = { __typename?: 'Query', myReservations: { __typename?: 'Reservations', totalCount: number, nodes?: Array<{ __typename?: 'Reservation', id: string, canBeCancelled: boolean, canBeUpdated: boolean, code: string, passed: boolean, peopleCount: number, date: string, slot: number, review?: { __typename?: 'Review', id: string } | null, user?: { __typename?: 'User', id: string } | null, reservable?: { __typename: 'Daily', id: string, restaurant: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } } | { __typename: 'Event', id: string, title: string, slotless: boolean, eventRestaurant?: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }>, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } | { __typename: 'FestivalEditionRestaurant', id: string, allDaySlots: boolean, festivalEdition: { __typename?: 'FestivalEdition', festival: { __typename?: 'Festival', name: string } }, restaurant: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } } | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null } | null> | null } };

export type NewsletterSignUpMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type NewsletterSignUpMutation = { __typename?: 'Mutation', newsletterSignUp: { __typename?: 'NewsletterSignUp', salesmanagoContactId?: string | null } };

export type SetDefaultCardMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SetDefaultCardMutation = { __typename?: 'Mutation', setDefaultCard: { __typename?: 'Card', id: string } };

export type UserCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCardsQuery = { __typename?: 'Query', user?: { __typename?: 'User', cards?: Array<{ __typename?: 'Card', brand: string, canBeDestroyed: boolean, default: boolean, expiryDate: string, id: string, last4Digits: string, name: string }> | null } | null };

export type UserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDataQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, anonymous: boolean, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, verified: boolean, subscribed: boolean, hasMarketingConsent: boolean, hasPernodConsent: boolean, salesmanagoContactId?: string | null, regulationStatus: RegulationStatusEnum } | null };

export type AllTagsQueryVariables = Exact<{
  festivalEditionId?: InputMaybe<Scalars['ID']>;
  regionId?: InputMaybe<Scalars['ID']>;
}>;


export type AllTagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: string, name: string, tagCount: number, position: number, type: string }> };

export type ClientConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientConfigQuery = { __typename?: 'Query', clientConfigs: { __typename?: 'ClientConfig', d2dDefaultReservableFrom: string, reservableExtraDefaultReservableFrom: string } };

export type FirstUpcomingReservationQueryVariables = Exact<{ [key: string]: never; }>;


export type FirstUpcomingReservationQuery = { __typename?: 'Query', myReservations: { __typename?: 'Reservations', totalCount: number, edges?: Array<{ __typename?: 'ReservationsEdge', node?: { __typename?: 'Reservation', date: string, slot: number, reservable?: { __typename: 'Daily', id: string, restaurant: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } } | { __typename: 'Event', id: string, title: string, slotless: boolean, eventRestaurant?: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }>, metadatas: Array<{ __typename?: 'Metadata', id: string, key: string, value: string }> } | { __typename: 'FestivalEditionRestaurant', id: string, allDaySlots: boolean, festivalEdition: { __typename?: 'FestivalEdition', festival: { __typename?: 'Festival', name: string } }, restaurant: { __typename?: 'Restaurant', name: string, id: string, address?: string | null, imageFiles: Array<{ __typename?: 'ImageFile', preview?: string | null, id: string }> } } | null, reservableExtraAssignments?: Array<{ __typename?: 'ReservableExtraAssignment', reservableExtraId: string, menuId: string, quantity: number, id: string, menu: { __typename?: 'Menu', id?: string | null, position: number, label: string }, reservableExtra: { __typename?: 'ReservableExtra', id: string, name: string, price: number } }> | null } | null } | null> | null } };

export type ImageFragmentFragment = { __typename?: 'ImageFile', id: string, preview?: string | null, position: number };

export type LastVisitedRestaurantsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type LastVisitedRestaurantsQuery = { __typename?: 'Query', restaurants: { __typename?: 'Restaurants', nodes?: Array<{ __typename?: 'Restaurant', id: string, name: string, description?: string | null, slug: string, tags: Array<{ __typename?: 'Tag', id: string, type: string, name: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', position: number, thumbnail?: string | null }> } | null> | null } };

export type PopularTagsQueryVariables = Exact<{
  region_id: Scalars['ID'];
}>;


export type PopularTagsQuery = { __typename?: 'Query', popularTags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }> };

export type RegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionsQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', latitude: number, longitude: number, id: string, name: string, hidden: boolean, currentTenant: string, eventsEnabled: boolean }> };

export type ResolveRestaurantCodeQueryVariables = Exact<{
  code: Scalars['ID'];
}>;


export type ResolveRestaurantCodeQuery = { __typename?: 'Query', decodeRestaurant: { __typename?: 'DecodedRestaurant', id?: string | null, sourceId?: number | null } };

export type ResolveUrlSlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ResolveUrlSlugQuery = { __typename?: 'Query', resolveUrlSlug?: { __typename?: 'UrlResolverResult', objectId: string, objectType: string } | null };

export type SearchQueryVariables = Exact<{
  text: Scalars['String'];
  regionId?: InputMaybe<Scalars['ID']>;
}>;


export type SearchQuery = { __typename?: 'Query', search: Array<{ __typename?: 'Collection' } | { __typename?: 'Restaurant', id: string, name: string, description?: string | null, slug: string, tags: Array<{ __typename?: 'Tag', id: string, type: string, name: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', position: number, thumbnail?: string | null }> } | { __typename?: 'Tag', id: string, name: string, type: string, position: number }> };

export type SelectedRegionQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectedRegionQuery = { __typename?: 'Query', selectedRegion?: { __typename?: 'CookieRegion', id: string, name: string, isProposed: boolean } | null };

export type SmartSearchRestaurantFragment = { __typename?: 'Restaurant', id: string, name: string, description?: string | null, slug: string, tags: Array<{ __typename?: 'Tag', id: string, type: string, name: string, position: number }>, imageFiles: Array<{ __typename?: 'ImageFile', position: number, thumbnail?: string | null }> };

export type TagFragmentFragment = { __typename?: 'Tag', id: string, name: string, type: string, position: number };

export type TagsListQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsListQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: string, name: string }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, type: string, position: number }> };

export const LeanReservationGuestFragmentDoc = gql`
    fragment LeanReservationGuest on ReservationGuest {
  id
  confirmedAt
  email
  user {
    id
    firstName
  }
}
    `;
export const ChefsMenuAssignmentFragmentDoc = gql`
    fragment ChefsMenuAssignment on ReservableExtraAssignment {
  reservableExtraId
  id: menuId
  menuId
  quantity
  menu {
    id
    position
    label
  }
  reservableExtra {
    id
    name
    price
  }
}
    `;
export const ContactDetailsFragmentDoc = gql`
    fragment ContactDetails on Restaurant {
  id
  name
  address
  latitude
  longitude
  phoneNumber
  urls {
    url
    urlType
  }
  facebookUrl
  instagramUrl
  imageFiles {
    id
    preview
  }
  region {
    id
    name
  }
}
    `;
export const InviteDataFragmentDoc = gql`
    fragment InviteData on Reservation {
  id
  canBeUpdated
  canBeCancelled
  passed
  code
  createdAt
  date
  slot
  peopleCount
  status
  user {
    id
    firstName
    lastName
  }
  reservationGuests {
    ...LeanReservationGuest
  }
  guestInvitationUrl
  reservableExtraAssignments {
    ...ChefsMenuAssignment
  }
  reservable {
    __typename
    ... on Daily {
      id
      restaurant {
        ...ContactDetails
        slug
      }
    }
    ... on Event {
      id
      title
      imageFiles {
        preview
        id
      }
      eventRestaurant: restaurant {
        ...ContactDetails
        slug
      }
      slotless
      metadatas {
        id
        key
        value
      }
    }
    ... on FestivalEditionRestaurant {
      id
      allDaySlots
      festivalEdition {
        id
        festival {
          id
          code
        }
      }
      restaurant {
        ...ContactDetails
        slug
      }
    }
  }
}
    ${LeanReservationGuestFragmentDoc}
${ChefsMenuAssignmentFragmentDoc}
${ContactDetailsFragmentDoc}`;
export const SelectedFerMenusFragmentDoc = gql`
    fragment SelectedFERMenus on FestivalEditionRestaurant {
  id
  menus {
    label
  }
  festivalEdition {
    id
    forceLabels
  }
}
    `;
export const SelectedMenusFragmentDoc = gql`
    fragment SelectedMenus on Reservation {
  menus
  reservable {
    ... on FestivalEditionRestaurant {
      ...SelectedFERMenus
    }
  }
}
    ${SelectedFerMenusFragmentDoc}`;
export const TagFragmentFragmentDoc = gql`
    fragment TagFragment on Tag {
  id
  name
  type
  position
}
    `;
export const RestaurantInReservableExtraFragmentDoc = gql`
    fragment RestaurantInReservableExtra on Restaurant {
  id
  name
  slug
  chef
  description
  establishmentYear
  favorited
  reservables {
    ... on Daily {
      id
      slotDefinitions {
        possibleSlots
      }
    }
    ... on FestivalEditionRestaurant {
      id
    }
    ... on Event {
      id
    }
  }
  openingHours {
    day
    from
    to
  }
  tags {
    ...TagFragment
  }
  imageFiles {
    id
    preview
  }
}
    ${TagFragmentFragmentDoc}`;
export const RestaurantListElementFragmentDoc = gql`
    fragment RestaurantListElement on Restaurant {
  id
  name
  slug
  description
  favorited
  position
  latitude
  longitude
  address
  imageFiles {
    id
    preview
  }
  tags {
    ...TagFragment
  }
  reservables {
    __typename
    ... on Daily {
      id
    }
    ... on Event {
      id
    }
    ... on FestivalEditionRestaurant {
      id
    }
  }
}
    ${TagFragmentFragmentDoc}`;
export const ReservationOfferFragmentDoc = gql`
    fragment ReservationOffer on ReservableExtra {
  id
  name
  slug
  price
  description
  image {
    id
    preview
    original
    thumbnail
  }
  enabled
  reservableFrom
  restaurant {
    name
    id
    slug
    favorited
    reservables {
      ... on Daily {
        id
        slotDefinitions {
          id
          possibleSlots
        }
      }
      ... on FestivalEditionRestaurant {
        id
      }
      ... on Event {
        id
      }
    }
    tags {
      id
      name
      type
      position
    }
    imageFiles {
      id
      preview
    }
  }
}
    `;
export const LeanCollectionFragmentDoc = gql`
    fragment LeanCollection on PolymorphicCollection {
  id
  category
  title
  regionId
  festivalEditionRestaurants {
    restaurant {
      ...RestaurantListElement
    }
  }
  reservableExtras {
    ...ReservationOffer
  }
  restaurants {
    ...RestaurantListElement
  }
}
    ${RestaurantListElementFragmentDoc}
${ReservationOfferFragmentDoc}`;
export const MainPageBannerFragmentDoc = gql`
    fragment MainPageBanner on Banner {
  id
  href
  files
  alt
}
    `;
export const CrossSellsFragmentDoc = gql`
    fragment CrossSells on CrossSell {
  id
  name
  image {
    id
    preview
  }
  price
}
    `;
export const LeanCrossSellFragmentDoc = gql`
    fragment LeanCrossSell on CrossSell {
  id
  name
  description
  extraDescription
  price
  image {
    preview
  }
  peopleCountLimited
  quantityLimitedToOne
  adult
  internal
  fill
  position
  categorySlug
  festivalDrink
}
    `;
export const FullMenuFragmentDoc = gql`
    fragment FullMenu on Menu {
  id
  imageFile {
    id
    original
    preview
  }
  label
  position
  positions {
    name
    content
  }
}
    `;
export const ReservableExtraMenusFragmentDoc = gql`
    fragment ReservableExtraMenus on ReservableExtra {
  menus {
    ...FullMenu
  }
}
    ${FullMenuFragmentDoc}`;
export const LeanReservableExtraFragmentDoc = gql`
    fragment LeanReservableExtra on ReservableExtra {
  ...ReservableExtraMenus
  id
  name
  slug
  price
  description
  enabled
  reservableFrom
  image {
    id
    preview
    original
    thumbnail
  }
}
    ${ReservableExtraMenusFragmentDoc}`;
export const DailyReservationReservableFragmentDoc = gql`
    fragment DailyReservationReservable on Daily {
  id
  price
  crossSells {
    festivalDrink
    ...LeanCrossSell
  }
  restaurant {
    slug
    festivalEditionRestaurants {
      id
      festivalEdition {
        state
      }
    }
    ...ContactDetails
    reservableExtras {
      ...LeanReservableExtra
    }
  }
  slotDefinitions {
    possibleSlots
  }
}
    ${LeanCrossSellFragmentDoc}
${ContactDetailsFragmentDoc}
${LeanReservableExtraFragmentDoc}`;
export const EventReservationReservableFragmentDoc = gql`
    fragment EventReservationReservable on Event {
  id
  code
  title
  slotless
  minPeopleCount
  maxPeopleCount
  description
  startsAt
  endsAt
  imageFiles {
    id
    preview
  }
  menus {
    ...FullMenu
  }
  menusPerPerson
  slots {
    possibleSlots
  }
  eventRestaurant: restaurant {
    slug
    ...ContactDetails
  }
  metadatas {
    id
    key
    value
  }
}
    ${FullMenuFragmentDoc}
${ContactDetailsFragmentDoc}`;
export const FestivalReservationReservableFragmentDoc = gql`
    fragment FestivalReservationReservable on FestivalEditionRestaurant {
  id
  menusPerPerson
  menus {
    ...FullMenu
  }
  imageFiles {
    preview
  }
  crossSellAssignments {
    saleEnabled
    festivalEditionCrossSell {
      crossSell {
        id
        name
        description
        extraDescription
        price
        image {
          preview
        }
        peopleCountLimited
        quantityLimitedToOne
        adult
        internal
        fill
        position
        categorySlug
        __typename
      }
      __typename
    }
    __typename
  }
  festivalEdition {
    id
    code
    forceLabels
    slots {
      possibleSlots
    }
    festival {
      id
      code
      slug
      metadatas {
        id
        key
        value
      }
    }
  }
  allDaySlots
  crossSells {
    id
    festivalDrink
    ...LeanCrossSell
  }
  restaurant {
    slug
    ...ContactDetails
  }
}
    ${FullMenuFragmentDoc}
${LeanCrossSellFragmentDoc}
${ContactDetailsFragmentDoc}`;
export const ReservationCrossSellFragmentFragmentDoc = gql`
    fragment ReservationCrossSellFragment on ReservationCrossSell {
  id
  quantity
  crossSell {
    id
    name
    price
  }
}
    `;
export const RestaurantDataFragmentDoc = gql`
    fragment RestaurantData on Restaurant {
  name
  id
  address
  imageFiles {
    preview
    id
  }
}
    `;
export const ReservationModalFragmentDoc = gql`
    fragment ReservationModal on Reservation {
  date
  slot
  reservable {
    __typename
    ... on Daily {
      id
      restaurant {
        ...RestaurantData
      }
    }
    ... on FestivalEditionRestaurant {
      id
      festivalEdition {
        festival {
          name
        }
      }
      allDaySlots
      restaurant {
        ...RestaurantData
      }
    }
    ... on Event {
      id
      eventRestaurant: restaurant {
        ...RestaurantData
      }
      imageFiles {
        preview
        id
      }
      title
      slotless
      metadatas {
        id
        key
        value
      }
    }
  }
  reservableExtraAssignments {
    ...ChefsMenuAssignment
  }
}
    ${RestaurantDataFragmentDoc}
${ChefsMenuAssignmentFragmentDoc}`;
export const ReservationListElementFragmentDoc = gql`
    fragment ReservationListElement on Reservation {
  id
  canBeCancelled
  canBeUpdated
  code
  passed
  peopleCount
  date
  slot
  review {
    id
  }
  user {
    id
  }
  ...ReservationModal
}
    ${ReservationModalFragmentDoc}`;
export const MinimumReservationCrossSellFragmentDoc = gql`
    fragment MinimumReservationCrossSell on ReservationCrossSell {
  quantity
  crossSell {
    id
  }
}
    `;
export const MinimumPreviousReservationFragmentDoc = gql`
    fragment MinimumPreviousReservation on Reservation {
  previousReservation {
    reservationCrossSells {
      ...MinimumReservationCrossSell
    }
    peopleCount
    slot
    date
    reservableExtraAssignments {
      quantity
      menuId
      reservableExtraId
    }
  }
}
    ${MinimumReservationCrossSellFragmentDoc}`;
export const ReservationPricesFragmentDoc = gql`
    fragment ReservationPrices on Reservation {
  lastOrderPrice
  discount {
    value
    code
    id
  }
  reservationCrossSells {
    crossSell {
      name
      price
      id
    }
    isApplicable
    quantity
    id
  }
  discount {
    code
    value
    type
  }
  priceValues {
    basePrice
    crossSellsPrice
    deliveryFee
    feeablePeopleCount
    priceToPay
    totalValue
    reservationFee
    reservationFeeUnitPrice
    discountValue
    reservableExtrasPrice
    primeTimeFeeIncludedInBaseUnitPrice
  }
  reservationSummarySheet {
    currentTenant
    details
    identifier
    label
    price
    quantity
  }
  reservableExtras {
    id
    name
    price
  }
  reservableExtraAssignments {
    ...ChefsMenuAssignment
  }
  reservable {
    ... on Daily {
      price
    }
    ... on FestivalEditionRestaurant {
      price
      festivalEdition {
        code
        price
        festival {
          name
        }
      }
    }
    ... on Event {
      price
      title
    }
  }
}
    ${ChefsMenuAssignmentFragmentDoc}`;
export const ReservationSummaryDataFragmentDoc = gql`
    fragment ReservationSummaryData on Reservation {
  __typename
  id
  canBeUpdated
  canBeCancelled
  canBeDiscounted
  code
  createdAt
  expired
  festivalDrinkRequiredQuantity
  reservableExtrasAvailable
  hasReservableExtra
  date
  slot
  menus
  peopleCount
  expiresAt
  timestamp @client
  status
  notes
  vatId
  permittedPaymentMethods
  autoDiscountsAvailable
  user {
    id
    firstName
    lastName
  }
  ...MinimumPreviousReservation
  lastOrderPrice
  ...ReservationPrices
  reservableExtras {
    ...LeanReservableExtra
  }
  reservableExtraAssignments {
    ...ChefsMenuAssignment
  }
}
    ${MinimumPreviousReservationFragmentDoc}
${ReservationPricesFragmentDoc}
${LeanReservableExtraFragmentDoc}
${ChefsMenuAssignmentFragmentDoc}`;
export const ReservationWithCrossSellsFragmentDoc = gql`
    fragment ReservationWithCrossSells on Reservation {
  id
  code
}
    `;
export const SlotDurationFragmentDoc = gql`
    fragment SlotDuration on Reservation {
  reservable {
    __typename
    ... on Daily {
      slotDuration
    }
    ... on Event {
      slots {
        duration
      }
    }
    ... on FestivalEditionRestaurant {
      festivalEdition {
        allDaySlots
        slotDuration
      }
    }
  }
}
    `;
export const ImageFragmentFragmentDoc = gql`
    fragment ImageFragment on ImageFile {
  id
  preview
  position
}
    `;
export const DailyRestaurantListElementFragmentDoc = gql`
    fragment DailyRestaurantListElement on Restaurant {
  id
  name
  slug
  description
  favorited
  position
  openingHours {
    day
    from
    to
  }
  imageFiles {
    ...ImageFragment
  }
  tags {
    ...TagFragment
  }
  reservables {
    ... on Daily {
      id
    }
  }
}
    ${ImageFragmentFragmentDoc}
${TagFragmentFragmentDoc}`;
export const FerNodeFragmentDoc = gql`
    fragment FERNode on FestivalEditionRestaurant {
  id
  externalSaleUrl
  imageFiles(scope: WITH_RESTAURANT) {
    id
    preview
    original
  }
  restaurant {
    id
    name
    favorited
    description
    latitude
    longitude
    address
    tags {
      id
      name
      type
      position
    }
  }
}
    `;
export const FullRestaurantFragmentDoc = gql`
    fragment FullRestaurant on Restaurant {
  id
  slug
  address
  latitude
  longitude
  chef
  restaurator
  description
  establishmentYear
  name
  phoneNumber
  facebookUrl
  instagramUrl
  rating
  favorited
  ratingCount
  openingState
  urls {
    url
    urlType
  }
  reservables {
    ... on Daily {
      id
      slotDefinitions {
        possibleSlots
      }
      reservableFrom
    }
    ... on Event {
      id
      reservableFrom
    }
    ... on FestivalEditionRestaurant {
      id
      price
      allDaySlots
      menusPerPerson
      imageFiles {
        id
        preview
        original
      }
      reservableFrom
      menus {
        ...FullMenu
      }
      externalSaleUrl
      festivalEdition {
        id
        code
        state
        price
        reservationFeeUnitPrice
        slots {
          slotStart
        }
        forceLabels
        startsAt
        endsAt
        reservableFrom
        festival {
          id
          code
          name
          slogan
          slug
          image {
            id
            preview
          }
        }
      }
    }
  }
  openingHoursToday {
    to
    day
    from
  }
  menuFileUrl
  restaurantDeliveryZones {
    label
    deliveryRadius
    price
  }
  openingHours {
    day
    from
    to
  }
  tags {
    id
    icon
    name
    type
    position
  }
  imageFiles {
    id
    preview
    original
  }
  zone {
    id
    name
    region {
      id
      name
    }
  }
  reservableExtras {
    ...LeanReservableExtra
  }
}
    ${FullMenuFragmentDoc}
${LeanReservableExtraFragmentDoc}`;
export const LeanMenuFragmentDoc = gql`
    fragment LeanMenu on Menu {
  id
  label
  position
  positions {
    name
    content
  }
}
    `;
export const CardImageFragmentDoc = gql`
    fragment CardImage on Card {
  brand
  canBeDestroyed
  default
  expiryDate
  id
  last4Digits
  name
}
    `;
export const SmartSearchRestaurantFragmentDoc = gql`
    fragment SmartSearchRestaurant on Restaurant {
  id
  name
  description
  tags {
    id
    type
    name
    position
  }
  slug
  imageFiles {
    position
    thumbnail
  }
}
    `;
export const AcceptRegulationDocument = gql`
    mutation AcceptRegulation {
  acceptRegulation {
    id
    verified
    subscribed
    regulationStatus
  }
}
    `;
export type AcceptRegulationMutationFn = Apollo.MutationFunction<AcceptRegulationMutation, AcceptRegulationMutationVariables>;

/**
 * __useAcceptRegulationMutation__
 *
 * To run a mutation, you first call `useAcceptRegulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptRegulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptRegulationMutation, { data, loading, error }] = useAcceptRegulationMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptRegulationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptRegulationMutation, AcceptRegulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptRegulationMutation, AcceptRegulationMutationVariables>(AcceptRegulationDocument, options);
      }
export type AcceptRegulationMutationHookResult = ReturnType<typeof useAcceptRegulationMutation>;
export type AcceptRegulationMutationResult = Apollo.MutationResult<AcceptRegulationMutation>;
export type AcceptRegulationMutationOptions = Apollo.BaseMutationOptions<AcceptRegulationMutation, AcceptRegulationMutationVariables>;
export const CreateReviewDocument = gql`
    mutation createReview($text: String!, $code: String!, $ratings: RatingAttributes!, $securityToken: String) {
  createReview(
    text: $text
    reservationCode: $code
    ratings: $ratings
    securityToken: $securityToken
  ) {
    id
  }
}
    `;
export type CreateReviewMutationFn = Apollo.MutationFunction<CreateReviewMutation, CreateReviewMutationVariables>;

/**
 * __useCreateReviewMutation__
 *
 * To run a mutation, you first call `useCreateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewMutation, { data, loading, error }] = useCreateReviewMutation({
 *   variables: {
 *      text: // value for 'text'
 *      code: // value for 'code'
 *      ratings: // value for 'ratings'
 *      securityToken: // value for 'securityToken'
 *   },
 * });
 */
export function useCreateReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateReviewMutation, CreateReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReviewMutation, CreateReviewMutationVariables>(CreateReviewDocument, options);
      }
export type CreateReviewMutationHookResult = ReturnType<typeof useCreateReviewMutation>;
export type CreateReviewMutationResult = Apollo.MutationResult<CreateReviewMutation>;
export type CreateReviewMutationOptions = Apollo.BaseMutationOptions<CreateReviewMutation, CreateReviewMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($firstName: String!, $lastName: String!, $email: String!, $password: String, $phoneNumber: String!, $marketingConsentAccepted: Boolean, $regulationConsentAccepted: Boolean, $anonymous: Boolean, $consents: [UserConsentInput!]) {
  createUser(
    firstName: $firstName
    lastName: $lastName
    email: $email
    password: $password
    phoneNumber: $phoneNumber
    marketingConsentAccepted: $marketingConsentAccepted
    regulationConsentAccepted: $regulationConsentAccepted
    anonymous: $anonymous
    consents: $consents
  ) {
    user {
      id
      email
      phoneNumber
      firstName
      lastName
      verified
      salesmanagoContactId
      regulationStatus
      hasMarketingConsent
      hasPernodConsent
      anonymous
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      phoneNumber: // value for 'phoneNumber'
 *      marketingConsentAccepted: // value for 'marketingConsentAccepted'
 *      regulationConsentAccepted: // value for 'regulationConsentAccepted'
 *      anonymous: // value for 'anonymous'
 *      consents: // value for 'consents'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const ResetPasswordRequestDocument = gql`
    mutation ResetPasswordRequest($email: String!) {
  resetPasswordRequest(email: $email) {
    sent
  }
}
    `;
export type ResetPasswordRequestMutationFn = Apollo.MutationFunction<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>;

/**
 * __useResetPasswordRequestMutation__
 *
 * To run a mutation, you first call `useResetPasswordRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordRequestMutation, { data, loading, error }] = useResetPasswordRequestMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>(ResetPasswordRequestDocument, options);
      }
export type ResetPasswordRequestMutationHookResult = ReturnType<typeof useResetPasswordRequestMutation>;
export type ResetPasswordRequestMutationResult = Apollo.MutationResult<ResetPasswordRequestMutation>;
export type ResetPasswordRequestMutationOptions = Apollo.BaseMutationOptions<ResetPasswordRequestMutation, ResetPasswordRequestMutationVariables>;
export const SetPasswordDocument = gql`
    mutation SetPassword($resetPasswordToken: String!, $password: String!) {
  setPassword(resetPasswordToken: $resetPasswordToken, password: $password) {
    id
  }
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      resetPasswordToken: // value for 'resetPasswordToken'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const SignInDocument = gql`
    mutation SignIn($email: String!, $password: String!) {
  signIn(email: $email, password: $password) {
    user {
      id
      firstName
      lastName
      email
      phoneNumber
      verified
      salesmanagoContactId
      regulationStatus
    }
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignOutDocument = gql`
    mutation SignOut {
  signOut
}
    `;
export type SignOutMutationFn = Apollo.MutationFunction<SignOutMutation, SignOutMutationVariables>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(baseOptions?: Apollo.MutationHookOptions<SignOutMutation, SignOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(SignOutDocument, options);
      }
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<SignOutMutation, SignOutMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($firstName: String, $lastName: String, $phoneNumber: String, $hasMarketingConsent: Boolean, $consents: [UserConsentInput!]) {
  updateUser(
    firstName: $firstName
    lastName: $lastName
    phoneNumber: $phoneNumber
    hasMarketingConsent: $hasMarketingConsent
    consents: $consents
  ) {
    id
    firstName
    lastName
    phoneNumber
    hasMarketingConsent
    hasPernodConsent
    subscribed
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phoneNumber: // value for 'phoneNumber'
 *      hasMarketingConsent: // value for 'hasMarketingConsent'
 *      consents: // value for 'consents'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const AddReservationGuestDocument = gql`
    mutation addReservationGuest($reservationId: ID!, $email: String!) {
  addReservationGuest(reservationId: $reservationId, email: $email) {
    email
    id
    confirmedAt
    user {
      firstName
      lastName
      id
    }
  }
}
    `;
export type AddReservationGuestMutationFn = Apollo.MutationFunction<AddReservationGuestMutation, AddReservationGuestMutationVariables>;

/**
 * __useAddReservationGuestMutation__
 *
 * To run a mutation, you first call `useAddReservationGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReservationGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReservationGuestMutation, { data, loading, error }] = useAddReservationGuestMutation({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddReservationGuestMutation(baseOptions?: Apollo.MutationHookOptions<AddReservationGuestMutation, AddReservationGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReservationGuestMutation, AddReservationGuestMutationVariables>(AddReservationGuestDocument, options);
      }
export type AddReservationGuestMutationHookResult = ReturnType<typeof useAddReservationGuestMutation>;
export type AddReservationGuestMutationResult = Apollo.MutationResult<AddReservationGuestMutation>;
export type AddReservationGuestMutationOptions = Apollo.BaseMutationOptions<AddReservationGuestMutation, AddReservationGuestMutationVariables>;
export const ConfirmReservationDocument = gql`
    mutation confirmReservation($code: String!) {
  confirmManualReservation(code: $code) {
    id
    code
    confirmed
    date
    username
    phoneNumber
    peopleCount
    hour
    slot
    slotDuration
    restaurant {
      ...ContactDetails
    }
  }
}
    ${ContactDetailsFragmentDoc}`;
export type ConfirmReservationMutationFn = Apollo.MutationFunction<ConfirmReservationMutation, ConfirmReservationMutationVariables>;

/**
 * __useConfirmReservationMutation__
 *
 * To run a mutation, you first call `useConfirmReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmReservationMutation, { data, loading, error }] = useConfirmReservationMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConfirmReservationMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmReservationMutation, ConfirmReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmReservationMutation, ConfirmReservationMutationVariables>(ConfirmReservationDocument, options);
      }
export type ConfirmReservationMutationHookResult = ReturnType<typeof useConfirmReservationMutation>;
export type ConfirmReservationMutationResult = Apollo.MutationResult<ConfirmReservationMutation>;
export type ConfirmReservationMutationOptions = Apollo.BaseMutationOptions<ConfirmReservationMutation, ConfirmReservationMutationVariables>;
export const RememberMeDocument = gql`
    mutation rememberMe($code: String!, $email: String!, $rodoConsent: Boolean, $marketingConsent: Boolean) {
  rememberMe(
    code: $code
    email: $email
    marketingConsent: $marketingConsent
    rodoConsent: $rodoConsent
  ) {
    id
  }
}
    `;
export type RememberMeMutationFn = Apollo.MutationFunction<RememberMeMutation, RememberMeMutationVariables>;

/**
 * __useRememberMeMutation__
 *
 * To run a mutation, you first call `useRememberMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRememberMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rememberMeMutation, { data, loading, error }] = useRememberMeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      email: // value for 'email'
 *      rodoConsent: // value for 'rodoConsent'
 *      marketingConsent: // value for 'marketingConsent'
 *   },
 * });
 */
export function useRememberMeMutation(baseOptions?: Apollo.MutationHookOptions<RememberMeMutation, RememberMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RememberMeMutation, RememberMeMutationVariables>(RememberMeDocument, options);
      }
export type RememberMeMutationHookResult = ReturnType<typeof useRememberMeMutation>;
export type RememberMeMutationResult = Apollo.MutationResult<RememberMeMutation>;
export type RememberMeMutationOptions = Apollo.BaseMutationOptions<RememberMeMutation, RememberMeMutationVariables>;
export const ConfirmReservationGuestDocument = gql`
    mutation confirmReservationGuest($token: String!) {
  confirmReservationGuest(token: $token) {
    email
    id
  }
}
    `;
export type ConfirmReservationGuestMutationFn = Apollo.MutationFunction<ConfirmReservationGuestMutation, ConfirmReservationGuestMutationVariables>;

/**
 * __useConfirmReservationGuestMutation__
 *
 * To run a mutation, you first call `useConfirmReservationGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmReservationGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmReservationGuestMutation, { data, loading, error }] = useConfirmReservationGuestMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useConfirmReservationGuestMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmReservationGuestMutation, ConfirmReservationGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmReservationGuestMutation, ConfirmReservationGuestMutationVariables>(ConfirmReservationGuestDocument, options);
      }
export type ConfirmReservationGuestMutationHookResult = ReturnType<typeof useConfirmReservationGuestMutation>;
export type ConfirmReservationGuestMutationResult = Apollo.MutationResult<ConfirmReservationGuestMutation>;
export type ConfirmReservationGuestMutationOptions = Apollo.BaseMutationOptions<ConfirmReservationGuestMutation, ConfirmReservationGuestMutationVariables>;
export const InvitePageDocument = gql`
    query InvitePage($securityToken: String) {
  reservation(securityToken: $securityToken) {
    ...InviteData
    ...SlotDuration
  }
}
    ${InviteDataFragmentDoc}
${SlotDurationFragmentDoc}`;

/**
 * __useInvitePageQuery__
 *
 * To run a query within a React component, call `useInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitePageQuery({
 *   variables: {
 *      securityToken: // value for 'securityToken'
 *   },
 * });
 */
export function useInvitePageQuery(baseOptions?: Apollo.QueryHookOptions<InvitePageQuery, InvitePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitePageQuery, InvitePageQueryVariables>(InvitePageDocument, options);
      }
export function useInvitePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitePageQuery, InvitePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitePageQuery, InvitePageQueryVariables>(InvitePageDocument, options);
        }
export type InvitePageQueryHookResult = ReturnType<typeof useInvitePageQuery>;
export type InvitePageLazyQueryHookResult = ReturnType<typeof useInvitePageLazyQuery>;
export type InvitePageQueryResult = Apollo.QueryResult<InvitePageQuery, InvitePageQueryVariables>;
export const KlarnaCreateOrderDocument = gql`
    mutation klarnaCreateOrder($reservationId: ID!, $authToken: String!) {
  klarnaCreateOrder(reservationId: $reservationId, authToken: $authToken) {
    fraudStatus
    orderId
    redirectUrl
    payload
  }
}
    `;
export type KlarnaCreateOrderMutationFn = Apollo.MutationFunction<KlarnaCreateOrderMutation, KlarnaCreateOrderMutationVariables>;

/**
 * __useKlarnaCreateOrderMutation__
 *
 * To run a mutation, you first call `useKlarnaCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKlarnaCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [klarnaCreateOrderMutation, { data, loading, error }] = useKlarnaCreateOrderMutation({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *      authToken: // value for 'authToken'
 *   },
 * });
 */
export function useKlarnaCreateOrderMutation(baseOptions?: Apollo.MutationHookOptions<KlarnaCreateOrderMutation, KlarnaCreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KlarnaCreateOrderMutation, KlarnaCreateOrderMutationVariables>(KlarnaCreateOrderDocument, options);
      }
export type KlarnaCreateOrderMutationHookResult = ReturnType<typeof useKlarnaCreateOrderMutation>;
export type KlarnaCreateOrderMutationResult = Apollo.MutationResult<KlarnaCreateOrderMutation>;
export type KlarnaCreateOrderMutationOptions = Apollo.BaseMutationOptions<KlarnaCreateOrderMutation, KlarnaCreateOrderMutationVariables>;
export const KlarnaCreateSessionDocument = gql`
    mutation klarnaCreateSession($reservationId: ID!) {
  klarnaCreateSession(reservationId: $reservationId) {
    clientToken
    sessionId
    paymentMethodCategories
    payload
  }
}
    `;
export type KlarnaCreateSessionMutationFn = Apollo.MutationFunction<KlarnaCreateSessionMutation, KlarnaCreateSessionMutationVariables>;

/**
 * __useKlarnaCreateSessionMutation__
 *
 * To run a mutation, you first call `useKlarnaCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKlarnaCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [klarnaCreateSessionMutation, { data, loading, error }] = useKlarnaCreateSessionMutation({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useKlarnaCreateSessionMutation(baseOptions?: Apollo.MutationHookOptions<KlarnaCreateSessionMutation, KlarnaCreateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KlarnaCreateSessionMutation, KlarnaCreateSessionMutationVariables>(KlarnaCreateSessionDocument, options);
      }
export type KlarnaCreateSessionMutationHookResult = ReturnType<typeof useKlarnaCreateSessionMutation>;
export type KlarnaCreateSessionMutationResult = Apollo.MutationResult<KlarnaCreateSessionMutation>;
export type KlarnaCreateSessionMutationOptions = Apollo.BaseMutationOptions<KlarnaCreateSessionMutation, KlarnaCreateSessionMutationVariables>;
export const KlarnaUpdateSessionDocument = gql`
    mutation klarnaUpdateSession($reservationId: ID!, $sessionId: String!) {
  klarnaUpdateSession(reservationId: $reservationId, sessionId: $sessionId)
}
    `;
export type KlarnaUpdateSessionMutationFn = Apollo.MutationFunction<KlarnaUpdateSessionMutation, KlarnaUpdateSessionMutationVariables>;

/**
 * __useKlarnaUpdateSessionMutation__
 *
 * To run a mutation, you first call `useKlarnaUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKlarnaUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [klarnaUpdateSessionMutation, { data, loading, error }] = useKlarnaUpdateSessionMutation({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useKlarnaUpdateSessionMutation(baseOptions?: Apollo.MutationHookOptions<KlarnaUpdateSessionMutation, KlarnaUpdateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KlarnaUpdateSessionMutation, KlarnaUpdateSessionMutationVariables>(KlarnaUpdateSessionDocument, options);
      }
export type KlarnaUpdateSessionMutationHookResult = ReturnType<typeof useKlarnaUpdateSessionMutation>;
export type KlarnaUpdateSessionMutationResult = Apollo.MutationResult<KlarnaUpdateSessionMutation>;
export type KlarnaUpdateSessionMutationOptions = Apollo.BaseMutationOptions<KlarnaUpdateSessionMutation, KlarnaUpdateSessionMutationVariables>;
export const CheckoutFerOfferSlotsDocument = gql`
    query CheckoutFEROfferSlots($dates: DateRange!, $reservables: [ReservableInput!]!) {
  slots(dates: $dates, reservables: $reservables) {
    sizes
    slot
    date
    reservable {
      ... on FestivalEditionRestaurant {
        id
        festivalEdition {
          id
          price
          festival {
            name
            image {
              preview
              id
            }
          }
        }
        menus {
          ...FullMenu
        }
        restaurant {
          imageFiles {
            preview
            id
          }
        }
      }
    }
  }
}
    ${FullMenuFragmentDoc}`;

/**
 * __useCheckoutFerOfferSlotsQuery__
 *
 * To run a query within a React component, call `useCheckoutFerOfferSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutFerOfferSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutFerOfferSlotsQuery({
 *   variables: {
 *      dates: // value for 'dates'
 *      reservables: // value for 'reservables'
 *   },
 * });
 */
export function useCheckoutFerOfferSlotsQuery(baseOptions: Apollo.QueryHookOptions<CheckoutFerOfferSlotsQuery, CheckoutFerOfferSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutFerOfferSlotsQuery, CheckoutFerOfferSlotsQueryVariables>(CheckoutFerOfferSlotsDocument, options);
      }
export function useCheckoutFerOfferSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutFerOfferSlotsQuery, CheckoutFerOfferSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutFerOfferSlotsQuery, CheckoutFerOfferSlotsQueryVariables>(CheckoutFerOfferSlotsDocument, options);
        }
export type CheckoutFerOfferSlotsQueryHookResult = ReturnType<typeof useCheckoutFerOfferSlotsQuery>;
export type CheckoutFerOfferSlotsLazyQueryHookResult = ReturnType<typeof useCheckoutFerOfferSlotsLazyQuery>;
export type CheckoutFerOfferSlotsQueryResult = Apollo.QueryResult<CheckoutFerOfferSlotsQuery, CheckoutFerOfferSlotsQueryVariables>;
export const PayuPaymentMethodsDocument = gql`
    query PayuPaymentMethods {
  payuPaymentMethods {
    currentTenant
    payByLinks {
      name
      value
      brandImageUrl
    }
  }
}
    `;

/**
 * __usePayuPaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePayuPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayuPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayuPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePayuPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<PayuPaymentMethodsQuery, PayuPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayuPaymentMethodsQuery, PayuPaymentMethodsQueryVariables>(PayuPaymentMethodsDocument, options);
      }
export function usePayuPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayuPaymentMethodsQuery, PayuPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayuPaymentMethodsQuery, PayuPaymentMethodsQueryVariables>(PayuPaymentMethodsDocument, options);
        }
export type PayuPaymentMethodsQueryHookResult = ReturnType<typeof usePayuPaymentMethodsQuery>;
export type PayuPaymentMethodsLazyQueryHookResult = ReturnType<typeof usePayuPaymentMethodsLazyQuery>;
export type PayuPaymentMethodsQueryResult = Apollo.QueryResult<PayuPaymentMethodsQuery, PayuPaymentMethodsQueryVariables>;
export const PurchaseReservationDocument = gql`
    mutation PurchaseReservation($code: String!, $paymentMethod: PaymentMethodEnum, $paymentProvider: PaymentProviderEnum, $extraParams: PaymentExtraParamsInput, $cardId: ID) {
  purchaseReservation(
    code: $code
    paymentMethod: $paymentMethod
    paymentProvider: $paymentProvider
    extraParams: $extraParams
    cardId: $cardId
  ) {
    reservation {
      id
      code
      guestInvitationUrl
      status
      lastOrderPrice
    }
    checkoutPageUrl
    cryptKey
  }
}
    `;
export type PurchaseReservationMutationFn = Apollo.MutationFunction<PurchaseReservationMutation, PurchaseReservationMutationVariables>;

/**
 * __usePurchaseReservationMutation__
 *
 * To run a mutation, you first call `usePurchaseReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseReservationMutation, { data, loading, error }] = usePurchaseReservationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      paymentMethod: // value for 'paymentMethod'
 *      paymentProvider: // value for 'paymentProvider'
 *      extraParams: // value for 'extraParams'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function usePurchaseReservationMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseReservationMutation, PurchaseReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseReservationMutation, PurchaseReservationMutationVariables>(PurchaseReservationDocument, options);
      }
export type PurchaseReservationMutationHookResult = ReturnType<typeof usePurchaseReservationMutation>;
export type PurchaseReservationMutationResult = Apollo.MutationResult<PurchaseReservationMutation>;
export type PurchaseReservationMutationOptions = Apollo.BaseMutationOptions<PurchaseReservationMutation, PurchaseReservationMutationVariables>;
export const ReleaseSlotDocument = gql`
    mutation ReleaseSlot($reservationCode: String!) {
  releaseSlot(reservationCode: $reservationCode) {
    id
  }
}
    `;
export type ReleaseSlotMutationFn = Apollo.MutationFunction<ReleaseSlotMutation, ReleaseSlotMutationVariables>;

/**
 * __useReleaseSlotMutation__
 *
 * To run a mutation, you first call `useReleaseSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseSlotMutation, { data, loading, error }] = useReleaseSlotMutation({
 *   variables: {
 *      reservationCode: // value for 'reservationCode'
 *   },
 * });
 */
export function useReleaseSlotMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseSlotMutation, ReleaseSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseSlotMutation, ReleaseSlotMutationVariables>(ReleaseSlotDocument, options);
      }
export type ReleaseSlotMutationHookResult = ReturnType<typeof useReleaseSlotMutation>;
export type ReleaseSlotMutationResult = Apollo.MutationResult<ReleaseSlotMutation>;
export type ReleaseSlotMutationOptions = Apollo.BaseMutationOptions<ReleaseSlotMutation, ReleaseSlotMutationVariables>;
export const ReservationGuestsDocument = gql`
    query ReservationGuests($code: String, $securityToken: String) {
  reservation(code: $code, securityToken: $securityToken) {
    id
    reservationGuests {
      ...LeanReservationGuest
    }
  }
}
    ${LeanReservationGuestFragmentDoc}`;

/**
 * __useReservationGuestsQuery__
 *
 * To run a query within a React component, call `useReservationGuestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationGuestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationGuestsQuery({
 *   variables: {
 *      code: // value for 'code'
 *      securityToken: // value for 'securityToken'
 *   },
 * });
 */
export function useReservationGuestsQuery(baseOptions?: Apollo.QueryHookOptions<ReservationGuestsQuery, ReservationGuestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationGuestsQuery, ReservationGuestsQueryVariables>(ReservationGuestsDocument, options);
      }
export function useReservationGuestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationGuestsQuery, ReservationGuestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationGuestsQuery, ReservationGuestsQueryVariables>(ReservationGuestsDocument, options);
        }
export type ReservationGuestsQueryHookResult = ReturnType<typeof useReservationGuestsQuery>;
export type ReservationGuestsLazyQueryHookResult = ReturnType<typeof useReservationGuestsLazyQuery>;
export type ReservationGuestsQueryResult = Apollo.QueryResult<ReservationGuestsQuery, ReservationGuestsQueryVariables>;
export const ReservationStatusDocument = gql`
    query ReservationStatus($code: String, $securityToken: String) {
  reservation(code: $code, securityToken: $securityToken) {
    id
    status
  }
}
    `;

/**
 * __useReservationStatusQuery__
 *
 * To run a query within a React component, call `useReservationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationStatusQuery({
 *   variables: {
 *      code: // value for 'code'
 *      securityToken: // value for 'securityToken'
 *   },
 * });
 */
export function useReservationStatusQuery(baseOptions?: Apollo.QueryHookOptions<ReservationStatusQuery, ReservationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationStatusQuery, ReservationStatusQueryVariables>(ReservationStatusDocument, options);
      }
export function useReservationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationStatusQuery, ReservationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationStatusQuery, ReservationStatusQueryVariables>(ReservationStatusDocument, options);
        }
export type ReservationStatusQueryHookResult = ReturnType<typeof useReservationStatusQuery>;
export type ReservationStatusLazyQueryHookResult = ReturnType<typeof useReservationStatusLazyQuery>;
export type ReservationStatusQueryResult = Apollo.QueryResult<ReservationStatusQuery, ReservationStatusQueryVariables>;
export const SuccessPageDocument = gql`
    query SuccessPage($code: String) {
  reservation(code: $code) {
    ...InviteData
    ...SlotDuration
    ...ReservationPrices
    ...SelectedMenus
  }
}
    ${InviteDataFragmentDoc}
${SlotDurationFragmentDoc}
${ReservationPricesFragmentDoc}
${SelectedMenusFragmentDoc}`;

/**
 * __useSuccessPageQuery__
 *
 * To run a query within a React component, call `useSuccessPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuccessPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuccessPageQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSuccessPageQuery(baseOptions?: Apollo.QueryHookOptions<SuccessPageQuery, SuccessPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuccessPageQuery, SuccessPageQueryVariables>(SuccessPageDocument, options);
      }
export function useSuccessPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuccessPageQuery, SuccessPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuccessPageQuery, SuccessPageQueryVariables>(SuccessPageDocument, options);
        }
export type SuccessPageQueryHookResult = ReturnType<typeof useSuccessPageQuery>;
export type SuccessPageLazyQueryHookResult = ReturnType<typeof useSuccessPageLazyQuery>;
export type SuccessPageQueryResult = Apollo.QueryResult<SuccessPageQuery, SuccessPageQueryVariables>;
export const SuccessPageVoucherDocument = gql`
    query SuccessPageVoucher($code: String!) {
  voucher(code: $code) {
    id
    code
    status
    user {
      id
      firstName
      lastName
    }
    peopleCount
    email
    festivalEdition {
      id
      code
      price
      state
      festival {
        id
        code
        name
      }
    }
  }
}
    `;

/**
 * __useSuccessPageVoucherQuery__
 *
 * To run a query within a React component, call `useSuccessPageVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuccessPageVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuccessPageVoucherQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSuccessPageVoucherQuery(baseOptions: Apollo.QueryHookOptions<SuccessPageVoucherQuery, SuccessPageVoucherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuccessPageVoucherQuery, SuccessPageVoucherQueryVariables>(SuccessPageVoucherDocument, options);
      }
export function useSuccessPageVoucherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuccessPageVoucherQuery, SuccessPageVoucherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuccessPageVoucherQuery, SuccessPageVoucherQueryVariables>(SuccessPageVoucherDocument, options);
        }
export type SuccessPageVoucherQueryHookResult = ReturnType<typeof useSuccessPageVoucherQuery>;
export type SuccessPageVoucherLazyQueryHookResult = ReturnType<typeof useSuccessPageVoucherLazyQuery>;
export type SuccessPageVoucherQueryResult = Apollo.QueryResult<SuccessPageVoucherQuery, SuccessPageVoucherQueryVariables>;
export const ReservableExtraSlugDocument = gql`
    query ReservableExtraSlug($id: ID!) {
  reservableExtra(id: $id) {
    slug
  }
}
    `;

/**
 * __useReservableExtraSlugQuery__
 *
 * To run a query within a React component, call `useReservableExtraSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservableExtraSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservableExtraSlugQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReservableExtraSlugQuery(baseOptions: Apollo.QueryHookOptions<ReservableExtraSlugQuery, ReservableExtraSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservableExtraSlugQuery, ReservableExtraSlugQueryVariables>(ReservableExtraSlugDocument, options);
      }
export function useReservableExtraSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservableExtraSlugQuery, ReservableExtraSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservableExtraSlugQuery, ReservableExtraSlugQueryVariables>(ReservableExtraSlugDocument, options);
        }
export type ReservableExtraSlugQueryHookResult = ReturnType<typeof useReservableExtraSlugQuery>;
export type ReservableExtraSlugLazyQueryHookResult = ReturnType<typeof useReservableExtraSlugLazyQuery>;
export type ReservableExtraSlugQueryResult = Apollo.QueryResult<ReservableExtraSlugQuery, ReservableExtraSlugQueryVariables>;
export const SingleReservableExtraDocument = gql`
    query SingleReservableExtra($id: ID!) {
  reservableExtra(id: $id) {
    ...LeanReservableExtra
    restaurant {
      ...RestaurantInReservableExtra
    }
  }
}
    ${LeanReservableExtraFragmentDoc}
${RestaurantInReservableExtraFragmentDoc}`;

/**
 * __useSingleReservableExtraQuery__
 *
 * To run a query within a React component, call `useSingleReservableExtraQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleReservableExtraQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleReservableExtraQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleReservableExtraQuery(baseOptions: Apollo.QueryHookOptions<SingleReservableExtraQuery, SingleReservableExtraQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleReservableExtraQuery, SingleReservableExtraQueryVariables>(SingleReservableExtraDocument, options);
      }
export function useSingleReservableExtraLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleReservableExtraQuery, SingleReservableExtraQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleReservableExtraQuery, SingleReservableExtraQueryVariables>(SingleReservableExtraDocument, options);
        }
export type SingleReservableExtraQueryHookResult = ReturnType<typeof useSingleReservableExtraQuery>;
export type SingleReservableExtraLazyQueryHookResult = ReturnType<typeof useSingleReservableExtraLazyQuery>;
export type SingleReservableExtraQueryResult = Apollo.QueryResult<SingleReservableExtraQuery, SingleReservableExtraQueryVariables>;
export const CollectionDocument = gql`
    query Collection($id: ID!) {
  collection(id: $id) {
    ...LeanCollection
  }
}
    ${LeanCollectionFragmentDoc}`;

/**
 * __useCollectionQuery__
 *
 * To run a query within a React component, call `useCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCollectionQuery(baseOptions: Apollo.QueryHookOptions<CollectionQuery, CollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionQuery, CollectionQueryVariables>(CollectionDocument, options);
      }
export function useCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionQuery, CollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionQuery, CollectionQueryVariables>(CollectionDocument, options);
        }
export type CollectionQueryHookResult = ReturnType<typeof useCollectionQuery>;
export type CollectionLazyQueryHookResult = ReturnType<typeof useCollectionLazyQuery>;
export type CollectionQueryResult = Apollo.QueryResult<CollectionQuery, CollectionQueryVariables>;
export const MenuPositionsDocument = gql`
    query menuPositions($festivalEditionId: ID!, $after: String, $regionId: ID!, $search: String, $index: Int) {
  menuPositions(
    first: 10
    after: $after
    festivalEditionId: $festivalEditionId
    regionId: $regionId
    search: $search
    index: $index
  ) {
    nodes {
      ... on MenuPosition {
        content
        index
        name
        title
        menu {
          id
          label
        }
        restaurant {
          name
          slug
          id
          festivalEditionRestaurants {
            id
            festivalEdition {
              id
            }
          }
        }
      }
    }
    totalCount
    pageInfo {
      endCursor
    }
  }
}
    `;

/**
 * __useMenuPositionsQuery__
 *
 * To run a query within a React component, call `useMenuPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuPositionsQuery({
 *   variables: {
 *      festivalEditionId: // value for 'festivalEditionId'
 *      after: // value for 'after'
 *      regionId: // value for 'regionId'
 *      search: // value for 'search'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useMenuPositionsQuery(baseOptions: Apollo.QueryHookOptions<MenuPositionsQuery, MenuPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuPositionsQuery, MenuPositionsQueryVariables>(MenuPositionsDocument, options);
      }
export function useMenuPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuPositionsQuery, MenuPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuPositionsQuery, MenuPositionsQueryVariables>(MenuPositionsDocument, options);
        }
export type MenuPositionsQueryHookResult = ReturnType<typeof useMenuPositionsQuery>;
export type MenuPositionsLazyQueryHookResult = ReturnType<typeof useMenuPositionsLazyQuery>;
export type MenuPositionsQueryResult = Apollo.QueryResult<MenuPositionsQuery, MenuPositionsQueryVariables>;
export const ClosestFestivalEditionRestaurantDocument = gql`
    query ClosestFestivalEditionRestaurant($festivalEditionIds: [ID!]) {
  restaurants(first: 1, festival_edition_ids: $festivalEditionIds, sort: DISTANCE) {
    nodes {
      id
      name
      slug
      distance
      region {
        id
      }
    }
  }
}
    `;

/**
 * __useClosestFestivalEditionRestaurantQuery__
 *
 * To run a query within a React component, call `useClosestFestivalEditionRestaurantQuery` and pass it any options that fit your needs.
 * When your component renders, `useClosestFestivalEditionRestaurantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClosestFestivalEditionRestaurantQuery({
 *   variables: {
 *      festivalEditionIds: // value for 'festivalEditionIds'
 *   },
 * });
 */
export function useClosestFestivalEditionRestaurantQuery(baseOptions?: Apollo.QueryHookOptions<ClosestFestivalEditionRestaurantQuery, ClosestFestivalEditionRestaurantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClosestFestivalEditionRestaurantQuery, ClosestFestivalEditionRestaurantQueryVariables>(ClosestFestivalEditionRestaurantDocument, options);
      }
export function useClosestFestivalEditionRestaurantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClosestFestivalEditionRestaurantQuery, ClosestFestivalEditionRestaurantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClosestFestivalEditionRestaurantQuery, ClosestFestivalEditionRestaurantQueryVariables>(ClosestFestivalEditionRestaurantDocument, options);
        }
export type ClosestFestivalEditionRestaurantQueryHookResult = ReturnType<typeof useClosestFestivalEditionRestaurantQuery>;
export type ClosestFestivalEditionRestaurantLazyQueryHookResult = ReturnType<typeof useClosestFestivalEditionRestaurantLazyQuery>;
export type ClosestFestivalEditionRestaurantQueryResult = Apollo.QueryResult<ClosestFestivalEditionRestaurantQuery, ClosestFestivalEditionRestaurantQueryVariables>;
export const CurrentFestivalEditionDocument = gql`
    query CurrentFestivalEdition($code: FestivalCodesEnum, $slug: String) {
  currentFestivalEdition(code: $code, slug: $slug) {
    id
    state
    voucher
    startsAt
    endsAt
    price
    externalSale
    minPeopleCount
    maxPeopleCount
    reservableFrom
    code
    defaultReservableFrom
    festival {
      code
      slug
    }
    slots {
      duration
      interval
      possibleSlots
      slotStart
    }
  }
}
    `;

/**
 * __useCurrentFestivalEditionQuery__
 *
 * To run a query within a React component, call `useCurrentFestivalEditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentFestivalEditionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentFestivalEditionQuery({
 *   variables: {
 *      code: // value for 'code'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCurrentFestivalEditionQuery(baseOptions?: Apollo.QueryHookOptions<CurrentFestivalEditionQuery, CurrentFestivalEditionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentFestivalEditionQuery, CurrentFestivalEditionQueryVariables>(CurrentFestivalEditionDocument, options);
      }
export function useCurrentFestivalEditionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentFestivalEditionQuery, CurrentFestivalEditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentFestivalEditionQuery, CurrentFestivalEditionQueryVariables>(CurrentFestivalEditionDocument, options);
        }
export type CurrentFestivalEditionQueryHookResult = ReturnType<typeof useCurrentFestivalEditionQuery>;
export type CurrentFestivalEditionLazyQueryHookResult = ReturnType<typeof useCurrentFestivalEditionLazyQuery>;
export type CurrentFestivalEditionQueryResult = Apollo.QueryResult<CurrentFestivalEditionQuery, CurrentFestivalEditionQueryVariables>;
export const EventsRegionsListDocument = gql`
    query EventsRegionsList($slotless: Boolean) {
  incomingEventsRegions(slotless: $slotless) {
    id
  }
}
    `;

/**
 * __useEventsRegionsListQuery__
 *
 * To run a query within a React component, call `useEventsRegionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsRegionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsRegionsListQuery({
 *   variables: {
 *      slotless: // value for 'slotless'
 *   },
 * });
 */
export function useEventsRegionsListQuery(baseOptions?: Apollo.QueryHookOptions<EventsRegionsListQuery, EventsRegionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsRegionsListQuery, EventsRegionsListQueryVariables>(EventsRegionsListDocument, options);
      }
export function useEventsRegionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsRegionsListQuery, EventsRegionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsRegionsListQuery, EventsRegionsListQueryVariables>(EventsRegionsListDocument, options);
        }
export type EventsRegionsListQueryHookResult = ReturnType<typeof useEventsRegionsListQuery>;
export type EventsRegionsListLazyQueryHookResult = ReturnType<typeof useEventsRegionsListLazyQuery>;
export type EventsRegionsListQueryResult = Apollo.QueryResult<EventsRegionsListQuery, EventsRegionsListQueryVariables>;
export const FerModalDocument = gql`
    query FERModal($ferId: ID!) {
  festivalEditionRestaurant(id: $ferId) {
    id
    price
    allDaySlots
    externalSaleUrl
    imageFiles(scope: WITH_RESTAURANT) {
      id
      preview
      original
    }
    restaurant {
      id
      name
      favorited
      description
      slug
      latitude
      longitude
      address
      phoneNumber
      urls {
        url
        urlType
      }
      tags {
        id
        name
        type
        position
      }
    }
    menus {
      ...LeanMenu
    }
    festivalEdition {
      id
      price
      startsAt
      endsAt
      reservableFrom
      forceLabels
      reservationFeeUnitPrice
      state
      code
      maxPeopleCount
      minPeopleCount
      slots {
        slotStart
      }
      festival {
        id
        code
        name
        slogan
        image {
          id
          preview
        }
      }
    }
  }
}
    ${LeanMenuFragmentDoc}`;

/**
 * __useFerModalQuery__
 *
 * To run a query within a React component, call `useFerModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFerModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFerModalQuery({
 *   variables: {
 *      ferId: // value for 'ferId'
 *   },
 * });
 */
export function useFerModalQuery(baseOptions: Apollo.QueryHookOptions<FerModalQuery, FerModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FerModalQuery, FerModalQueryVariables>(FerModalDocument, options);
      }
export function useFerModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FerModalQuery, FerModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FerModalQuery, FerModalQueryVariables>(FerModalDocument, options);
        }
export type FerModalQueryHookResult = ReturnType<typeof useFerModalQuery>;
export type FerModalLazyQueryHookResult = ReturnType<typeof useFerModalLazyQuery>;
export type FerModalQueryResult = Apollo.QueryResult<FerModalQuery, FerModalQueryVariables>;
export const FestivalMenuRegionRestaurantsDocument = gql`
    query FestivalMenuRegionRestaurants($name: String, $regionId: ID!, $festivalEditionIds: [ID!]) {
  restaurants(
    name: $name
    region_id: $regionId
    sort: DISTANCE
    festival_edition_ids: $festivalEditionIds
  ) {
    nodes {
      id
      name
      slug
      distance
    }
  }
}
    `;

/**
 * __useFestivalMenuRegionRestaurantsQuery__
 *
 * To run a query within a React component, call `useFestivalMenuRegionRestaurantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFestivalMenuRegionRestaurantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFestivalMenuRegionRestaurantsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      regionId: // value for 'regionId'
 *      festivalEditionIds: // value for 'festivalEditionIds'
 *   },
 * });
 */
export function useFestivalMenuRegionRestaurantsQuery(baseOptions: Apollo.QueryHookOptions<FestivalMenuRegionRestaurantsQuery, FestivalMenuRegionRestaurantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FestivalMenuRegionRestaurantsQuery, FestivalMenuRegionRestaurantsQueryVariables>(FestivalMenuRegionRestaurantsDocument, options);
      }
export function useFestivalMenuRegionRestaurantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FestivalMenuRegionRestaurantsQuery, FestivalMenuRegionRestaurantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FestivalMenuRegionRestaurantsQuery, FestivalMenuRegionRestaurantsQueryVariables>(FestivalMenuRegionRestaurantsDocument, options);
        }
export type FestivalMenuRegionRestaurantsQueryHookResult = ReturnType<typeof useFestivalMenuRegionRestaurantsQuery>;
export type FestivalMenuRegionRestaurantsLazyQueryHookResult = ReturnType<typeof useFestivalMenuRegionRestaurantsLazyQuery>;
export type FestivalMenuRegionRestaurantsQueryResult = Apollo.QueryResult<FestivalMenuRegionRestaurantsQuery, FestivalMenuRegionRestaurantsQueryVariables>;
export const FestivalRegionsListDocument = gql`
    query FestivalRegionsList($festivalEditionId: ID!) {
  festivalRegions(festivalEditionId: $festivalEditionId) {
    id
    name
  }
}
    `;

/**
 * __useFestivalRegionsListQuery__
 *
 * To run a query within a React component, call `useFestivalRegionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFestivalRegionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFestivalRegionsListQuery({
 *   variables: {
 *      festivalEditionId: // value for 'festivalEditionId'
 *   },
 * });
 */
export function useFestivalRegionsListQuery(baseOptions: Apollo.QueryHookOptions<FestivalRegionsListQuery, FestivalRegionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FestivalRegionsListQuery, FestivalRegionsListQueryVariables>(FestivalRegionsListDocument, options);
      }
export function useFestivalRegionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FestivalRegionsListQuery, FestivalRegionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FestivalRegionsListQuery, FestivalRegionsListQueryVariables>(FestivalRegionsListDocument, options);
        }
export type FestivalRegionsListQueryHookResult = ReturnType<typeof useFestivalRegionsListQuery>;
export type FestivalRegionsListLazyQueryHookResult = ReturnType<typeof useFestivalRegionsListLazyQuery>;
export type FestivalRegionsListQueryResult = Apollo.QueryResult<FestivalRegionsListQuery, FestivalRegionsListQueryVariables>;
export const FestivalSponsorsListDocument = gql`
    query FestivalSponsorsList($festivalEditionId: ID, $regionId: ID, $clubSponsors: Boolean) {
  sponsors(
    festivalEditionId: $festivalEditionId
    regionId: $regionId
    clubSponsors: $clubSponsors
  ) {
    nodes {
      id
      label
      kind
      subkind
      image {
        id
        preview
      }
      url
    }
  }
}
    `;

/**
 * __useFestivalSponsorsListQuery__
 *
 * To run a query within a React component, call `useFestivalSponsorsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFestivalSponsorsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFestivalSponsorsListQuery({
 *   variables: {
 *      festivalEditionId: // value for 'festivalEditionId'
 *      regionId: // value for 'regionId'
 *      clubSponsors: // value for 'clubSponsors'
 *   },
 * });
 */
export function useFestivalSponsorsListQuery(baseOptions?: Apollo.QueryHookOptions<FestivalSponsorsListQuery, FestivalSponsorsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FestivalSponsorsListQuery, FestivalSponsorsListQueryVariables>(FestivalSponsorsListDocument, options);
      }
export function useFestivalSponsorsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FestivalSponsorsListQuery, FestivalSponsorsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FestivalSponsorsListQuery, FestivalSponsorsListQueryVariables>(FestivalSponsorsListDocument, options);
        }
export type FestivalSponsorsListQueryHookResult = ReturnType<typeof useFestivalSponsorsListQuery>;
export type FestivalSponsorsListLazyQueryHookResult = ReturnType<typeof useFestivalSponsorsListLazyQuery>;
export type FestivalSponsorsListQueryResult = Apollo.QueryResult<FestivalSponsorsListQuery, FestivalSponsorsListQueryVariables>;
export const OngoingFestivalsListDocument = gql`
    query OngoingFestivalsList {
  ongoingFestivalEditions {
    id
    code
    price
    startsAt
    endsAt
    state
    minPeopleCount
    maxPeopleCount
    menuPositions {
      label
    }
    metadatas {
      id
      key
      value
    }
    festival {
      id
      code
      url
      name
      slogan
      about
      shortDescription
      slug
      image {
        preview
      }
    }
    slots {
      id
      possibleSlots
    }
  }
}
    `;

/**
 * __useOngoingFestivalsListQuery__
 *
 * To run a query within a React component, call `useOngoingFestivalsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOngoingFestivalsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOngoingFestivalsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useOngoingFestivalsListQuery(baseOptions?: Apollo.QueryHookOptions<OngoingFestivalsListQuery, OngoingFestivalsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OngoingFestivalsListQuery, OngoingFestivalsListQueryVariables>(OngoingFestivalsListDocument, options);
      }
export function useOngoingFestivalsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OngoingFestivalsListQuery, OngoingFestivalsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OngoingFestivalsListQuery, OngoingFestivalsListQueryVariables>(OngoingFestivalsListDocument, options);
        }
export type OngoingFestivalsListQueryHookResult = ReturnType<typeof useOngoingFestivalsListQuery>;
export type OngoingFestivalsListLazyQueryHookResult = ReturnType<typeof useOngoingFestivalsListLazyQuery>;
export type OngoingFestivalsListQueryResult = Apollo.QueryResult<OngoingFestivalsListQuery, OngoingFestivalsListQueryVariables>;
export const ReservationConnectDataDocument = gql`
    query ReservationConnectData($code: String!) {
  reservation(code: $code) {
    id
    code
    user {
      id
    }
  }
}
    `;

/**
 * __useReservationConnectDataQuery__
 *
 * To run a query within a React component, call `useReservationConnectDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationConnectDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationConnectDataQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useReservationConnectDataQuery(baseOptions: Apollo.QueryHookOptions<ReservationConnectDataQuery, ReservationConnectDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationConnectDataQuery, ReservationConnectDataQueryVariables>(ReservationConnectDataDocument, options);
      }
export function useReservationConnectDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationConnectDataQuery, ReservationConnectDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationConnectDataQuery, ReservationConnectDataQueryVariables>(ReservationConnectDataDocument, options);
        }
export type ReservationConnectDataQueryHookResult = ReturnType<typeof useReservationConnectDataQuery>;
export type ReservationConnectDataLazyQueryHookResult = ReturnType<typeof useReservationConnectDataLazyQuery>;
export type ReservationConnectDataQueryResult = Apollo.QueryResult<ReservationConnectDataQuery, ReservationConnectDataQueryVariables>;
export const RestaurantFestivalMenuDocument = gql`
    query RestaurantFestivalMenu($id: ID!) {
  restaurant(id: $id) {
    id
    name
    reservables {
      ... on FestivalEditionRestaurant {
        id
        festivalEdition {
          id
          state
          festival {
            id
            code
          }
        }
        menus {
          id
          label
          position
          positions {
            name
            title
            content
            index
          }
        }
        ferInventoryItems {
          price
          inventoryItem {
            id
            name
            image {
              preview
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRestaurantFestivalMenuQuery__
 *
 * To run a query within a React component, call `useRestaurantFestivalMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantFestivalMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantFestivalMenuQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestaurantFestivalMenuQuery(baseOptions: Apollo.QueryHookOptions<RestaurantFestivalMenuQuery, RestaurantFestivalMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RestaurantFestivalMenuQuery, RestaurantFestivalMenuQueryVariables>(RestaurantFestivalMenuDocument, options);
      }
export function useRestaurantFestivalMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RestaurantFestivalMenuQuery, RestaurantFestivalMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RestaurantFestivalMenuQuery, RestaurantFestivalMenuQueryVariables>(RestaurantFestivalMenuDocument, options);
        }
export type RestaurantFestivalMenuQueryHookResult = ReturnType<typeof useRestaurantFestivalMenuQuery>;
export type RestaurantFestivalMenuLazyQueryHookResult = ReturnType<typeof useRestaurantFestivalMenuLazyQuery>;
export type RestaurantFestivalMenuQueryResult = Apollo.QueryResult<RestaurantFestivalMenuQuery, RestaurantFestivalMenuQueryVariables>;
export const SingleFestivalEditionDocument = gql`
    query SingleFestivalEdition($id: ID!) {
  festivalEdition(id: $id) {
    id
    code
    state
    voucher
    startsAt
    endsAt
    price
    minPeopleCount
    maxPeopleCount
    festival {
      id
      slug
      code
      name
    }
  }
}
    `;

/**
 * __useSingleFestivalEditionQuery__
 *
 * To run a query within a React component, call `useSingleFestivalEditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleFestivalEditionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleFestivalEditionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleFestivalEditionQuery(baseOptions: Apollo.QueryHookOptions<SingleFestivalEditionQuery, SingleFestivalEditionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleFestivalEditionQuery, SingleFestivalEditionQueryVariables>(SingleFestivalEditionDocument, options);
      }
export function useSingleFestivalEditionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleFestivalEditionQuery, SingleFestivalEditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleFestivalEditionQuery, SingleFestivalEditionQueryVariables>(SingleFestivalEditionDocument, options);
        }
export type SingleFestivalEditionQueryHookResult = ReturnType<typeof useSingleFestivalEditionQuery>;
export type SingleFestivalEditionLazyQueryHookResult = ReturnType<typeof useSingleFestivalEditionLazyQuery>;
export type SingleFestivalEditionQueryResult = Apollo.QueryResult<SingleFestivalEditionQuery, SingleFestivalEditionQueryVariables>;
export const EventBasicDataDocument = gql`
    query eventBasicData($id: ID) {
  event(id: $id) {
    id
  }
}
    `;

/**
 * __useEventBasicDataQuery__
 *
 * To run a query within a React component, call `useEventBasicDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventBasicDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventBasicDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventBasicDataQuery(baseOptions?: Apollo.QueryHookOptions<EventBasicDataQuery, EventBasicDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventBasicDataQuery, EventBasicDataQueryVariables>(EventBasicDataDocument, options);
      }
export function useEventBasicDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventBasicDataQuery, EventBasicDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventBasicDataQuery, EventBasicDataQueryVariables>(EventBasicDataDocument, options);
        }
export type EventBasicDataQueryHookResult = ReturnType<typeof useEventBasicDataQuery>;
export type EventBasicDataLazyQueryHookResult = ReturnType<typeof useEventBasicDataLazyQuery>;
export type EventBasicDataQueryResult = Apollo.QueryResult<EventBasicDataQuery, EventBasicDataQueryVariables>;
export const CreateVoucherDocument = gql`
    mutation createVoucher($peopleCount: Int!, $festivalEditionId: ID!, $userId: ID) {
  createVoucher(
    peopleCount: $peopleCount
    festivalEditionId: $festivalEditionId
    userId: $userId
  ) {
    id
    code
    peopleCount
    permittedPaymentMethods
  }
}
    `;
export type CreateVoucherMutationFn = Apollo.MutationFunction<CreateVoucherMutation, CreateVoucherMutationVariables>;

/**
 * __useCreateVoucherMutation__
 *
 * To run a mutation, you first call `useCreateVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVoucherMutation, { data, loading, error }] = useCreateVoucherMutation({
 *   variables: {
 *      peopleCount: // value for 'peopleCount'
 *      festivalEditionId: // value for 'festivalEditionId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateVoucherMutation(baseOptions?: Apollo.MutationHookOptions<CreateVoucherMutation, CreateVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVoucherMutation, CreateVoucherMutationVariables>(CreateVoucherDocument, options);
      }
export type CreateVoucherMutationHookResult = ReturnType<typeof useCreateVoucherMutation>;
export type CreateVoucherMutationResult = Apollo.MutationResult<CreateVoucherMutation>;
export type CreateVoucherMutationOptions = Apollo.BaseMutationOptions<CreateVoucherMutation, CreateVoucherMutationVariables>;
export const OngoingFestivalsWithMetadatasDocument = gql`
    query ongoingFestivalsWithMetadatas($withVoucher: Boolean) {
  ongoingFestivalEditions(withVoucher: $withVoucher) {
    id
    code
    price
    startsAt
    endsAt
    minPeopleCount
    festival {
      id
      code
      url
      name
      image {
        original
        preview
      }
      logo {
        original
        preview
      }
    }
    metadatas {
      id
      key
      value
    }
    state
  }
}
    `;

/**
 * __useOngoingFestivalsWithMetadatasQuery__
 *
 * To run a query within a React component, call `useOngoingFestivalsWithMetadatasQuery` and pass it any options that fit your needs.
 * When your component renders, `useOngoingFestivalsWithMetadatasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOngoingFestivalsWithMetadatasQuery({
 *   variables: {
 *      withVoucher: // value for 'withVoucher'
 *   },
 * });
 */
export function useOngoingFestivalsWithMetadatasQuery(baseOptions?: Apollo.QueryHookOptions<OngoingFestivalsWithMetadatasQuery, OngoingFestivalsWithMetadatasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OngoingFestivalsWithMetadatasQuery, OngoingFestivalsWithMetadatasQueryVariables>(OngoingFestivalsWithMetadatasDocument, options);
      }
export function useOngoingFestivalsWithMetadatasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OngoingFestivalsWithMetadatasQuery, OngoingFestivalsWithMetadatasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OngoingFestivalsWithMetadatasQuery, OngoingFestivalsWithMetadatasQueryVariables>(OngoingFestivalsWithMetadatasDocument, options);
        }
export type OngoingFestivalsWithMetadatasQueryHookResult = ReturnType<typeof useOngoingFestivalsWithMetadatasQuery>;
export type OngoingFestivalsWithMetadatasLazyQueryHookResult = ReturnType<typeof useOngoingFestivalsWithMetadatasLazyQuery>;
export type OngoingFestivalsWithMetadatasQueryResult = Apollo.QueryResult<OngoingFestivalsWithMetadatasQuery, OngoingFestivalsWithMetadatasQueryVariables>;
export const PurchaseVoucherDocument = gql`
    mutation purchaseVoucher($code: String!, $paymentProvider: PaymentProviderEnum, $paymentMethod: PaymentMethodEnum, $extraParams: PaymentExtraParamsInput, $cardId: ID) {
  purchaseVoucher(
    code: $code
    paymentProvider: $paymentProvider
    paymentMethod: $paymentMethod
    extraParams: $extraParams
    cardId: $cardId
  ) {
    checkoutPageUrl
    cryptKey
    voucher {
      id
      code
      status
    }
  }
}
    `;
export type PurchaseVoucherMutationFn = Apollo.MutationFunction<PurchaseVoucherMutation, PurchaseVoucherMutationVariables>;

/**
 * __usePurchaseVoucherMutation__
 *
 * To run a mutation, you first call `usePurchaseVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseVoucherMutation, { data, loading, error }] = usePurchaseVoucherMutation({
 *   variables: {
 *      code: // value for 'code'
 *      paymentProvider: // value for 'paymentProvider'
 *      paymentMethod: // value for 'paymentMethod'
 *      extraParams: // value for 'extraParams'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function usePurchaseVoucherMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseVoucherMutation, PurchaseVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseVoucherMutation, PurchaseVoucherMutationVariables>(PurchaseVoucherDocument, options);
      }
export type PurchaseVoucherMutationHookResult = ReturnType<typeof usePurchaseVoucherMutation>;
export type PurchaseVoucherMutationResult = Apollo.MutationResult<PurchaseVoucherMutation>;
export type PurchaseVoucherMutationOptions = Apollo.BaseMutationOptions<PurchaseVoucherMutation, PurchaseVoucherMutationVariables>;
export const ReservableDocument = gql`
    query reservable($id: ID!, $type: ReservableEnum!) {
  reservable(id: $id, type: $type) {
    ... on Event {
      id
      code
      title
      price
      startsAt
      endsAt
      minMenusAmount
      minPeopleCount
      reservableFrom
      metadatas {
        id
        key
        value
      }
      slotless
      slots {
        id
        duration
        possibleSlots
        slotStart
      }
      menus {
        label
        position
        imageFile {
          id
          preview
        }
        positions {
          name
          title
          content
        }
      }
    }
  }
}
    `;

/**
 * __useReservableQuery__
 *
 * To run a query within a React component, call `useReservableQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservableQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useReservableQuery(baseOptions: Apollo.QueryHookOptions<ReservableQuery, ReservableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservableQuery, ReservableQueryVariables>(ReservableDocument, options);
      }
export function useReservableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservableQuery, ReservableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservableQuery, ReservableQueryVariables>(ReservableDocument, options);
        }
export type ReservableQueryHookResult = ReturnType<typeof useReservableQuery>;
export type ReservableLazyQueryHookResult = ReturnType<typeof useReservableLazyQuery>;
export type ReservableQueryResult = Apollo.QueryResult<ReservableQuery, ReservableQueryVariables>;
export const EventDataDocument = gql`
    query eventData($id: ID) {
  event(id: $id) {
    id
    title
    description
    startsAt
    endsAt
    minPeopleCount
    maxPeopleCount
    price
    external
    externalUrl
    slotless
    imageFiles {
      id
      preview
    }
    menus {
      id
    }
    metadatas {
      id
      key
      value
    }
  }
}
    `;

/**
 * __useEventDataQuery__
 *
 * To run a query within a React component, call `useEventDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventDataQuery(baseOptions?: Apollo.QueryHookOptions<EventDataQuery, EventDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventDataQuery, EventDataQueryVariables>(EventDataDocument, options);
      }
export function useEventDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventDataQuery, EventDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventDataQuery, EventDataQueryVariables>(EventDataDocument, options);
        }
export type EventDataQueryHookResult = ReturnType<typeof useEventDataQuery>;
export type EventDataLazyQueryHookResult = ReturnType<typeof useEventDataLazyQuery>;
export type EventDataQueryResult = Apollo.QueryResult<EventDataQuery, EventDataQueryVariables>;
export const SideEventsListWithMetadatasDocument = gql`
    query sideEventsListWithMetadatas($slotless: Boolean, $regionId: ID) {
  incomingEvents(slotless: $slotless, region_id: $regionId) {
    edges {
      node {
        id
        title
        price
        startsAt
        endsAt
        slotless
        minPeopleCount
        imageFiles {
          id
          preview
        }
        metadatas {
          id
          key
          value
        }
      }
    }
  }
}
    `;

/**
 * __useSideEventsListWithMetadatasQuery__
 *
 * To run a query within a React component, call `useSideEventsListWithMetadatasQuery` and pass it any options that fit your needs.
 * When your component renders, `useSideEventsListWithMetadatasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSideEventsListWithMetadatasQuery({
 *   variables: {
 *      slotless: // value for 'slotless'
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useSideEventsListWithMetadatasQuery(baseOptions?: Apollo.QueryHookOptions<SideEventsListWithMetadatasQuery, SideEventsListWithMetadatasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SideEventsListWithMetadatasQuery, SideEventsListWithMetadatasQueryVariables>(SideEventsListWithMetadatasDocument, options);
      }
export function useSideEventsListWithMetadatasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SideEventsListWithMetadatasQuery, SideEventsListWithMetadatasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SideEventsListWithMetadatasQuery, SideEventsListWithMetadatasQueryVariables>(SideEventsListWithMetadatasDocument, options);
        }
export type SideEventsListWithMetadatasQueryHookResult = ReturnType<typeof useSideEventsListWithMetadatasQuery>;
export type SideEventsListWithMetadatasLazyQueryHookResult = ReturnType<typeof useSideEventsListWithMetadatasLazyQuery>;
export type SideEventsListWithMetadatasQueryResult = Apollo.QueryResult<SideEventsListWithMetadatasQuery, SideEventsListWithMetadatasQueryVariables>;
export const VoucherDataDocument = gql`
    query voucherData($code: String!) {
  voucher(code: $code) {
    id
    code
    peopleCount
    status
    permittedPaymentMethods
    festivalEditions {
      id
      code
      state
      voucher
      startsAt
      endsAt
      price
      minPeopleCount
      maxPeopleCount
      reservationFeeUnitPrice
      festival {
        id
        code
        name
        metadatas {
          id
          key
          value
        }
      }
    }
  }
}
    `;

/**
 * __useVoucherDataQuery__
 *
 * To run a query within a React component, call `useVoucherDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoucherDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoucherDataQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVoucherDataQuery(baseOptions: Apollo.QueryHookOptions<VoucherDataQuery, VoucherDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VoucherDataQuery, VoucherDataQueryVariables>(VoucherDataDocument, options);
      }
export function useVoucherDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VoucherDataQuery, VoucherDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VoucherDataQuery, VoucherDataQueryVariables>(VoucherDataDocument, options);
        }
export type VoucherDataQueryHookResult = ReturnType<typeof useVoucherDataQuery>;
export type VoucherDataLazyQueryHookResult = ReturnType<typeof useVoucherDataLazyQuery>;
export type VoucherDataQueryResult = Apollo.QueryResult<VoucherDataQuery, VoucherDataQueryVariables>;
export const VoucherStatusDocument = gql`
    query VoucherStatus($code: String!) {
  voucher(code: $code) {
    status
  }
}
    `;

/**
 * __useVoucherStatusQuery__
 *
 * To run a query within a React component, call `useVoucherStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoucherStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoucherStatusQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVoucherStatusQuery(baseOptions: Apollo.QueryHookOptions<VoucherStatusQuery, VoucherStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VoucherStatusQuery, VoucherStatusQueryVariables>(VoucherStatusDocument, options);
      }
export function useVoucherStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VoucherStatusQuery, VoucherStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VoucherStatusQuery, VoucherStatusQueryVariables>(VoucherStatusDocument, options);
        }
export type VoucherStatusQueryHookResult = ReturnType<typeof useVoucherStatusQuery>;
export type VoucherStatusLazyQueryHookResult = ReturnType<typeof useVoucherStatusLazyQuery>;
export type VoucherStatusQueryResult = Apollo.QueryResult<VoucherStatusQuery, VoucherStatusQueryVariables>;
export const BannersDocument = gql`
    query Banners($section_slug: String) {
  banners(section_slug: $section_slug) {
    nodes {
      ...MainPageBanner
    }
  }
}
    ${MainPageBannerFragmentDoc}`;

/**
 * __useBannersQuery__
 *
 * To run a query within a React component, call `useBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannersQuery({
 *   variables: {
 *      section_slug: // value for 'section_slug'
 *   },
 * });
 */
export function useBannersQuery(baseOptions?: Apollo.QueryHookOptions<BannersQuery, BannersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BannersQuery, BannersQueryVariables>(BannersDocument, options);
      }
export function useBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BannersQuery, BannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BannersQuery, BannersQueryVariables>(BannersDocument, options);
        }
export type BannersQueryHookResult = ReturnType<typeof useBannersQuery>;
export type BannersLazyQueryHookResult = ReturnType<typeof useBannersLazyQuery>;
export type BannersQueryResult = Apollo.QueryResult<BannersQuery, BannersQueryVariables>;
export const HomepageQueryDocument = gql`
    query HomepageQuery($region_id: ID!, $section_slug: String!) {
  collections(region_id: $region_id, section_slug: $section_slug) {
    edges {
      node {
        id
        category
        position
        title
        festivalEdition {
          festival {
            code
            slug
          }
        }
        restaurants {
          id
          name
          description
          slug
          favorited
          imageFiles {
            id
            preview
          }
          position
          tags {
            id
            name
            position
            type
          }
          reservables {
            ... on Daily {
              id
            }
            ... on Event {
              id
            }
            ... on FestivalEditionRestaurant {
              id
            }
          }
        }
        reservableExtras {
          ...ReservationOffer
        }
        elements {
          elementId
          elementType
        }
        section {
          slug
        }
      }
    }
  }
}
    ${ReservationOfferFragmentDoc}`;

/**
 * __useHomepageQueryQuery__
 *
 * To run a query within a React component, call `useHomepageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomepageQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomepageQueryQuery({
 *   variables: {
 *      region_id: // value for 'region_id'
 *      section_slug: // value for 'section_slug'
 *   },
 * });
 */
export function useHomepageQueryQuery(baseOptions: Apollo.QueryHookOptions<HomepageQueryQuery, HomepageQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomepageQueryQuery, HomepageQueryQueryVariables>(HomepageQueryDocument, options);
      }
export function useHomepageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomepageQueryQuery, HomepageQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomepageQueryQuery, HomepageQueryQueryVariables>(HomepageQueryDocument, options);
        }
export type HomepageQueryQueryHookResult = ReturnType<typeof useHomepageQueryQuery>;
export type HomepageQueryLazyQueryHookResult = ReturnType<typeof useHomepageQueryLazyQuery>;
export type HomepageQueryQueryResult = Apollo.QueryResult<HomepageQueryQuery, HomepageQueryQueryVariables>;
export const PopularRestaurantsDocument = gql`
    query PopularRestaurants($region_id: ID!) {
  popularRestaurants(region_id: $region_id) {
    id
    name
    imageFiles {
      id
      preview
    }
  }
}
    `;

/**
 * __usePopularRestaurantsQuery__
 *
 * To run a query within a React component, call `usePopularRestaurantsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularRestaurantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularRestaurantsQuery({
 *   variables: {
 *      region_id: // value for 'region_id'
 *   },
 * });
 */
export function usePopularRestaurantsQuery(baseOptions: Apollo.QueryHookOptions<PopularRestaurantsQuery, PopularRestaurantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopularRestaurantsQuery, PopularRestaurantsQueryVariables>(PopularRestaurantsDocument, options);
      }
export function usePopularRestaurantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopularRestaurantsQuery, PopularRestaurantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopularRestaurantsQuery, PopularRestaurantsQueryVariables>(PopularRestaurantsDocument, options);
        }
export type PopularRestaurantsQueryHookResult = ReturnType<typeof usePopularRestaurantsQuery>;
export type PopularRestaurantsLazyQueryHookResult = ReturnType<typeof usePopularRestaurantsLazyQuery>;
export type PopularRestaurantsQueryResult = Apollo.QueryResult<PopularRestaurantsQuery, PopularRestaurantsQueryVariables>;
export const FerListDocument = gql`
    query FERList($festival_edition_id: ID!, $region_id: ID!, $first: Int!, $after: String, $reservation_filters: ReservationFilter, $tag_ids: [ID], $restaurant_ids: [ID]) {
  festivalEditionRestaurants(
    festival_edition_id: $festival_edition_id
    region_id: $region_id
    first: $first
    after: $after
    reservation_filters: $reservation_filters
    tag_ids: $tag_ids
    restaurant_ids: $restaurant_ids
  ) {
    totalCount
    nodes {
      ...FERNode
    }
  }
}
    ${FerNodeFragmentDoc}`;

/**
 * __useFerListQuery__
 *
 * To run a query within a React component, call `useFerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFerListQuery({
 *   variables: {
 *      festival_edition_id: // value for 'festival_edition_id'
 *      region_id: // value for 'region_id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      reservation_filters: // value for 'reservation_filters'
 *      tag_ids: // value for 'tag_ids'
 *      restaurant_ids: // value for 'restaurant_ids'
 *   },
 * });
 */
export function useFerListQuery(baseOptions: Apollo.QueryHookOptions<FerListQuery, FerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FerListQuery, FerListQueryVariables>(FerListDocument, options);
      }
export function useFerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FerListQuery, FerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FerListQuery, FerListQueryVariables>(FerListDocument, options);
        }
export type FerListQueryHookResult = ReturnType<typeof useFerListQuery>;
export type FerListLazyQueryHookResult = ReturnType<typeof useFerListLazyQuery>;
export type FerListQueryResult = Apollo.QueryResult<FerListQuery, FerListQueryVariables>;
export const ListingSearchDocument = gql`
    query ListingSearch($regionId: ID, $text: String!) {
  search(regionId: $regionId, text: $text) {
    __typename
    ... on Collection {
      id
    }
    ... on Restaurant {
      id
    }
    ... on Tag {
      id
    }
  }
}
    `;

/**
 * __useListingSearchQuery__
 *
 * To run a query within a React component, call `useListingSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingSearchQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useListingSearchQuery(baseOptions: Apollo.QueryHookOptions<ListingSearchQuery, ListingSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingSearchQuery, ListingSearchQueryVariables>(ListingSearchDocument, options);
      }
export function useListingSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingSearchQuery, ListingSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingSearchQuery, ListingSearchQueryVariables>(ListingSearchDocument, options);
        }
export type ListingSearchQueryHookResult = ReturnType<typeof useListingSearchQuery>;
export type ListingSearchLazyQueryHookResult = ReturnType<typeof useListingSearchLazyQuery>;
export type ListingSearchQueryResult = Apollo.QueryResult<ListingSearchQuery, ListingSearchQueryVariables>;
export const PageDetailDocument = gql`
    query pageDetail($slug: String!) {
  pageDetail(slug: $slug) {
    id
    name
    slug
    topBanner {
      id
      files
      href
      visible
    }
    middleBanner {
      id
      files
      href
      visible
    }
  }
}
    `;

/**
 * __usePageDetailQuery__
 *
 * To run a query within a React component, call `usePageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageDetailQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePageDetailQuery(baseOptions: Apollo.QueryHookOptions<PageDetailQuery, PageDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageDetailQuery, PageDetailQueryVariables>(PageDetailDocument, options);
      }
export function usePageDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageDetailQuery, PageDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageDetailQuery, PageDetailQueryVariables>(PageDetailDocument, options);
        }
export type PageDetailQueryHookResult = ReturnType<typeof usePageDetailQuery>;
export type PageDetailLazyQueryHookResult = ReturnType<typeof usePageDetailLazyQuery>;
export type PageDetailQueryResult = Apollo.QueryResult<PageDetailQuery, PageDetailQueryVariables>;
export const GetRandomEventDocument = gql`
    query getRandomEvent($region_id: ID, $slotless: Boolean) {
  randomIncomingEvent(region_id: $region_id, slotless: $slotless) {
    id
    title
    price
    startsAt
    endsAt
    address
    slotless
    restaurant {
      name
    }
    metadatas {
      id
      key
      value
    }
    imageFiles {
      id
      preview
    }
  }
}
    `;

/**
 * __useGetRandomEventQuery__
 *
 * To run a query within a React component, call `useGetRandomEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRandomEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRandomEventQuery({
 *   variables: {
 *      region_id: // value for 'region_id'
 *      slotless: // value for 'slotless'
 *   },
 * });
 */
export function useGetRandomEventQuery(baseOptions?: Apollo.QueryHookOptions<GetRandomEventQuery, GetRandomEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRandomEventQuery, GetRandomEventQueryVariables>(GetRandomEventDocument, options);
      }
export function useGetRandomEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRandomEventQuery, GetRandomEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRandomEventQuery, GetRandomEventQueryVariables>(GetRandomEventDocument, options);
        }
export type GetRandomEventQueryHookResult = ReturnType<typeof useGetRandomEventQuery>;
export type GetRandomEventLazyQueryHookResult = ReturnType<typeof useGetRandomEventLazyQuery>;
export type GetRandomEventQueryResult = Apollo.QueryResult<GetRandomEventQuery, GetRandomEventQueryVariables>;
export const ApplyPaymentMethodDiscountDocument = gql`
    mutation ApplyPaymentMethodDiscount($code: String!, $paymentMethod: PaymentMethodEnum) {
  applyPaymentMethodDiscount(code: $code, paymentMethod: $paymentMethod) {
    ...ReservationSummaryData
    reservable {
      __typename
      ... on FestivalEditionRestaurant {
        ...FestivalReservationReservable
      }
      ... on Daily {
        ...DailyReservationReservable
      }
      ... on Event {
        ...EventReservationReservable
      }
    }
  }
}
    ${ReservationSummaryDataFragmentDoc}
${FestivalReservationReservableFragmentDoc}
${DailyReservationReservableFragmentDoc}
${EventReservationReservableFragmentDoc}`;
export type ApplyPaymentMethodDiscountMutationFn = Apollo.MutationFunction<ApplyPaymentMethodDiscountMutation, ApplyPaymentMethodDiscountMutationVariables>;

/**
 * __useApplyPaymentMethodDiscountMutation__
 *
 * To run a mutation, you first call `useApplyPaymentMethodDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyPaymentMethodDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyPaymentMethodDiscountMutation, { data, loading, error }] = useApplyPaymentMethodDiscountMutation({
 *   variables: {
 *      code: // value for 'code'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useApplyPaymentMethodDiscountMutation(baseOptions?: Apollo.MutationHookOptions<ApplyPaymentMethodDiscountMutation, ApplyPaymentMethodDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyPaymentMethodDiscountMutation, ApplyPaymentMethodDiscountMutationVariables>(ApplyPaymentMethodDiscountDocument, options);
      }
export type ApplyPaymentMethodDiscountMutationHookResult = ReturnType<typeof useApplyPaymentMethodDiscountMutation>;
export type ApplyPaymentMethodDiscountMutationResult = Apollo.MutationResult<ApplyPaymentMethodDiscountMutation>;
export type ApplyPaymentMethodDiscountMutationOptions = Apollo.BaseMutationOptions<ApplyPaymentMethodDiscountMutation, ApplyPaymentMethodDiscountMutationVariables>;
export const AvailableDatesDocument = gql`
    query AvailableDates($dates: DateRange!, $reservables: [ReservableInput!]!, $withReservableExtra: Boolean) {
  slots(
    dates: $dates
    reservables: $reservables
    withReservableExtra: $withReservableExtra
  ) {
    date
    slot
    sizes
    reservable {
      ... on Daily {
        id
      }
      ... on Event {
        id
      }
      ... on FestivalEditionRestaurant {
        id
      }
    }
  }
}
    `;

/**
 * __useAvailableDatesQuery__
 *
 * To run a query within a React component, call `useAvailableDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableDatesQuery({
 *   variables: {
 *      dates: // value for 'dates'
 *      reservables: // value for 'reservables'
 *      withReservableExtra: // value for 'withReservableExtra'
 *   },
 * });
 */
export function useAvailableDatesQuery(baseOptions: Apollo.QueryHookOptions<AvailableDatesQuery, AvailableDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableDatesQuery, AvailableDatesQueryVariables>(AvailableDatesDocument, options);
      }
export function useAvailableDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableDatesQuery, AvailableDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableDatesQuery, AvailableDatesQueryVariables>(AvailableDatesDocument, options);
        }
export type AvailableDatesQueryHookResult = ReturnType<typeof useAvailableDatesQuery>;
export type AvailableDatesLazyQueryHookResult = ReturnType<typeof useAvailableDatesLazyQuery>;
export type AvailableDatesQueryResult = Apollo.QueryResult<AvailableDatesQuery, AvailableDatesQueryVariables>;
export const CancelDailyReservationDocument = gql`
    mutation CancelDailyReservation($code: String!) {
  cancelDailyReservation(code: $code) {
    id
  }
}
    `;
export type CancelDailyReservationMutationFn = Apollo.MutationFunction<CancelDailyReservationMutation, CancelDailyReservationMutationVariables>;

/**
 * __useCancelDailyReservationMutation__
 *
 * To run a mutation, you first call `useCancelDailyReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDailyReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDailyReservationMutation, { data, loading, error }] = useCancelDailyReservationMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCancelDailyReservationMutation(baseOptions?: Apollo.MutationHookOptions<CancelDailyReservationMutation, CancelDailyReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDailyReservationMutation, CancelDailyReservationMutationVariables>(CancelDailyReservationDocument, options);
      }
export type CancelDailyReservationMutationHookResult = ReturnType<typeof useCancelDailyReservationMutation>;
export type CancelDailyReservationMutationResult = Apollo.MutationResult<CancelDailyReservationMutation>;
export type CancelDailyReservationMutationOptions = Apollo.BaseMutationOptions<CancelDailyReservationMutation, CancelDailyReservationMutationVariables>;
export const CancelReservationDocument = gql`
    mutation CancelReservation($code: String!) {
  cancelReservation(code: $code) {
    id
  }
}
    `;
export type CancelReservationMutationFn = Apollo.MutationFunction<CancelReservationMutation, CancelReservationMutationVariables>;

/**
 * __useCancelReservationMutation__
 *
 * To run a mutation, you first call `useCancelReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReservationMutation, { data, loading, error }] = useCancelReservationMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCancelReservationMutation(baseOptions?: Apollo.MutationHookOptions<CancelReservationMutation, CancelReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReservationMutation, CancelReservationMutationVariables>(CancelReservationDocument, options);
      }
export type CancelReservationMutationHookResult = ReturnType<typeof useCancelReservationMutation>;
export type CancelReservationMutationResult = Apollo.MutationResult<CancelReservationMutation>;
export type CancelReservationMutationOptions = Apollo.BaseMutationOptions<CancelReservationMutation, CancelReservationMutationVariables>;
export const ConnectReservationDocument = gql`
    mutation ConnectReservation($code: String!, $userId: ID!) {
  connectReservation(code: $code, userId: $userId) {
    id
    code
  }
}
    `;
export type ConnectReservationMutationFn = Apollo.MutationFunction<ConnectReservationMutation, ConnectReservationMutationVariables>;

/**
 * __useConnectReservationMutation__
 *
 * To run a mutation, you first call `useConnectReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectReservationMutation, { data, loading, error }] = useConnectReservationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useConnectReservationMutation(baseOptions?: Apollo.MutationHookOptions<ConnectReservationMutation, ConnectReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectReservationMutation, ConnectReservationMutationVariables>(ConnectReservationDocument, options);
      }
export type ConnectReservationMutationHookResult = ReturnType<typeof useConnectReservationMutation>;
export type ConnectReservationMutationResult = Apollo.MutationResult<ConnectReservationMutation>;
export type ConnectReservationMutationOptions = Apollo.BaseMutationOptions<ConnectReservationMutation, ConnectReservationMutationVariables>;
export const CreateDailyReservationDocument = gql`
    mutation CreateDailyReservation($reservableExtraAttrs: [ReservableExtraAttrInput!], $restaurantId: ID!, $date: Date!, $slot: Int!, $peopleCount: Int!, $reservationSource: Int) {
  createDailyReservation(
    restaurantId: $restaurantId
    date: $date
    slot: $slot
    reservableExtraAttrs: $reservableExtraAttrs
    peopleCount: $peopleCount
    reservationSource: $reservationSource
  ) {
    id
    code
    status
    previousReservation {
      ...MinimumPreviousReservation
    }
    priceValues {
      priceToPay
      totalValue
    }
    reservableExtrasAvailable
    reservable {
      __typename
      ... on Daily {
        crossSells {
          id
          festivalDrink
        }
      }
    }
  }
}
    ${MinimumPreviousReservationFragmentDoc}`;
export type CreateDailyReservationMutationFn = Apollo.MutationFunction<CreateDailyReservationMutation, CreateDailyReservationMutationVariables>;

/**
 * __useCreateDailyReservationMutation__
 *
 * To run a mutation, you first call `useCreateDailyReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyReservationMutation, { data, loading, error }] = useCreateDailyReservationMutation({
 *   variables: {
 *      reservableExtraAttrs: // value for 'reservableExtraAttrs'
 *      restaurantId: // value for 'restaurantId'
 *      date: // value for 'date'
 *      slot: // value for 'slot'
 *      peopleCount: // value for 'peopleCount'
 *      reservationSource: // value for 'reservationSource'
 *   },
 * });
 */
export function useCreateDailyReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyReservationMutation, CreateDailyReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDailyReservationMutation, CreateDailyReservationMutationVariables>(CreateDailyReservationDocument, options);
      }
export type CreateDailyReservationMutationHookResult = ReturnType<typeof useCreateDailyReservationMutation>;
export type CreateDailyReservationMutationResult = Apollo.MutationResult<CreateDailyReservationMutation>;
export type CreateDailyReservationMutationOptions = Apollo.BaseMutationOptions<CreateDailyReservationMutation, CreateDailyReservationMutationVariables>;
export const CreateEventReservationDocument = gql`
    mutation CreateEventReservation($eventId: ID!, $date: Date!, $slot: Int!, $peopleCount: Int!, $notes: String, $menus: [Int!]!) {
  createEventReservation(
    eventId: $eventId
    date: $date
    slot: $slot
    peopleCount: $peopleCount
    notes: $notes
    menus: $menus
  ) {
    id
    code
    previousReservation {
      ...MinimumPreviousReservation
    }
    priceValues {
      priceToPay
      discountValue
    }
  }
}
    ${MinimumPreviousReservationFragmentDoc}`;
export type CreateEventReservationMutationFn = Apollo.MutationFunction<CreateEventReservationMutation, CreateEventReservationMutationVariables>;

/**
 * __useCreateEventReservationMutation__
 *
 * To run a mutation, you first call `useCreateEventReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventReservationMutation, { data, loading, error }] = useCreateEventReservationMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      date: // value for 'date'
 *      slot: // value for 'slot'
 *      peopleCount: // value for 'peopleCount'
 *      notes: // value for 'notes'
 *      menus: // value for 'menus'
 *   },
 * });
 */
export function useCreateEventReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventReservationMutation, CreateEventReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventReservationMutation, CreateEventReservationMutationVariables>(CreateEventReservationDocument, options);
      }
export type CreateEventReservationMutationHookResult = ReturnType<typeof useCreateEventReservationMutation>;
export type CreateEventReservationMutationResult = Apollo.MutationResult<CreateEventReservationMutation>;
export type CreateEventReservationMutationOptions = Apollo.BaseMutationOptions<CreateEventReservationMutation, CreateEventReservationMutationVariables>;
export const CreateFestivalReservationDocument = gql`
    mutation CreateFestivalReservation($festivalEditionId: ID!, $restaurantId: ID!, $date: Date!, $slot: Int!, $menus: [Int!]!, $voucherCode: String, $sourceId: Int, $peopleCount: Int!) {
  createFestivalReservation(
    festivalEditionId: $festivalEditionId
    restaurantId: $restaurantId
    date: $date
    slot: $slot
    menus: $menus
    voucherCode: $voucherCode
    reservationSource: $sourceId
    peopleCount: $peopleCount
  ) {
    id
    code
    reservableExtrasAvailable
    reservable {
      __typename
      ... on FestivalEditionRestaurant {
        id
        crossSells {
          id
          festivalDrink
        }
      }
    }
  }
}
    `;
export type CreateFestivalReservationMutationFn = Apollo.MutationFunction<CreateFestivalReservationMutation, CreateFestivalReservationMutationVariables>;

/**
 * __useCreateFestivalReservationMutation__
 *
 * To run a mutation, you first call `useCreateFestivalReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFestivalReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFestivalReservationMutation, { data, loading, error }] = useCreateFestivalReservationMutation({
 *   variables: {
 *      festivalEditionId: // value for 'festivalEditionId'
 *      restaurantId: // value for 'restaurantId'
 *      date: // value for 'date'
 *      slot: // value for 'slot'
 *      menus: // value for 'menus'
 *      voucherCode: // value for 'voucherCode'
 *      sourceId: // value for 'sourceId'
 *      peopleCount: // value for 'peopleCount'
 *   },
 * });
 */
export function useCreateFestivalReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateFestivalReservationMutation, CreateFestivalReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFestivalReservationMutation, CreateFestivalReservationMutationVariables>(CreateFestivalReservationDocument, options);
      }
export type CreateFestivalReservationMutationHookResult = ReturnType<typeof useCreateFestivalReservationMutation>;
export type CreateFestivalReservationMutationResult = Apollo.MutationResult<CreateFestivalReservationMutation>;
export type CreateFestivalReservationMutationOptions = Apollo.BaseMutationOptions<CreateFestivalReservationMutation, CreateFestivalReservationMutationVariables>;
export const EvaluationReservationDocument = gql`
    query EvaluationReservation($code: String!, $securityToken: String) {
  reservation(code: $code, securityToken: $securityToken) {
    id
    code
    passed
    peopleCount
    date
    slot
    hour
    menus
    review {
      id
    }
    reservable {
      __typename
      ... on FestivalEditionRestaurant {
        id
        menusPerPerson
        menus {
          label
        }
        allDaySlots
        restaurant {
          id
          address
          name
          imageFiles {
            id
            preview
          }
        }
        festivalEdition {
          id
          forceLabels
          festival {
            id
            code
            name
          }
        }
      }
      ... on Daily {
        id
        restaurant {
          id
          address
          name
          imageFiles {
            id
            preview
          }
        }
      }
      ... on Event {
        id
        code
        title
        imageFiles {
          id
          preview
        }
        slotless
        eventRestaurant: restaurant {
          slug
          ...ContactDetails
        }
        metadatas {
          id
          key
          value
        }
      }
    }
    user {
      id
      firstName
    }
  }
}
    ${ContactDetailsFragmentDoc}`;

/**
 * __useEvaluationReservationQuery__
 *
 * To run a query within a React component, call `useEvaluationReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationReservationQuery({
 *   variables: {
 *      code: // value for 'code'
 *      securityToken: // value for 'securityToken'
 *   },
 * });
 */
export function useEvaluationReservationQuery(baseOptions: Apollo.QueryHookOptions<EvaluationReservationQuery, EvaluationReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationReservationQuery, EvaluationReservationQueryVariables>(EvaluationReservationDocument, options);
      }
export function useEvaluationReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationReservationQuery, EvaluationReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationReservationQuery, EvaluationReservationQueryVariables>(EvaluationReservationDocument, options);
        }
export type EvaluationReservationQueryHookResult = ReturnType<typeof useEvaluationReservationQuery>;
export type EvaluationReservationLazyQueryHookResult = ReturnType<typeof useEvaluationReservationLazyQuery>;
export type EvaluationReservationQueryResult = Apollo.QueryResult<EvaluationReservationQuery, EvaluationReservationQueryVariables>;
export const MyPurchasesDocument = gql`
    query MyPurchases($festival: FestivalCodesEnum, $first: Int, $after: String) {
  myPurchases(festival: $festival, first: $first, after: $after) @connection(key: "myPurchases") {
    edges {
      node {
        ... on Reservation {
          id
          canBeUpdated
          code
          date
          hour
          slot
          createdAt
          peopleCount
          priceValues {
            totalValue
          }
          review {
            id
          }
          user {
            id
          }
          reservable {
            ... on Daily {
              id
              dailyRestaurant: restaurant {
                id
                name
                address
                latitude
                longitude
                imageFiles {
                  id
                  preview
                }
              }
            }
            ... on Event {
              id
              title
              slotless
              eventRestaurant: restaurant {
                id
                address
                latitude
                longitude
                imageFiles {
                  id
                  preview
                }
              }
            }
            ... on FestivalEditionRestaurant {
              id
              festivalEdition {
                id
                festival {
                  id
                  code
                }
              }
              restaurant {
                id
                name
                address
                latitude
                longitude
                imageFiles {
                  id
                  preview
                }
              }
            }
          }
          discount {
            id
            code
            festivalEdition {
              id
            }
            type
            value
          }
          reservationCrossSells {
            id
            quantity
            isApplicable
            crossSell {
              id
              name
            }
          }
          status
        }
        ... on Voucher {
          id
          code
          peopleCount
          createdAt
          used
          festivalEdition {
            id
            endsAt
            startsAt
            festival {
              id
              name
              code
              logo {
                id
                thumbnail
              }
            }
            state
          }
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useMyPurchasesQuery__
 *
 * To run a query within a React component, call `useMyPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPurchasesQuery({
 *   variables: {
 *      festival: // value for 'festival'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMyPurchasesQuery(baseOptions?: Apollo.QueryHookOptions<MyPurchasesQuery, MyPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPurchasesQuery, MyPurchasesQueryVariables>(MyPurchasesDocument, options);
      }
export function useMyPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPurchasesQuery, MyPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPurchasesQuery, MyPurchasesQueryVariables>(MyPurchasesDocument, options);
        }
export type MyPurchasesQueryHookResult = ReturnType<typeof useMyPurchasesQuery>;
export type MyPurchasesLazyQueryHookResult = ReturnType<typeof useMyPurchasesLazyQuery>;
export type MyPurchasesQueryResult = Apollo.QueryResult<MyPurchasesQuery, MyPurchasesQueryVariables>;
export const ReservableExtraListDocument = gql`
    query ReservableExtraList($name: String, $restaurantTags: [TagFilter], $after: String, $first: Int, $regionIds: [ID!]) {
  reservableExtras(
    regionIds: $regionIds
    enabled: true
    restaurant_tags: $restaurantTags
    name: $name
    first: $first
    after: $after
  ) {
    nodes {
      ...LeanReservableExtra
      restaurant {
        ...RestaurantInReservableExtra
      }
    }
    totalCount
    pageInfo {
      endCursor
    }
  }
}
    ${LeanReservableExtraFragmentDoc}
${RestaurantInReservableExtraFragmentDoc}`;

/**
 * __useReservableExtraListQuery__
 *
 * To run a query within a React component, call `useReservableExtraListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservableExtraListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservableExtraListQuery({
 *   variables: {
 *      name: // value for 'name'
 *      restaurantTags: // value for 'restaurantTags'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      regionIds: // value for 'regionIds'
 *   },
 * });
 */
export function useReservableExtraListQuery(baseOptions?: Apollo.QueryHookOptions<ReservableExtraListQuery, ReservableExtraListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservableExtraListQuery, ReservableExtraListQueryVariables>(ReservableExtraListDocument, options);
      }
export function useReservableExtraListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservableExtraListQuery, ReservableExtraListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservableExtraListQuery, ReservableExtraListQueryVariables>(ReservableExtraListDocument, options);
        }
export type ReservableExtraListQueryHookResult = ReturnType<typeof useReservableExtraListQuery>;
export type ReservableExtraListLazyQueryHookResult = ReturnType<typeof useReservableExtraListLazyQuery>;
export type ReservableExtraListQueryResult = Apollo.QueryResult<ReservableExtraListQuery, ReservableExtraListQueryVariables>;
export const ReservationDetailsGuestDocument = gql`
    query ReservationDetailsGuest($code: String) {
  reservation(code: $code) {
    ...InviteData
    ...SlotDuration
    ...SelectedMenus
  }
}
    ${InviteDataFragmentDoc}
${SlotDurationFragmentDoc}
${SelectedMenusFragmentDoc}`;

/**
 * __useReservationDetailsGuestQuery__
 *
 * To run a query within a React component, call `useReservationDetailsGuestQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationDetailsGuestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationDetailsGuestQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useReservationDetailsGuestQuery(baseOptions?: Apollo.QueryHookOptions<ReservationDetailsGuestQuery, ReservationDetailsGuestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationDetailsGuestQuery, ReservationDetailsGuestQueryVariables>(ReservationDetailsGuestDocument, options);
      }
export function useReservationDetailsGuestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationDetailsGuestQuery, ReservationDetailsGuestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationDetailsGuestQuery, ReservationDetailsGuestQueryVariables>(ReservationDetailsGuestDocument, options);
        }
export type ReservationDetailsGuestQueryHookResult = ReturnType<typeof useReservationDetailsGuestQuery>;
export type ReservationDetailsGuestLazyQueryHookResult = ReturnType<typeof useReservationDetailsGuestLazyQuery>;
export type ReservationDetailsGuestQueryResult = Apollo.QueryResult<ReservationDetailsGuestQuery, ReservationDetailsGuestQueryVariables>;
export const ReservationOffersListDocument = gql`
    query ReservationOffersList($region_id: ID, $name: String, $tags: [TagFilter], $ids: [ID], $after: String, $first: Int, $sort: RestaurantSort) {
  restaurants(
    region_id: $region_id
    name: $name
    tags: $tags
    with_reservable_extras: true
    ids: $ids
    first: $first
    after: $after
    sort: $sort
  ) {
    nodes {
      id
      ...RestaurantInReservableExtra
      reservableExtras {
        ...LeanReservableExtra
      }
    }
    totalCount
    pageInfo {
      endCursor
    }
  }
}
    ${RestaurantInReservableExtraFragmentDoc}
${LeanReservableExtraFragmentDoc}`;

/**
 * __useReservationOffersListQuery__
 *
 * To run a query within a React component, call `useReservationOffersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationOffersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationOffersListQuery({
 *   variables: {
 *      region_id: // value for 'region_id'
 *      name: // value for 'name'
 *      tags: // value for 'tags'
 *      ids: // value for 'ids'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReservationOffersListQuery(baseOptions?: Apollo.QueryHookOptions<ReservationOffersListQuery, ReservationOffersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationOffersListQuery, ReservationOffersListQueryVariables>(ReservationOffersListDocument, options);
      }
export function useReservationOffersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationOffersListQuery, ReservationOffersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationOffersListQuery, ReservationOffersListQueryVariables>(ReservationOffersListDocument, options);
        }
export type ReservationOffersListQueryHookResult = ReturnType<typeof useReservationOffersListQuery>;
export type ReservationOffersListLazyQueryHookResult = ReturnType<typeof useReservationOffersListLazyQuery>;
export type ReservationOffersListQueryResult = Apollo.QueryResult<ReservationOffersListQuery, ReservationOffersListQueryVariables>;
export const ReservationSummaryDocument = gql`
    query ReservationSummary($code: String!) {
  reservation(code: $code) {
    ...ReservationSummaryData
    reservable {
      __typename
      ... on FestivalEditionRestaurant {
        ...FestivalReservationReservable
      }
      ... on Daily {
        ...DailyReservationReservable
      }
      ... on Event {
        ...EventReservationReservable
      }
    }
  }
}
    ${ReservationSummaryDataFragmentDoc}
${FestivalReservationReservableFragmentDoc}
${DailyReservationReservableFragmentDoc}
${EventReservationReservableFragmentDoc}`;

/**
 * __useReservationSummaryQuery__
 *
 * To run a query within a React component, call `useReservationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationSummaryQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useReservationSummaryQuery(baseOptions: Apollo.QueryHookOptions<ReservationSummaryQuery, ReservationSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationSummaryQuery, ReservationSummaryQueryVariables>(ReservationSummaryDocument, options);
      }
export function useReservationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationSummaryQuery, ReservationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationSummaryQuery, ReservationSummaryQueryVariables>(ReservationSummaryDocument, options);
        }
export type ReservationSummaryQueryHookResult = ReturnType<typeof useReservationSummaryQuery>;
export type ReservationSummaryLazyQueryHookResult = ReturnType<typeof useReservationSummaryLazyQuery>;
export type ReservationSummaryQueryResult = Apollo.QueryResult<ReservationSummaryQuery, ReservationSummaryQueryVariables>;
export const SendReservationNotificationDocument = gql`
    mutation sendReservationNotification($id: ID!, $type: ReservationNotificationTypeEnum!) {
  sendReservationNotification(id: $id, type: $type)
}
    `;
export type SendReservationNotificationMutationFn = Apollo.MutationFunction<SendReservationNotificationMutation, SendReservationNotificationMutationVariables>;

/**
 * __useSendReservationNotificationMutation__
 *
 * To run a mutation, you first call `useSendReservationNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReservationNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReservationNotificationMutation, { data, loading, error }] = useSendReservationNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSendReservationNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendReservationNotificationMutation, SendReservationNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendReservationNotificationMutation, SendReservationNotificationMutationVariables>(SendReservationNotificationDocument, options);
      }
export type SendReservationNotificationMutationHookResult = ReturnType<typeof useSendReservationNotificationMutation>;
export type SendReservationNotificationMutationResult = Apollo.MutationResult<SendReservationNotificationMutation>;
export type SendReservationNotificationMutationOptions = Apollo.BaseMutationOptions<SendReservationNotificationMutation, SendReservationNotificationMutationVariables>;
export const SlotsUsageDocument = gql`
    query SlotsUsage($dates: DateRange!, $reservables: [ReservableInput!]!, $withReservableExtra: Boolean) {
  slots(
    dates: $dates
    reservables: $reservables
    withReservableExtra: $withReservableExtra
  ) {
    date
    discount
    runningOut
    sizes
    slot
    interval
    primeTimeFee
    reservable {
      ... on Daily {
        id
      }
      ... on Event {
        id
      }
      ... on FestivalEditionRestaurant {
        id
      }
    }
  }
}
    `;

/**
 * __useSlotsUsageQuery__
 *
 * To run a query within a React component, call `useSlotsUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlotsUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlotsUsageQuery({
 *   variables: {
 *      dates: // value for 'dates'
 *      reservables: // value for 'reservables'
 *      withReservableExtra: // value for 'withReservableExtra'
 *   },
 * });
 */
export function useSlotsUsageQuery(baseOptions: Apollo.QueryHookOptions<SlotsUsageQuery, SlotsUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlotsUsageQuery, SlotsUsageQueryVariables>(SlotsUsageDocument, options);
      }
export function useSlotsUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlotsUsageQuery, SlotsUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlotsUsageQuery, SlotsUsageQueryVariables>(SlotsUsageDocument, options);
        }
export type SlotsUsageQueryHookResult = ReturnType<typeof useSlotsUsageQuery>;
export type SlotsUsageLazyQueryHookResult = ReturnType<typeof useSlotsUsageLazyQuery>;
export type SlotsUsageQueryResult = Apollo.QueryResult<SlotsUsageQuery, SlotsUsageQueryVariables>;
export const UpdateDailyReservationDocument = gql`
    mutation UpdateDailyReservation($code: String!, $reservableExtraAttrs: [ReservableExtraAttrInput!], $crossSellsList: [CrossSellsList!], $redeemCode: String, $notes: String, $date: Date, $slot: Int, $peopleCount: Int, $vatId: String) {
  updateDailyReservation(
    code: $code
    crossSellsList: $crossSellsList
    reservableExtraAttrs: $reservableExtraAttrs
    redeemCode: $redeemCode
    notes: $notes
    date: $date
    slot: $slot
    peopleCount: $peopleCount
    vatId: $vatId
  ) {
    ...ReservationSummaryData
    reservable {
      __typename
      ... on Daily {
        ...DailyReservationReservable
      }
    }
  }
}
    ${ReservationSummaryDataFragmentDoc}
${DailyReservationReservableFragmentDoc}`;
export type UpdateDailyReservationMutationFn = Apollo.MutationFunction<UpdateDailyReservationMutation, UpdateDailyReservationMutationVariables>;

/**
 * __useUpdateDailyReservationMutation__
 *
 * To run a mutation, you first call `useUpdateDailyReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyReservationMutation, { data, loading, error }] = useUpdateDailyReservationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      reservableExtraAttrs: // value for 'reservableExtraAttrs'
 *      crossSellsList: // value for 'crossSellsList'
 *      redeemCode: // value for 'redeemCode'
 *      notes: // value for 'notes'
 *      date: // value for 'date'
 *      slot: // value for 'slot'
 *      peopleCount: // value for 'peopleCount'
 *      vatId: // value for 'vatId'
 *   },
 * });
 */
export function useUpdateDailyReservationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyReservationMutation, UpdateDailyReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyReservationMutation, UpdateDailyReservationMutationVariables>(UpdateDailyReservationDocument, options);
      }
export type UpdateDailyReservationMutationHookResult = ReturnType<typeof useUpdateDailyReservationMutation>;
export type UpdateDailyReservationMutationResult = Apollo.MutationResult<UpdateDailyReservationMutation>;
export type UpdateDailyReservationMutationOptions = Apollo.BaseMutationOptions<UpdateDailyReservationMutation, UpdateDailyReservationMutationVariables>;
export const UpdateEventReservationDocument = gql`
    mutation updateEventReservation($code: String!, $vatId: String, $redeemCode: String, $notes: String, $menus: [Int!], $userAcceptedMarketingConsent: Boolean) {
  updateEventReservation(
    code: $code
    vatId: $vatId
    notes: $notes
    menus: $menus
    redeemCode: $redeemCode
    userAcceptedMarketingConsent: $userAcceptedMarketingConsent
  ) {
    ...ReservationSummaryData
    reservable {
      __typename
      ... on Event {
        ...EventReservationReservable
      }
    }
  }
}
    ${ReservationSummaryDataFragmentDoc}
${EventReservationReservableFragmentDoc}`;
export type UpdateEventReservationMutationFn = Apollo.MutationFunction<UpdateEventReservationMutation, UpdateEventReservationMutationVariables>;

/**
 * __useUpdateEventReservationMutation__
 *
 * To run a mutation, you first call `useUpdateEventReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventReservationMutation, { data, loading, error }] = useUpdateEventReservationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      vatId: // value for 'vatId'
 *      redeemCode: // value for 'redeemCode'
 *      notes: // value for 'notes'
 *      menus: // value for 'menus'
 *      userAcceptedMarketingConsent: // value for 'userAcceptedMarketingConsent'
 *   },
 * });
 */
export function useUpdateEventReservationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventReservationMutation, UpdateEventReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventReservationMutation, UpdateEventReservationMutationVariables>(UpdateEventReservationDocument, options);
      }
export type UpdateEventReservationMutationHookResult = ReturnType<typeof useUpdateEventReservationMutation>;
export type UpdateEventReservationMutationResult = Apollo.MutationResult<UpdateEventReservationMutation>;
export type UpdateEventReservationMutationOptions = Apollo.BaseMutationOptions<UpdateEventReservationMutation, UpdateEventReservationMutationVariables>;
export const UpdateFestivalReservationDocument = gql`
    mutation UpdateFestivalReservation($code: String!, $crossSellsList: [CrossSellsList!], $menus: [Int!], $date: Date, $slot: Int, $peopleCount: Int, $redeemCode: String, $notes: String, $vatId: String, $userAcceptedMarketingConsent: Boolean) {
  updateFestivalReservation(
    code: $code
    crossSellsList: $crossSellsList
    menus: $menus
    date: $date
    slot: $slot
    peopleCount: $peopleCount
    redeemCode: $redeemCode
    notes: $notes
    vatId: $vatId
    userAcceptedMarketingConsent: $userAcceptedMarketingConsent
  ) {
    ...ReservationSummaryData
    reservable {
      __typename
      ... on FestivalEditionRestaurant {
        ...FestivalReservationReservable
      }
    }
  }
}
    ${ReservationSummaryDataFragmentDoc}
${FestivalReservationReservableFragmentDoc}`;
export type UpdateFestivalReservationMutationFn = Apollo.MutationFunction<UpdateFestivalReservationMutation, UpdateFestivalReservationMutationVariables>;

/**
 * __useUpdateFestivalReservationMutation__
 *
 * To run a mutation, you first call `useUpdateFestivalReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFestivalReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFestivalReservationMutation, { data, loading, error }] = useUpdateFestivalReservationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      crossSellsList: // value for 'crossSellsList'
 *      menus: // value for 'menus'
 *      date: // value for 'date'
 *      slot: // value for 'slot'
 *      peopleCount: // value for 'peopleCount'
 *      redeemCode: // value for 'redeemCode'
 *      notes: // value for 'notes'
 *      vatId: // value for 'vatId'
 *      userAcceptedMarketingConsent: // value for 'userAcceptedMarketingConsent'
 *   },
 * });
 */
export function useUpdateFestivalReservationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFestivalReservationMutation, UpdateFestivalReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFestivalReservationMutation, UpdateFestivalReservationMutationVariables>(UpdateFestivalReservationDocument, options);
      }
export type UpdateFestivalReservationMutationHookResult = ReturnType<typeof useUpdateFestivalReservationMutation>;
export type UpdateFestivalReservationMutationResult = Apollo.MutationResult<UpdateFestivalReservationMutation>;
export type UpdateFestivalReservationMutationOptions = Apollo.BaseMutationOptions<UpdateFestivalReservationMutation, UpdateFestivalReservationMutationVariables>;
export const ValidateVoucherDocument = gql`
    query validateVoucher($code: String!) {
  voucher(code: $code) {
    id
    code
    marketingConsentRequired
    festivalEditions {
      code
    }
  }
}
    `;

/**
 * __useValidateVoucherQuery__
 *
 * To run a query within a React component, call `useValidateVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateVoucherQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useValidateVoucherQuery(baseOptions: Apollo.QueryHookOptions<ValidateVoucherQuery, ValidateVoucherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateVoucherQuery, ValidateVoucherQueryVariables>(ValidateVoucherDocument, options);
      }
export function useValidateVoucherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateVoucherQuery, ValidateVoucherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateVoucherQuery, ValidateVoucherQueryVariables>(ValidateVoucherDocument, options);
        }
export type ValidateVoucherQueryHookResult = ReturnType<typeof useValidateVoucherQuery>;
export type ValidateVoucherLazyQueryHookResult = ReturnType<typeof useValidateVoucherLazyQuery>;
export type ValidateVoucherQueryResult = Apollo.QueryResult<ValidateVoucherQuery, ValidateVoucherQueryVariables>;
export const IntegrationLinkPageDocument = gql`
    query IntegrationLinkPage($id: ID!) {
  restaurant(id: $id) {
    id
    name
    reservableExtras {
      id
    }
  }
}
    `;

/**
 * __useIntegrationLinkPageQuery__
 *
 * To run a query within a React component, call `useIntegrationLinkPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationLinkPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationLinkPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationLinkPageQuery(baseOptions: Apollo.QueryHookOptions<IntegrationLinkPageQuery, IntegrationLinkPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationLinkPageQuery, IntegrationLinkPageQueryVariables>(IntegrationLinkPageDocument, options);
      }
export function useIntegrationLinkPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationLinkPageQuery, IntegrationLinkPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationLinkPageQuery, IntegrationLinkPageQueryVariables>(IntegrationLinkPageDocument, options);
        }
export type IntegrationLinkPageQueryHookResult = ReturnType<typeof useIntegrationLinkPageQuery>;
export type IntegrationLinkPageLazyQueryHookResult = ReturnType<typeof useIntegrationLinkPageLazyQuery>;
export type IntegrationLinkPageQueryResult = Apollo.QueryResult<IntegrationLinkPageQuery, IntegrationLinkPageQueryVariables>;
export const CreateFavouriteRestaurantDocument = gql`
    mutation CreateFavouriteRestaurant($restaurantId: ID!) {
  createFavorite(restaurantId: $restaurantId) {
    restaurant {
      id
      favorited
    }
  }
}
    `;
export type CreateFavouriteRestaurantMutationFn = Apollo.MutationFunction<CreateFavouriteRestaurantMutation, CreateFavouriteRestaurantMutationVariables>;

/**
 * __useCreateFavouriteRestaurantMutation__
 *
 * To run a mutation, you first call `useCreateFavouriteRestaurantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFavouriteRestaurantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFavouriteRestaurantMutation, { data, loading, error }] = useCreateFavouriteRestaurantMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useCreateFavouriteRestaurantMutation(baseOptions?: Apollo.MutationHookOptions<CreateFavouriteRestaurantMutation, CreateFavouriteRestaurantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFavouriteRestaurantMutation, CreateFavouriteRestaurantMutationVariables>(CreateFavouriteRestaurantDocument, options);
      }
export type CreateFavouriteRestaurantMutationHookResult = ReturnType<typeof useCreateFavouriteRestaurantMutation>;
export type CreateFavouriteRestaurantMutationResult = Apollo.MutationResult<CreateFavouriteRestaurantMutation>;
export type CreateFavouriteRestaurantMutationOptions = Apollo.BaseMutationOptions<CreateFavouriteRestaurantMutation, CreateFavouriteRestaurantMutationVariables>;
export const DestroyFavouriteRestaurantDocument = gql`
    mutation DestroyFavouriteRestaurant($restaurantId: ID!) {
  destroyFavorite(restaurantId: $restaurantId) {
    restaurant {
      id
      favorited
    }
  }
}
    `;
export type DestroyFavouriteRestaurantMutationFn = Apollo.MutationFunction<DestroyFavouriteRestaurantMutation, DestroyFavouriteRestaurantMutationVariables>;

/**
 * __useDestroyFavouriteRestaurantMutation__
 *
 * To run a mutation, you first call `useDestroyFavouriteRestaurantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyFavouriteRestaurantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyFavouriteRestaurantMutation, { data, loading, error }] = useDestroyFavouriteRestaurantMutation({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useDestroyFavouriteRestaurantMutation(baseOptions?: Apollo.MutationHookOptions<DestroyFavouriteRestaurantMutation, DestroyFavouriteRestaurantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyFavouriteRestaurantMutation, DestroyFavouriteRestaurantMutationVariables>(DestroyFavouriteRestaurantDocument, options);
      }
export type DestroyFavouriteRestaurantMutationHookResult = ReturnType<typeof useDestroyFavouriteRestaurantMutation>;
export type DestroyFavouriteRestaurantMutationResult = Apollo.MutationResult<DestroyFavouriteRestaurantMutation>;
export type DestroyFavouriteRestaurantMutationOptions = Apollo.BaseMutationOptions<DestroyFavouriteRestaurantMutation, DestroyFavouriteRestaurantMutationVariables>;
export const LikeDocument = gql`
    query Like($id: ID!) {
  restaurant(id: $id) {
    favorited
  }
}
    `;

/**
 * __useLikeQuery__
 *
 * To run a query within a React component, call `useLikeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLikeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLikeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLikeQuery(baseOptions: Apollo.QueryHookOptions<LikeQuery, LikeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LikeQuery, LikeQueryVariables>(LikeDocument, options);
      }
export function useLikeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LikeQuery, LikeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LikeQuery, LikeQueryVariables>(LikeDocument, options);
        }
export type LikeQueryHookResult = ReturnType<typeof useLikeQuery>;
export type LikeLazyQueryHookResult = ReturnType<typeof useLikeLazyQuery>;
export type LikeQueryResult = Apollo.QueryResult<LikeQuery, LikeQueryVariables>;
export const OtherDatesRestaurantsDocument = gql`
    query OtherDatesRestaurants($region_id: ID, $reservation_filters: ReservationFilter, $tag_ids: [ID], $ids: [ID], $with_reservable_extras: Boolean, $after: String, $first: Int, $sort: RestaurantSort) {
  otherDatesRestaurants(
    region_id: $region_id
    reservation_filters: $reservation_filters
    with_reservable_extras: $with_reservable_extras
    tag_ids: $tag_ids
    ids: $ids
    first: $first
    after: $after
    sort: $sort
  ) {
    nodes {
      ...RestaurantListElement
    }
    totalCount
    pageInfo {
      endCursor
    }
  }
}
    ${RestaurantListElementFragmentDoc}`;

/**
 * __useOtherDatesRestaurantsQuery__
 *
 * To run a query within a React component, call `useOtherDatesRestaurantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOtherDatesRestaurantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOtherDatesRestaurantsQuery({
 *   variables: {
 *      region_id: // value for 'region_id'
 *      reservation_filters: // value for 'reservation_filters'
 *      tag_ids: // value for 'tag_ids'
 *      ids: // value for 'ids'
 *      with_reservable_extras: // value for 'with_reservable_extras'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useOtherDatesRestaurantsQuery(baseOptions?: Apollo.QueryHookOptions<OtherDatesRestaurantsQuery, OtherDatesRestaurantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OtherDatesRestaurantsQuery, OtherDatesRestaurantsQueryVariables>(OtherDatesRestaurantsDocument, options);
      }
export function useOtherDatesRestaurantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OtherDatesRestaurantsQuery, OtherDatesRestaurantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OtherDatesRestaurantsQuery, OtherDatesRestaurantsQueryVariables>(OtherDatesRestaurantsDocument, options);
        }
export type OtherDatesRestaurantsQueryHookResult = ReturnType<typeof useOtherDatesRestaurantsQuery>;
export type OtherDatesRestaurantsLazyQueryHookResult = ReturnType<typeof useOtherDatesRestaurantsLazyQuery>;
export type OtherDatesRestaurantsQueryResult = Apollo.QueryResult<OtherDatesRestaurantsQuery, OtherDatesRestaurantsQueryVariables>;
export const ReservablesDocument = gql`
    query reservables($restaurantId: ID!, $dates: DateRange!) {
  reservables(restaurantId: $restaurantId, dates: $dates) {
    ... on Daily {
      id
      possibleSlots
      reservableFrom
      minPeopleCount
      maxPeopleCount
      restaurant {
        id
      }
      slotDefinitions {
        possibleSlots
      }
      crossSells {
        ...LeanCrossSell
      }
    }
    ... on FestivalEditionRestaurant {
      id
      allDaySlots
      notes
      price
      menusPerPerson
      menus {
        ...LeanMenu
      }
      availableReservationTypes
      restaurant {
        id
      }
      reservableFrom
      festivalEdition {
        id
        code
        startsAt
        endsAt
        state
        price
        minPeopleCount
        maxPeopleCount
        menuPositions {
          __typename
        }
        forceLabels
        festival {
          id
          code
          name
          slogan
          shortDescription
          slug
        }
        slots {
          id
          possibleSlots
          slotStart
        }
        reservableFrom
      }
      crossSells {
        ...LeanCrossSell
      }
    }
  }
}
    ${LeanCrossSellFragmentDoc}
${LeanMenuFragmentDoc}`;

/**
 * __useReservablesQuery__
 *
 * To run a query within a React component, call `useReservablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservablesQuery({
 *   variables: {
 *      restaurantId: // value for 'restaurantId'
 *      dates: // value for 'dates'
 *   },
 * });
 */
export function useReservablesQuery(baseOptions: Apollo.QueryHookOptions<ReservablesQuery, ReservablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservablesQuery, ReservablesQueryVariables>(ReservablesDocument, options);
      }
export function useReservablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservablesQuery, ReservablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservablesQuery, ReservablesQueryVariables>(ReservablesDocument, options);
        }
export type ReservablesQueryHookResult = ReturnType<typeof useReservablesQuery>;
export type ReservablesLazyQueryHookResult = ReturnType<typeof useReservablesLazyQuery>;
export type ReservablesQueryResult = Apollo.QueryResult<ReservablesQuery, ReservablesQueryVariables>;
export const RestaurantMenuDocument = gql`
    query RestaurantMenu($ferId: ID!, $type: ReservableEnum!) {
  reservable(id: $ferId, type: $type) {
    ... on FestivalEditionRestaurant {
      menus {
        ...LeanMenu
      }
    }
  }
}
    ${LeanMenuFragmentDoc}`;

/**
 * __useRestaurantMenuQuery__
 *
 * To run a query within a React component, call `useRestaurantMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantMenuQuery({
 *   variables: {
 *      ferId: // value for 'ferId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRestaurantMenuQuery(baseOptions: Apollo.QueryHookOptions<RestaurantMenuQuery, RestaurantMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RestaurantMenuQuery, RestaurantMenuQueryVariables>(RestaurantMenuDocument, options);
      }
export function useRestaurantMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RestaurantMenuQuery, RestaurantMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RestaurantMenuQuery, RestaurantMenuQueryVariables>(RestaurantMenuDocument, options);
        }
export type RestaurantMenuQueryHookResult = ReturnType<typeof useRestaurantMenuQuery>;
export type RestaurantMenuLazyQueryHookResult = ReturnType<typeof useRestaurantMenuLazyQuery>;
export type RestaurantMenuQueryResult = Apollo.QueryResult<RestaurantMenuQuery, RestaurantMenuQueryVariables>;
export const RestaurantSlugDocument = gql`
    query RestaurantSlug($id: ID!) {
  restaurant(id: $id) {
    slug
  }
}
    `;

/**
 * __useRestaurantSlugQuery__
 *
 * To run a query within a React component, call `useRestaurantSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantSlugQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestaurantSlugQuery(baseOptions: Apollo.QueryHookOptions<RestaurantSlugQuery, RestaurantSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RestaurantSlugQuery, RestaurantSlugQueryVariables>(RestaurantSlugDocument, options);
      }
export function useRestaurantSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RestaurantSlugQuery, RestaurantSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RestaurantSlugQuery, RestaurantSlugQueryVariables>(RestaurantSlugDocument, options);
        }
export type RestaurantSlugQueryHookResult = ReturnType<typeof useRestaurantSlugQuery>;
export type RestaurantSlugLazyQueryHookResult = ReturnType<typeof useRestaurantSlugLazyQuery>;
export type RestaurantSlugQueryResult = Apollo.QueryResult<RestaurantSlugQuery, RestaurantSlugQueryVariables>;
export const RestaurantsListDocument = gql`
    query RestaurantsList($region_id: ID, $reservation_filters: ReservationFilter, $tag_ids: [ID], $ids: [ID], $with_reservable_extras: Boolean, $after: String, $first: Int, $sort: RestaurantSort) {
  restaurants(
    region_id: $region_id
    reservation_filters: $reservation_filters
    with_reservable_extras: $with_reservable_extras
    tag_ids: $tag_ids
    ids: $ids
    first: $first
    after: $after
    sort: $sort
  ) {
    nodes {
      ...RestaurantListElement
    }
    totalCount
    pageInfo {
      endCursor
    }
  }
}
    ${RestaurantListElementFragmentDoc}`;

/**
 * __useRestaurantsListQuery__
 *
 * To run a query within a React component, call `useRestaurantsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantsListQuery({
 *   variables: {
 *      region_id: // value for 'region_id'
 *      reservation_filters: // value for 'reservation_filters'
 *      tag_ids: // value for 'tag_ids'
 *      ids: // value for 'ids'
 *      with_reservable_extras: // value for 'with_reservable_extras'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useRestaurantsListQuery(baseOptions?: Apollo.QueryHookOptions<RestaurantsListQuery, RestaurantsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RestaurantsListQuery, RestaurantsListQueryVariables>(RestaurantsListDocument, options);
      }
export function useRestaurantsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RestaurantsListQuery, RestaurantsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RestaurantsListQuery, RestaurantsListQueryVariables>(RestaurantsListDocument, options);
        }
export type RestaurantsListQueryHookResult = ReturnType<typeof useRestaurantsListQuery>;
export type RestaurantsListLazyQueryHookResult = ReturnType<typeof useRestaurantsListLazyQuery>;
export type RestaurantsListQueryResult = Apollo.QueryResult<RestaurantsListQuery, RestaurantsListQueryVariables>;
export const RestaurantsQueryDocument = gql`
    query RestaurantsQuery {
  tags {
    ...TagFragment
  }
}
    ${TagFragmentFragmentDoc}`;

/**
 * __useRestaurantsQueryQuery__
 *
 * To run a query within a React component, call `useRestaurantsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestaurantsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestaurantsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useRestaurantsQueryQuery(baseOptions?: Apollo.QueryHookOptions<RestaurantsQueryQuery, RestaurantsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RestaurantsQueryQuery, RestaurantsQueryQueryVariables>(RestaurantsQueryDocument, options);
      }
export function useRestaurantsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RestaurantsQueryQuery, RestaurantsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RestaurantsQueryQuery, RestaurantsQueryQueryVariables>(RestaurantsQueryDocument, options);
        }
export type RestaurantsQueryQueryHookResult = ReturnType<typeof useRestaurantsQueryQuery>;
export type RestaurantsQueryLazyQueryHookResult = ReturnType<typeof useRestaurantsQueryLazyQuery>;
export type RestaurantsQueryQueryResult = Apollo.QueryResult<RestaurantsQueryQuery, RestaurantsQueryQueryVariables>;
export const GetBasicRestaurantDocument = gql`
    query getBasicRestaurant($id: ID!) {
  restaurant(id: $id) {
    id
  }
}
    `;

/**
 * __useGetBasicRestaurantQuery__
 *
 * To run a query within a React component, call `useGetBasicRestaurantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicRestaurantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicRestaurantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBasicRestaurantQuery(baseOptions: Apollo.QueryHookOptions<GetBasicRestaurantQuery, GetBasicRestaurantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBasicRestaurantQuery, GetBasicRestaurantQueryVariables>(GetBasicRestaurantDocument, options);
      }
export function useGetBasicRestaurantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBasicRestaurantQuery, GetBasicRestaurantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBasicRestaurantQuery, GetBasicRestaurantQueryVariables>(GetBasicRestaurantDocument, options);
        }
export type GetBasicRestaurantQueryHookResult = ReturnType<typeof useGetBasicRestaurantQuery>;
export type GetBasicRestaurantLazyQueryHookResult = ReturnType<typeof useGetBasicRestaurantLazyQuery>;
export type GetBasicRestaurantQueryResult = Apollo.QueryResult<GetBasicRestaurantQuery, GetBasicRestaurantQueryVariables>;
export const SingleRestaurantDocument = gql`
    query SingleRestaurant($id: ID!) {
  restaurant(id: $id) {
    ...FullRestaurant
    favorited
  }
}
    ${FullRestaurantFragmentDoc}`;

/**
 * __useSingleRestaurantQuery__
 *
 * To run a query within a React component, call `useSingleRestaurantQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleRestaurantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleRestaurantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleRestaurantQuery(baseOptions: Apollo.QueryHookOptions<SingleRestaurantQuery, SingleRestaurantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleRestaurantQuery, SingleRestaurantQueryVariables>(SingleRestaurantDocument, options);
      }
export function useSingleRestaurantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleRestaurantQuery, SingleRestaurantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleRestaurantQuery, SingleRestaurantQueryVariables>(SingleRestaurantDocument, options);
        }
export type SingleRestaurantQueryHookResult = ReturnType<typeof useSingleRestaurantQuery>;
export type SingleRestaurantLazyQueryHookResult = ReturnType<typeof useSingleRestaurantLazyQuery>;
export type SingleRestaurantQueryResult = Apollo.QueryResult<SingleRestaurantQuery, SingleRestaurantQueryVariables>;
export const PrivacyPolicyDocument = gql`
    query PrivacyPolicy($type: DocumentTypeEnum) {
  documents(type: $type) {
    nodes {
      id
      title
      richText
    }
  }
}
    `;

/**
 * __usePrivacyPolicyQuery__
 *
 * To run a query within a React component, call `usePrivacyPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivacyPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivacyPolicyQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePrivacyPolicyQuery(baseOptions?: Apollo.QueryHookOptions<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>(PrivacyPolicyDocument, options);
      }
export function usePrivacyPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>(PrivacyPolicyDocument, options);
        }
export type PrivacyPolicyQueryHookResult = ReturnType<typeof usePrivacyPolicyQuery>;
export type PrivacyPolicyLazyQueryHookResult = ReturnType<typeof usePrivacyPolicyLazyQuery>;
export type PrivacyPolicyQueryResult = Apollo.QueryResult<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>;
export const RegulationDocument = gql`
    query regulation($id: ID!) {
  document(id: $id) {
    id
    title
    richText
  }
}
    `;

/**
 * __useRegulationQuery__
 *
 * To run a query within a React component, call `useRegulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegulationQuery(baseOptions: Apollo.QueryHookOptions<RegulationQuery, RegulationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulationQuery, RegulationQueryVariables>(RegulationDocument, options);
      }
export function useRegulationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulationQuery, RegulationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulationQuery, RegulationQueryVariables>(RegulationDocument, options);
        }
export type RegulationQueryHookResult = ReturnType<typeof useRegulationQuery>;
export type RegulationLazyQueryHookResult = ReturnType<typeof useRegulationLazyQuery>;
export type RegulationQueryResult = Apollo.QueryResult<RegulationQuery, RegulationQueryVariables>;
export const RegulationsDocument = gql`
    query Regulations {
  documents {
    nodes {
      id
      title
      festivalEdition {
        id
      }
    }
  }
}
    `;

/**
 * __useRegulationsQuery__
 *
 * To run a query within a React component, call `useRegulationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegulationsQuery(baseOptions?: Apollo.QueryHookOptions<RegulationsQuery, RegulationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegulationsQuery, RegulationsQueryVariables>(RegulationsDocument, options);
      }
export function useRegulationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegulationsQuery, RegulationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegulationsQuery, RegulationsQueryVariables>(RegulationsDocument, options);
        }
export type RegulationsQueryHookResult = ReturnType<typeof useRegulationsQuery>;
export type RegulationsLazyQueryHookResult = ReturnType<typeof useRegulationsLazyQuery>;
export type RegulationsQueryResult = Apollo.QueryResult<RegulationsQuery, RegulationsQueryVariables>;
export const AppleSignInDocument = gql`
    mutation appleSignIn($appleIdentityToken: String!, $firstName: String, $lastName: String, $userIdentityId: String) {
  appleSignIn(
    appleIdentityToken: $appleIdentityToken
    firstName: $firstName
    lastName: $lastName
    userIdentityId: $userIdentityId
  ) {
    authToken
    user {
      id
      firstName
      lastName
      email
    }
  }
}
    `;
export type AppleSignInMutationFn = Apollo.MutationFunction<AppleSignInMutation, AppleSignInMutationVariables>;

/**
 * __useAppleSignInMutation__
 *
 * To run a mutation, you first call `useAppleSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppleSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appleSignInMutation, { data, loading, error }] = useAppleSignInMutation({
 *   variables: {
 *      appleIdentityToken: // value for 'appleIdentityToken'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      userIdentityId: // value for 'userIdentityId'
 *   },
 * });
 */
export function useAppleSignInMutation(baseOptions?: Apollo.MutationHookOptions<AppleSignInMutation, AppleSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppleSignInMutation, AppleSignInMutationVariables>(AppleSignInDocument, options);
      }
export type AppleSignInMutationHookResult = ReturnType<typeof useAppleSignInMutation>;
export type AppleSignInMutationResult = Apollo.MutationResult<AppleSignInMutation>;
export type AppleSignInMutationOptions = Apollo.BaseMutationOptions<AppleSignInMutation, AppleSignInMutationVariables>;
export const CheckCardDocument = gql`
    query checkCard($requestId: String!) {
  checkCard(requestId: $requestId) {
    id
  }
}
    `;

/**
 * __useCheckCardQuery__
 *
 * To run a query within a React component, call `useCheckCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCardQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useCheckCardQuery(baseOptions: Apollo.QueryHookOptions<CheckCardQuery, CheckCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCardQuery, CheckCardQueryVariables>(CheckCardDocument, options);
      }
export function useCheckCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCardQuery, CheckCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCardQuery, CheckCardQueryVariables>(CheckCardDocument, options);
        }
export type CheckCardQueryHookResult = ReturnType<typeof useCheckCardQuery>;
export type CheckCardLazyQueryHookResult = ReturnType<typeof useCheckCardLazyQuery>;
export type CheckCardQueryResult = Apollo.QueryResult<CheckCardQuery, CheckCardQueryVariables>;
export const ConfirmUserDocument = gql`
    mutation confirmUser($confirmationToken: String!) {
  confirmUser(confirmationToken: $confirmationToken) {
    user {
      id
    }
  }
}
    `;
export type ConfirmUserMutationFn = Apollo.MutationFunction<ConfirmUserMutation, ConfirmUserMutationVariables>;

/**
 * __useConfirmUserMutation__
 *
 * To run a mutation, you first call `useConfirmUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmUserMutation, { data, loading, error }] = useConfirmUserMutation({
 *   variables: {
 *      confirmationToken: // value for 'confirmationToken'
 *   },
 * });
 */
export function useConfirmUserMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmUserMutation, ConfirmUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmUserMutation, ConfirmUserMutationVariables>(ConfirmUserDocument, options);
      }
export type ConfirmUserMutationHookResult = ReturnType<typeof useConfirmUserMutation>;
export type ConfirmUserMutationResult = Apollo.MutationResult<ConfirmUserMutation>;
export type ConfirmUserMutationOptions = Apollo.BaseMutationOptions<ConfirmUserMutation, ConfirmUserMutationVariables>;
export const DeleteCardDocument = gql`
    mutation deleteCard($id: ID!) {
  deleteCard(id: $id) {
    id
  }
}
    `;
export type DeleteCardMutationFn = Apollo.MutationFunction<DeleteCardMutation, DeleteCardMutationVariables>;

/**
 * __useDeleteCardMutation__
 *
 * To run a mutation, you first call `useDeleteCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCardMutation, { data, loading, error }] = useDeleteCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCardMutation, DeleteCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCardMutation, DeleteCardMutationVariables>(DeleteCardDocument, options);
      }
export type DeleteCardMutationHookResult = ReturnType<typeof useDeleteCardMutation>;
export type DeleteCardMutationResult = Apollo.MutationResult<DeleteCardMutation>;
export type DeleteCardMutationOptions = Apollo.BaseMutationOptions<DeleteCardMutation, DeleteCardMutationVariables>;
export const FacebookSignInDocument = gql`
    mutation facebookSignIn($accessToken: String!, $email: String) {
  facebookSignIn(accessToken: $accessToken, email: $email) {
    authToken
    user {
      id
      firstName
      lastName
      email
    }
  }
}
    `;
export type FacebookSignInMutationFn = Apollo.MutationFunction<FacebookSignInMutation, FacebookSignInMutationVariables>;

/**
 * __useFacebookSignInMutation__
 *
 * To run a mutation, you first call `useFacebookSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFacebookSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [facebookSignInMutation, { data, loading, error }] = useFacebookSignInMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useFacebookSignInMutation(baseOptions?: Apollo.MutationHookOptions<FacebookSignInMutation, FacebookSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FacebookSignInMutation, FacebookSignInMutationVariables>(FacebookSignInDocument, options);
      }
export type FacebookSignInMutationHookResult = ReturnType<typeof useFacebookSignInMutation>;
export type FacebookSignInMutationResult = Apollo.MutationResult<FacebookSignInMutation>;
export type FacebookSignInMutationOptions = Apollo.BaseMutationOptions<FacebookSignInMutation, FacebookSignInMutationVariables>;
export const FavoriteRestaurantsDocument = gql`
    query favoriteRestaurants {
  favoriteRestaurants {
    ...RestaurantListElement
  }
}
    ${RestaurantListElementFragmentDoc}`;

/**
 * __useFavoriteRestaurantsQuery__
 *
 * To run a query within a React component, call `useFavoriteRestaurantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteRestaurantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteRestaurantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavoriteRestaurantsQuery(baseOptions?: Apollo.QueryHookOptions<FavoriteRestaurantsQuery, FavoriteRestaurantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoriteRestaurantsQuery, FavoriteRestaurantsQueryVariables>(FavoriteRestaurantsDocument, options);
      }
export function useFavoriteRestaurantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoriteRestaurantsQuery, FavoriteRestaurantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoriteRestaurantsQuery, FavoriteRestaurantsQueryVariables>(FavoriteRestaurantsDocument, options);
        }
export type FavoriteRestaurantsQueryHookResult = ReturnType<typeof useFavoriteRestaurantsQuery>;
export type FavoriteRestaurantsLazyQueryHookResult = ReturnType<typeof useFavoriteRestaurantsLazyQuery>;
export type FavoriteRestaurantsQueryResult = Apollo.QueryResult<FavoriteRestaurantsQuery, FavoriteRestaurantsQueryVariables>;
export const GoogleSignInDocument = gql`
    mutation googleSignIn($accessToken: String!, $email: String) {
  googleSignIn(accessToken: $accessToken, email: $email) {
    authToken
    user {
      id
      firstName
      lastName
      email
    }
  }
}
    `;
export type GoogleSignInMutationFn = Apollo.MutationFunction<GoogleSignInMutation, GoogleSignInMutationVariables>;

/**
 * __useGoogleSignInMutation__
 *
 * To run a mutation, you first call `useGoogleSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleSignInMutation, { data, loading, error }] = useGoogleSignInMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGoogleSignInMutation(baseOptions?: Apollo.MutationHookOptions<GoogleSignInMutation, GoogleSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GoogleSignInMutation, GoogleSignInMutationVariables>(GoogleSignInDocument, options);
      }
export type GoogleSignInMutationHookResult = ReturnType<typeof useGoogleSignInMutation>;
export type GoogleSignInMutationResult = Apollo.MutationResult<GoogleSignInMutation>;
export type GoogleSignInMutationOptions = Apollo.BaseMutationOptions<GoogleSignInMutation, GoogleSignInMutationVariables>;
export const MyPastReservationsDocument = gql`
    query MyPastReservations($first: Int, $after: String) {
  myReservations(type: PAST, first: $first, after: $after) {
    totalCount
    nodes {
      ...ReservationListElement
    }
  }
}
    ${ReservationListElementFragmentDoc}`;

/**
 * __useMyPastReservationsQuery__
 *
 * To run a query within a React component, call `useMyPastReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPastReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPastReservationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMyPastReservationsQuery(baseOptions?: Apollo.QueryHookOptions<MyPastReservationsQuery, MyPastReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPastReservationsQuery, MyPastReservationsQueryVariables>(MyPastReservationsDocument, options);
      }
export function useMyPastReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPastReservationsQuery, MyPastReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPastReservationsQuery, MyPastReservationsQueryVariables>(MyPastReservationsDocument, options);
        }
export type MyPastReservationsQueryHookResult = ReturnType<typeof useMyPastReservationsQuery>;
export type MyPastReservationsLazyQueryHookResult = ReturnType<typeof useMyPastReservationsLazyQuery>;
export type MyPastReservationsQueryResult = Apollo.QueryResult<MyPastReservationsQuery, MyPastReservationsQueryVariables>;
export const MyReservationsDocument = gql`
    query MyReservations($type: MyReservationsTypeEnum!, $first: Int, $after: String) {
  myReservations(type: $type, first: $first, after: $after) {
    totalCount
    nodes {
      ...ReservationListElement
    }
  }
}
    ${ReservationListElementFragmentDoc}`;

/**
 * __useMyReservationsQuery__
 *
 * To run a query within a React component, call `useMyReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyReservationsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMyReservationsQuery(baseOptions: Apollo.QueryHookOptions<MyReservationsQuery, MyReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyReservationsQuery, MyReservationsQueryVariables>(MyReservationsDocument, options);
      }
export function useMyReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyReservationsQuery, MyReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyReservationsQuery, MyReservationsQueryVariables>(MyReservationsDocument, options);
        }
export type MyReservationsQueryHookResult = ReturnType<typeof useMyReservationsQuery>;
export type MyReservationsLazyQueryHookResult = ReturnType<typeof useMyReservationsLazyQuery>;
export type MyReservationsQueryResult = Apollo.QueryResult<MyReservationsQuery, MyReservationsQueryVariables>;
export const NewsletterSignUpDocument = gql`
    mutation NewsletterSignUp($email: String!) {
  newsletterSignUp(email: $email) {
    salesmanagoContactId
  }
}
    `;
export type NewsletterSignUpMutationFn = Apollo.MutationFunction<NewsletterSignUpMutation, NewsletterSignUpMutationVariables>;

/**
 * __useNewsletterSignUpMutation__
 *
 * To run a mutation, you first call `useNewsletterSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewsletterSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newsletterSignUpMutation, { data, loading, error }] = useNewsletterSignUpMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useNewsletterSignUpMutation(baseOptions?: Apollo.MutationHookOptions<NewsletterSignUpMutation, NewsletterSignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewsletterSignUpMutation, NewsletterSignUpMutationVariables>(NewsletterSignUpDocument, options);
      }
export type NewsletterSignUpMutationHookResult = ReturnType<typeof useNewsletterSignUpMutation>;
export type NewsletterSignUpMutationResult = Apollo.MutationResult<NewsletterSignUpMutation>;
export type NewsletterSignUpMutationOptions = Apollo.BaseMutationOptions<NewsletterSignUpMutation, NewsletterSignUpMutationVariables>;
export const SetDefaultCardDocument = gql`
    mutation SetDefaultCard($id: ID!) {
  setDefaultCard(id: $id) {
    id
  }
}
    `;
export type SetDefaultCardMutationFn = Apollo.MutationFunction<SetDefaultCardMutation, SetDefaultCardMutationVariables>;

/**
 * __useSetDefaultCardMutation__
 *
 * To run a mutation, you first call `useSetDefaultCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultCardMutation, { data, loading, error }] = useSetDefaultCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDefaultCardMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultCardMutation, SetDefaultCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultCardMutation, SetDefaultCardMutationVariables>(SetDefaultCardDocument, options);
      }
export type SetDefaultCardMutationHookResult = ReturnType<typeof useSetDefaultCardMutation>;
export type SetDefaultCardMutationResult = Apollo.MutationResult<SetDefaultCardMutation>;
export type SetDefaultCardMutationOptions = Apollo.BaseMutationOptions<SetDefaultCardMutation, SetDefaultCardMutationVariables>;
export const UserCardsDocument = gql`
    query UserCards {
  user {
    cards {
      ...CardImage
    }
  }
}
    ${CardImageFragmentDoc}`;

/**
 * __useUserCardsQuery__
 *
 * To run a query within a React component, call `useUserCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCardsQuery(baseOptions?: Apollo.QueryHookOptions<UserCardsQuery, UserCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCardsQuery, UserCardsQueryVariables>(UserCardsDocument, options);
      }
export function useUserCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCardsQuery, UserCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCardsQuery, UserCardsQueryVariables>(UserCardsDocument, options);
        }
export type UserCardsQueryHookResult = ReturnType<typeof useUserCardsQuery>;
export type UserCardsLazyQueryHookResult = ReturnType<typeof useUserCardsLazyQuery>;
export type UserCardsQueryResult = Apollo.QueryResult<UserCardsQuery, UserCardsQueryVariables>;
export const UserDataDocument = gql`
    query UserData {
  user {
    id
    anonymous
    firstName
    lastName
    email
    phoneNumber
    verified
    subscribed
    hasMarketingConsent
    hasPernodConsent
    salesmanagoContactId
    regulationStatus
  }
}
    `;

/**
 * __useUserDataQuery__
 *
 * To run a query within a React component, call `useUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDataQuery(baseOptions?: Apollo.QueryHookOptions<UserDataQuery, UserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDataQuery, UserDataQueryVariables>(UserDataDocument, options);
      }
export function useUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDataQuery, UserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDataQuery, UserDataQueryVariables>(UserDataDocument, options);
        }
export type UserDataQueryHookResult = ReturnType<typeof useUserDataQuery>;
export type UserDataLazyQueryHookResult = ReturnType<typeof useUserDataLazyQuery>;
export type UserDataQueryResult = Apollo.QueryResult<UserDataQuery, UserDataQueryVariables>;
export const AllTagsDocument = gql`
    query AllTags($festivalEditionId: ID, $regionId: ID) {
  tags(festivalEditionId: $festivalEditionId, regionId: $regionId) {
    id
    name
    tagCount
    position
    type
  }
}
    `;

/**
 * __useAllTagsQuery__
 *
 * To run a query within a React component, call `useAllTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTagsQuery({
 *   variables: {
 *      festivalEditionId: // value for 'festivalEditionId'
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useAllTagsQuery(baseOptions?: Apollo.QueryHookOptions<AllTagsQuery, AllTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTagsQuery, AllTagsQueryVariables>(AllTagsDocument, options);
      }
export function useAllTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTagsQuery, AllTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTagsQuery, AllTagsQueryVariables>(AllTagsDocument, options);
        }
export type AllTagsQueryHookResult = ReturnType<typeof useAllTagsQuery>;
export type AllTagsLazyQueryHookResult = ReturnType<typeof useAllTagsLazyQuery>;
export type AllTagsQueryResult = Apollo.QueryResult<AllTagsQuery, AllTagsQueryVariables>;
export const ClientConfigDocument = gql`
    query ClientConfig {
  clientConfigs {
    d2dDefaultReservableFrom
    reservableExtraDefaultReservableFrom
  }
}
    `;

/**
 * __useClientConfigQuery__
 *
 * To run a query within a React component, call `useClientConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientConfigQuery(baseOptions?: Apollo.QueryHookOptions<ClientConfigQuery, ClientConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientConfigQuery, ClientConfigQueryVariables>(ClientConfigDocument, options);
      }
export function useClientConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientConfigQuery, ClientConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientConfigQuery, ClientConfigQueryVariables>(ClientConfigDocument, options);
        }
export type ClientConfigQueryHookResult = ReturnType<typeof useClientConfigQuery>;
export type ClientConfigLazyQueryHookResult = ReturnType<typeof useClientConfigLazyQuery>;
export type ClientConfigQueryResult = Apollo.QueryResult<ClientConfigQuery, ClientConfigQueryVariables>;
export const FirstUpcomingReservationDocument = gql`
    query FirstUpcomingReservation {
  myReservations(first: 1, type: UPCOMING) {
    totalCount
    edges {
      node {
        ...ReservationModal
      }
    }
  }
}
    ${ReservationModalFragmentDoc}`;

/**
 * __useFirstUpcomingReservationQuery__
 *
 * To run a query within a React component, call `useFirstUpcomingReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirstUpcomingReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirstUpcomingReservationQuery({
 *   variables: {
 *   },
 * });
 */
export function useFirstUpcomingReservationQuery(baseOptions?: Apollo.QueryHookOptions<FirstUpcomingReservationQuery, FirstUpcomingReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirstUpcomingReservationQuery, FirstUpcomingReservationQueryVariables>(FirstUpcomingReservationDocument, options);
      }
export function useFirstUpcomingReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirstUpcomingReservationQuery, FirstUpcomingReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirstUpcomingReservationQuery, FirstUpcomingReservationQueryVariables>(FirstUpcomingReservationDocument, options);
        }
export type FirstUpcomingReservationQueryHookResult = ReturnType<typeof useFirstUpcomingReservationQuery>;
export type FirstUpcomingReservationLazyQueryHookResult = ReturnType<typeof useFirstUpcomingReservationLazyQuery>;
export type FirstUpcomingReservationQueryResult = Apollo.QueryResult<FirstUpcomingReservationQuery, FirstUpcomingReservationQueryVariables>;
export const LastVisitedRestaurantsDocument = gql`
    query LastVisitedRestaurants($ids: [ID]) {
  restaurants(ids: $ids) {
    nodes {
      ...SmartSearchRestaurant
    }
  }
}
    ${SmartSearchRestaurantFragmentDoc}`;

/**
 * __useLastVisitedRestaurantsQuery__
 *
 * To run a query within a React component, call `useLastVisitedRestaurantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastVisitedRestaurantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastVisitedRestaurantsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLastVisitedRestaurantsQuery(baseOptions?: Apollo.QueryHookOptions<LastVisitedRestaurantsQuery, LastVisitedRestaurantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastVisitedRestaurantsQuery, LastVisitedRestaurantsQueryVariables>(LastVisitedRestaurantsDocument, options);
      }
export function useLastVisitedRestaurantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastVisitedRestaurantsQuery, LastVisitedRestaurantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastVisitedRestaurantsQuery, LastVisitedRestaurantsQueryVariables>(LastVisitedRestaurantsDocument, options);
        }
export type LastVisitedRestaurantsQueryHookResult = ReturnType<typeof useLastVisitedRestaurantsQuery>;
export type LastVisitedRestaurantsLazyQueryHookResult = ReturnType<typeof useLastVisitedRestaurantsLazyQuery>;
export type LastVisitedRestaurantsQueryResult = Apollo.QueryResult<LastVisitedRestaurantsQuery, LastVisitedRestaurantsQueryVariables>;
export const PopularTagsDocument = gql`
    query PopularTags($region_id: ID!) {
  popularTags(region_id: $region_id) {
    ...TagFragment
  }
}
    ${TagFragmentFragmentDoc}`;

/**
 * __usePopularTagsQuery__
 *
 * To run a query within a React component, call `usePopularTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularTagsQuery({
 *   variables: {
 *      region_id: // value for 'region_id'
 *   },
 * });
 */
export function usePopularTagsQuery(baseOptions: Apollo.QueryHookOptions<PopularTagsQuery, PopularTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopularTagsQuery, PopularTagsQueryVariables>(PopularTagsDocument, options);
      }
export function usePopularTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopularTagsQuery, PopularTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopularTagsQuery, PopularTagsQueryVariables>(PopularTagsDocument, options);
        }
export type PopularTagsQueryHookResult = ReturnType<typeof usePopularTagsQuery>;
export type PopularTagsLazyQueryHookResult = ReturnType<typeof usePopularTagsLazyQuery>;
export type PopularTagsQueryResult = Apollo.QueryResult<PopularTagsQuery, PopularTagsQueryVariables>;
export const RegionsDocument = gql`
    query regions {
  regions(visible: true) {
    latitude
    longitude
    id
    name
    hidden
    currentTenant
    eventsEnabled
  }
}
    `;

/**
 * __useRegionsQuery__
 *
 * To run a query within a React component, call `useRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegionsQuery(baseOptions?: Apollo.QueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
      }
export function useRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsQuery, RegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, options);
        }
export type RegionsQueryHookResult = ReturnType<typeof useRegionsQuery>;
export type RegionsLazyQueryHookResult = ReturnType<typeof useRegionsLazyQuery>;
export type RegionsQueryResult = Apollo.QueryResult<RegionsQuery, RegionsQueryVariables>;
export const ResolveRestaurantCodeDocument = gql`
    query ResolveRestaurantCode($code: ID!) {
  decodeRestaurant(code: $code) {
    id
    sourceId
  }
}
    `;

/**
 * __useResolveRestaurantCodeQuery__
 *
 * To run a query within a React component, call `useResolveRestaurantCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveRestaurantCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveRestaurantCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useResolveRestaurantCodeQuery(baseOptions: Apollo.QueryHookOptions<ResolveRestaurantCodeQuery, ResolveRestaurantCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveRestaurantCodeQuery, ResolveRestaurantCodeQueryVariables>(ResolveRestaurantCodeDocument, options);
      }
export function useResolveRestaurantCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveRestaurantCodeQuery, ResolveRestaurantCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveRestaurantCodeQuery, ResolveRestaurantCodeQueryVariables>(ResolveRestaurantCodeDocument, options);
        }
export type ResolveRestaurantCodeQueryHookResult = ReturnType<typeof useResolveRestaurantCodeQuery>;
export type ResolveRestaurantCodeLazyQueryHookResult = ReturnType<typeof useResolveRestaurantCodeLazyQuery>;
export type ResolveRestaurantCodeQueryResult = Apollo.QueryResult<ResolveRestaurantCodeQuery, ResolveRestaurantCodeQueryVariables>;
export const ResolveUrlSlugDocument = gql`
    query resolveUrlSlug($slug: String!) {
  resolveUrlSlug(slug: $slug) {
    objectId
    objectType
  }
}
    `;

/**
 * __useResolveUrlSlugQuery__
 *
 * To run a query within a React component, call `useResolveUrlSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveUrlSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveUrlSlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useResolveUrlSlugQuery(baseOptions: Apollo.QueryHookOptions<ResolveUrlSlugQuery, ResolveUrlSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveUrlSlugQuery, ResolveUrlSlugQueryVariables>(ResolveUrlSlugDocument, options);
      }
export function useResolveUrlSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveUrlSlugQuery, ResolveUrlSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveUrlSlugQuery, ResolveUrlSlugQueryVariables>(ResolveUrlSlugDocument, options);
        }
export type ResolveUrlSlugQueryHookResult = ReturnType<typeof useResolveUrlSlugQuery>;
export type ResolveUrlSlugLazyQueryHookResult = ReturnType<typeof useResolveUrlSlugLazyQuery>;
export type ResolveUrlSlugQueryResult = Apollo.QueryResult<ResolveUrlSlugQuery, ResolveUrlSlugQueryVariables>;
export const SearchDocument = gql`
    query search($text: String!, $regionId: ID) {
  search(text: $text, regionId: $regionId) {
    ... on Tag {
      ...TagFragment
    }
    ... on Restaurant {
      ...SmartSearchRestaurant
    }
  }
}
    ${TagFragmentFragmentDoc}
${SmartSearchRestaurantFragmentDoc}`;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      text: // value for 'text'
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const SelectedRegionDocument = gql`
    query SelectedRegion {
  selectedRegion @client {
    id
    name
    isProposed
  }
}
    `;

/**
 * __useSelectedRegionQuery__
 *
 * To run a query within a React component, call `useSelectedRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedRegionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectedRegionQuery(baseOptions?: Apollo.QueryHookOptions<SelectedRegionQuery, SelectedRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectedRegionQuery, SelectedRegionQueryVariables>(SelectedRegionDocument, options);
      }
export function useSelectedRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedRegionQuery, SelectedRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectedRegionQuery, SelectedRegionQueryVariables>(SelectedRegionDocument, options);
        }
export type SelectedRegionQueryHookResult = ReturnType<typeof useSelectedRegionQuery>;
export type SelectedRegionLazyQueryHookResult = ReturnType<typeof useSelectedRegionLazyQuery>;
export type SelectedRegionQueryResult = Apollo.QueryResult<SelectedRegionQuery, SelectedRegionQueryVariables>;
export const TagsListDocument = gql`
    query TagsList {
  regions(visible: true) {
    id
    name
  }
  tags {
    ...TagFragment
  }
}
    ${TagFragmentFragmentDoc}`;

/**
 * __useTagsListQuery__
 *
 * To run a query within a React component, call `useTagsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsListQuery(baseOptions?: Apollo.QueryHookOptions<TagsListQuery, TagsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsListQuery, TagsListQueryVariables>(TagsListDocument, options);
      }
export function useTagsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsListQuery, TagsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsListQuery, TagsListQueryVariables>(TagsListDocument, options);
        }
export type TagsListQueryHookResult = ReturnType<typeof useTagsListQuery>;
export type TagsListLazyQueryHookResult = ReturnType<typeof useTagsListLazyQuery>;
export type TagsListQueryResult = Apollo.QueryResult<TagsListQuery, TagsListQueryVariables>;